var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCarSpeed = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 833 574",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__CarSpeed",
  clipPath: "url(#CarSpeed_svg__clip0_13_9884)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 832.947,
  height: 574,
  fill: "white"
}), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_3"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M514.001 335.349L507.253 364.871C506.294 369.068 502.316 371.183 498.374 369.59L446.209 348.514C442.267 346.921 439.847 342.222 440.806 338.025L445.195 307.55C449.21 303.61 452.491 302.191 456.433 303.784L508.598 324.86C512.54 326.453 514.961 331.152 514.001 335.349Z",
  fill: "white",
  stroke: "#141941",
  strokeWidth: 0.483168,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_4"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_2",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M509.03 337.144L502.894 363.988C502.022 367.805 498.402 369.727 494.818 368.279L442.293 347.057C438.713 345.611 436.51 341.336 437.382 337.52L443.518 310.675C444.39 306.859 448.01 304.937 451.59 306.383L504.115 327.605C507.699 329.053 509.902 333.327 509.03 337.144Z",
  fill: "white",
  stroke: "#141941",
  strokeWidth: 0.483061,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_5"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_3",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M498.696 372.913L488.065 377.244C484.014 378.894 478.433 379.306 475.604 378.163L416.158 354.145C413.334 353.004 414.599 347.684 414.574 343.669L429.01 344.758C433.061 343.108 438.644 342.694 441.469 343.835L502.503 360.968C502.51 365.343 502.747 371.263 498.696 372.913Z",
  fill: "white",
  stroke: "#141941",
  strokeWidth: 0.768496,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_6"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_4",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M498.681 364.474L488.05 368.804C483.999 370.454 478.418 370.866 475.589 369.723L416.143 345.706C413.319 344.565 414.313 342.299 418.364 340.649L428.995 336.318C433.046 334.668 438.63 334.255 441.454 335.396L500.9 359.414C503.729 360.557 502.732 362.823 498.681 364.474Z",
  fill: "white",
  stroke: "#141941",
  strokeWidth: 0.768496,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_7"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_5",
  d: "M436.96 351.931L457.169 343.699",
  stroke: "#141941",
  strokeWidth: 0.520727,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_8"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_6",
  d: "M461.542 340.662L468.608 317.5",
  stroke: "#141941",
  strokeWidth: 0.520727,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_9"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_7",
  d: "M454.901 359.505L475.11 351.273",
  stroke: "#141941",
  strokeWidth: 0.520727,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_10"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_8",
  d: "M479.502 348.239L486.568 325.076",
  stroke: "#141941",
  strokeWidth: 0.520727,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_11"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_9",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M405.252 573.784L823.912 407.022L824.129 159.876L425.516 0.208567L4.78846 168.083L4.78993 413.272L405.252 573.784Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 1.30614,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_12"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_10",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.3503 408.376L425.549 244.288L425.547 7.31387L10.6915 172.701L11.3503 408.376Z",
  stroke: "#8496B9",
  strokeWidth: 0.818117,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_13"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_11",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M816.908 401.708L816.91 165.44L425.528 7.31184L425.529 244.334L816.908 401.708Z",
  stroke: "#8496B9",
  strokeWidth: 0.818117,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_14"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_12",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M816.91 401.708L404.276 565.028L11.3306 408.374L425.53 244.333L816.91 401.708Z",
  stroke: "#8496B9",
  strokeWidth: 0.818117,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Right-1"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_15"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_16"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_13",
  d: "M457.486 234.722L433.964 225.219V242.076L457.486 251.58V234.722Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_17"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_14",
  d: "M435.456 256.43L411.934 246.927V250.089L435.456 259.593V256.43Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_18"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_15",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M435.471 256.436L457.496 234.727L433.992 225.231L411.934 246.927L435.471 256.436Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_19"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_16",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M435.47 256.436V259.599L457.495 251.584V234.727L435.47 256.436Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_20"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_21"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_17",
  d: "M481.008 244.225L457.486 234.722V251.58L481.008 261.083V244.225Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_22"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_18",
  d: "M448.677 254.932L445.751 253.75V270.607L448.677 271.789V254.932Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.396271,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_23"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_19",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M448.703 254.935L481.017 244.23L457.513 234.734L445.777 253.752L448.703 254.935Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_24"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_20",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M448.704 254.935V271.792L481.018 261.088V244.23L448.704 254.935Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_25"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_26"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_21",
  d: "M504.528 253.728L481.006 244.225V261.082L504.528 270.586V253.728Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_27"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_22",
  d: "M482.499 275.436L458.978 265.932V269.095L482.499 278.598V275.436Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_28"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_23",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M482.514 275.442L504.539 253.733L481.035 244.237L458.978 265.933L482.514 275.442Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_29"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_24",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M482.514 275.442V278.605L504.539 270.59V253.733L482.514 275.442Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_30"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_31"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_25",
  d: "M457.486 217.754L433.964 208.25V225.108L457.486 234.611V217.754Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_32"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_26",
  d: "M425.156 228.46L422.23 227.278V244.136L425.156 245.318V228.46Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.396271,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_33"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_27",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M425.181 228.463L457.495 217.758L433.991 208.262L422.255 227.281L425.181 228.463Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_34"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_28",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M425.182 228.463V245.321L457.495 234.616V217.758L425.182 228.463Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_35"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_36"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_29",
  d: "M481.008 227.257L457.486 217.753V234.611L481.008 244.114V227.257Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_37"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_30",
  d: "M458.977 248.964L435.456 239.461V242.623L458.977 252.127V248.964Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_38"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_31",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M458.992 248.97L481.017 227.261L457.513 217.765L435.456 239.461L458.992 248.97Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_39"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_32",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M458.992 248.97V252.133L481.017 244.119V227.261L458.992 248.97Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_40"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_41"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_33",
  d: "M504.528 236.762L481.006 227.258V244.116L504.528 253.619V236.762Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_42"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_34",
  d: "M472.198 247.469L469.272 246.286V263.144L472.198 264.326V247.469Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.396271,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_43"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_35",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M472.225 247.471L504.538 236.766L481.034 227.27L469.299 246.289L472.225 247.471Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_44"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_36",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M472.225 247.471V264.328L504.538 253.624V236.766L472.225 247.471Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_45"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_46"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_37",
  d: "M457.486 200.197L433.964 190.693V207.551L457.486 217.054V200.197Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_47"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_38",
  d: "M435.456 221.904L411.934 212.401V215.563L435.456 225.067V221.904Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_48"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_39",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M435.471 221.91L457.496 200.201L433.992 190.705L411.934 212.401L435.471 221.91Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_49"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_40",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M435.47 221.91V225.073L457.495 217.059V200.201L435.47 221.91Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_50"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_51"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_41",
  d: "M481.008 209.7L457.486 200.196V217.054L481.008 226.557V209.7Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_52"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_42",
  d: "M448.677 220.406L445.751 219.224V236.082L448.677 237.264V220.406Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.396271,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_53"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_43",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M448.703 220.409L481.017 209.704L457.513 200.208L445.777 219.227L448.703 220.409Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_54"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_44",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M448.704 220.409V237.266L481.018 226.562V209.704L448.704 220.409Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_55"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_56"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_45",
  d: "M504.528 219.203L481.006 209.699V226.557L504.528 236.06V219.203Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_57"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_46",
  d: "M482.499 240.91L458.978 231.407V234.569L482.499 244.073V240.91Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_58"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_47",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M482.514 240.916L504.539 219.207L481.035 209.711L458.978 231.407L482.514 240.916Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_59"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_48",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M482.514 240.916V244.079L504.539 236.065V219.207L482.514 240.916Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_60"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_61"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_49",
  d: "M457.486 183.228L433.964 173.724V190.582L457.486 200.085V183.228Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_62"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_50",
  d: "M425.156 193.934L422.23 192.752V209.61L425.156 210.792V193.934Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.396271,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_63"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_51",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M425.181 193.937L457.495 183.232L433.991 173.736L422.255 192.755L425.181 193.937Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_64"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_52",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M425.182 193.937V210.794L457.495 200.09V183.232L425.182 193.937Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_65"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_66"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_53",
  d: "M481.008 192.733L457.486 183.229V200.087L481.008 209.59V192.733Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_67"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_54",
  d: "M458.977 214.44L435.456 204.937V208.1L458.977 217.603V214.44Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_68"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_55",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M458.992 214.447L481.017 192.738L457.513 183.242L435.456 204.937L458.992 214.447Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_69"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_56",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M458.992 214.447V217.609L481.017 209.595V192.737L458.992 214.447Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_70"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_71"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_57",
  d: "M504.528 202.236L481.006 192.733V209.59L504.528 219.093V202.236Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_72"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_58",
  d: "M472.198 212.942L469.272 211.76V228.618L472.198 229.8V212.942Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.396271,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_73"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_59",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M472.225 212.945L504.538 202.24L481.034 192.744L469.299 211.763L472.225 212.945Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_74"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_60",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M472.225 212.945V229.803L504.538 219.098V202.241L472.225 212.945Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_75"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_76"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_61",
  d: "M457.486 165.671L433.964 156.167V173.025L457.486 182.528V165.671Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_77"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_62",
  d: "M435.456 187.379L411.934 177.875V181.038L435.456 190.541V187.379Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_78"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_63",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M435.471 187.385L457.496 165.676L433.992 156.179L411.934 177.875L435.471 187.385Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_79"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_64",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M435.47 187.385V190.547L457.495 182.533V165.675L435.47 187.385Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_80"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_81"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_65",
  d: "M481.008 175.174L457.486 165.671V182.528L481.008 192.031V175.174Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_82"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_66",
  d: "M448.677 185.881L445.751 184.698V201.556L448.677 202.738V185.881Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.396271,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_83"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_67",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M448.703 185.883L481.017 175.179L457.513 165.683L445.777 184.701L448.703 185.883Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_84"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_68",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M448.704 185.883V202.741L481.018 192.036V175.179L448.704 185.883Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_85"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_86"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_69",
  d: "M504.528 184.677L481.006 175.173V192.031L504.528 201.534V184.677Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_87"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_70",
  d: "M482.499 206.384L458.978 196.881V200.044L482.499 209.547V206.384Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_88"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_71",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M482.514 206.39L504.539 184.681L481.035 175.185L458.978 196.881L482.514 206.39Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_89"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_72",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M482.514 206.39V209.553L504.539 201.539V184.681L482.514 206.39Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_90"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_91"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_73",
  d: "M457.486 148.704L433.964 139.201V156.058L457.486 165.562V148.704Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_92"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_74",
  d: "M425.156 159.411L422.23 158.229V175.086L425.156 176.268V159.411Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.396271,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_93"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_75",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M425.181 159.413L457.495 148.709L433.991 139.213L422.255 158.231L425.181 159.413Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_94"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_76",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M425.182 159.413V176.271L457.495 165.566V148.709L425.182 159.413Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_95"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_96"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_77",
  d: "M481.008 158.207L457.486 148.704V165.561L481.008 175.065V158.207Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_97"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_78",
  d: "M458.977 179.915L435.456 170.411V173.574L458.977 183.077V179.915Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_98"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_79",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M458.992 179.921L481.017 158.212L457.513 148.716L435.456 170.412L458.992 179.921Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_99"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_80",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M458.992 179.921V183.083L481.017 175.069V158.212L458.992 179.921Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_100"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_101"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_81",
  d: "M504.528 167.71L481.006 158.207V175.064L504.528 184.568V167.71Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_102"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_82",
  d: "M472.198 178.417L469.272 177.235V194.092L472.198 195.274V178.417Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.396271,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_103"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_83",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M472.225 178.419L504.538 167.715L481.034 158.219L469.299 177.237L472.225 178.419Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_104"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_84",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M472.225 178.419V195.277L504.538 184.572V167.715L472.225 178.419Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_105"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_106"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_107"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_85",
  d: "M457.486 131.146L433.964 121.643V138.5L457.486 148.003V131.146Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_108"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_86",
  d: "M435.456 152.854L411.934 143.35V146.513L435.456 156.016V152.854Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_109"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_87",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M435.471 152.86L457.496 131.151L433.992 121.655L411.934 143.35L435.471 152.86Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_110"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_88",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M435.471 152.86V156.022L457.495 148.008V131.151L435.471 152.86Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_111"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_112"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_89",
  d: "M481.008 140.649L457.486 131.146V148.003L481.008 157.507V140.649Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_113"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_90",
  d: "M448.677 151.356L445.751 150.174V167.031L448.677 168.213V151.356Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.396271,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_114"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_91",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M448.703 151.358L481.017 140.654L457.513 131.157L445.777 150.176L448.703 151.358Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_115"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_92",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M448.705 151.358V168.216L481.018 157.511V140.654L448.705 151.358Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_116"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_117"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_93",
  d: "M504.529 150.152L481.007 140.649V157.506L504.529 167.009V150.152Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_118"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_94",
  d: "M482.499 171.86L458.978 162.356V165.519L482.499 175.022V171.86Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_119"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_95",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M482.514 171.866L504.539 150.157L481.035 140.66L458.978 162.356L482.514 171.866Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_120"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_96",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M482.514 171.866V175.028L504.539 167.014V150.157L482.514 171.866Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_121"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_122"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_97",
  d: "M457.486 114.177L433.964 104.674V121.532L457.486 131.035V114.177Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_123"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_98",
  d: "M425.156 124.884L422.23 123.702V140.559L425.156 141.741V124.884Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.396271,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_124"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_99",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M425.182 124.886L457.496 114.182L433.992 104.686L422.256 123.704L425.182 124.886Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_125"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_100",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M425.183 124.887V141.744L457.497 131.039V114.182L425.183 124.887Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_126"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_127"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_101",
  d: "M481.008 123.683L457.486 114.179V131.037L481.008 140.54V123.683Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_128"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_102",
  d: "M458.977 145.39L435.456 135.887V139.049L458.977 148.553V145.39Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_129"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_103",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M458.992 145.396L481.017 123.687L457.513 114.191L435.456 135.887L458.992 145.396Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_130"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_104",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M458.992 145.396V148.559L481.017 140.545V123.687L458.992 145.396Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_131"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_132"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_105",
  d: "M504.53 133.185L481.008 123.682V140.539L504.53 150.043V133.185Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_133"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_106",
  d: "M472.199 143.892L469.273 142.71V159.567L472.199 160.749V143.892Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.396271,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_134"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_107",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M472.226 143.895L504.539 133.19L481.035 123.694L469.3 142.712L472.226 143.895Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_135"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_108",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M472.226 143.895V160.752L504.54 150.048V133.19L472.226 143.895Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_136"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_137"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_109",
  d: "M457.486 96.7869L433.964 87.2834V104.141L457.486 113.644V96.7869Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_138"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_110",
  d: "M435.456 118.495L411.934 108.991V112.154L435.456 121.657V118.495Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_139"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_111",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M435.471 118.501L457.496 96.7916L433.992 87.2954L411.934 108.991L435.471 118.501Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_140"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_112",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M435.47 118.501V121.663L457.495 113.649V96.7914L435.47 118.501Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_141"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_142"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_113",
  d: "M481.008 106.292L457.486 96.7883V113.646L481.008 123.149V106.292Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_143"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_114",
  d: "M448.677 116.998L445.751 115.816V132.674L448.677 133.856V116.998Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.396271,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_144"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_115",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M448.703 117.001L481.017 106.297L457.513 96.8004L445.777 115.819L448.703 117.001Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_145"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_116",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M448.704 117.001V133.859L481.018 123.154V106.297L448.704 117.001Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_146"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_147"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_117",
  d: "M504.528 115.795L481.006 106.292V123.149L504.528 132.652V115.795Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_148"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_118",
  d: "M482.499 137.503L458.978 127.999V131.162L482.499 140.665V137.503Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_149"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_119",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M482.514 137.509L504.539 115.799L481.035 106.303L458.978 127.999L482.514 137.509Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_150"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_120",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M482.514 137.509V140.671L504.539 132.657V115.799L482.514 137.509Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_151"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_152"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_121",
  d: "M457.486 79.8199L433.964 70.3165V87.174L457.486 96.6774V79.8199Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_153"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_122",
  d: "M425.156 90.5265L422.23 89.3445V106.202L425.156 107.384V90.5265Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.396271,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_154"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_123",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M425.181 90.5293L457.495 79.8248L433.991 70.3286L422.255 89.3472L425.181 90.5293Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_155"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_124",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M425.182 90.5293V107.387L457.495 96.6823V79.8248L425.182 90.5293Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_156"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_157"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_125",
  d: "M481.008 89.3231L457.486 79.8197V96.6772L481.008 106.181V89.3231Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_158"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_126",
  d: "M458.977 111.031L435.456 101.527V104.69L458.977 114.193V111.031Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_159"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_127",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M458.992 111.037L481.017 89.3278L457.513 79.8317L435.456 101.527L458.992 111.037Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_160"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_128",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M458.992 111.037V114.199L481.017 106.185V89.3278L458.992 111.037Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_161"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_162"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_129",
  d: "M504.528 98.8259L481.006 89.3225V106.18L504.528 115.683V98.8259Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_163"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_130",
  d: "M472.198 109.533L469.272 108.351V125.208L472.198 126.39V109.533Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.396271,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_164"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_131",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M472.225 109.535L504.538 98.8306L481.034 89.3345L469.299 108.353L472.225 109.535Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_165"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_132",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M472.225 109.535V126.393L504.538 115.688V98.8308L472.225 109.535Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_166"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_167"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_133",
  d: "M457.486 62.4285L433.964 52.925V69.7825L457.486 79.286V62.4285Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_168"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_134",
  d: "M435.456 84.1362L411.934 74.6328V77.7954L435.456 87.2988V84.1362Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_169"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_135",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M435.471 84.1423L457.496 62.4332L433.992 52.937L411.934 74.6328L435.471 84.1423Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_170"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_136",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M435.47 84.1423V87.3047L457.495 79.2906V62.4332L435.47 84.1423Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_171"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_172"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_137",
  d: "M481.008 71.9336L457.486 62.4302V79.2877L481.008 88.7911V71.9336Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_173"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_138",
  d: "M448.677 82.6401L445.751 81.458V98.3155L448.677 99.4976V82.6401Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.396271,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_174"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_139",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M448.703 82.6426L481.017 71.9381L457.513 62.4419L445.777 81.4605L448.703 82.6426Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_175"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_140",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M448.704 82.6429V99.5005L481.018 88.7958V71.9383L448.704 82.6429Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_176"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_177"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_141",
  d: "M504.528 81.4364L481.006 71.933V88.7905L504.528 98.2939V81.4364Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_178"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_142",
  d: "M482.499 103.144L458.978 93.6407V96.8033L482.499 106.307V103.144Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_179"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_143",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M482.514 103.15L504.539 81.4411L481.035 71.9449L458.978 93.6407L482.514 103.15Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_180"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_144",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M482.514 103.15V106.313L504.539 98.2984V81.441L482.514 103.15Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_181"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_182"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_145",
  d: "M457.486 45.4618L433.964 35.9584V52.8159L457.486 62.3193V45.4618Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_183"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_146",
  d: "M425.156 56.1683L422.23 54.9862V71.8437L425.156 73.0258V56.1683Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.396271,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_184"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_147",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M425.181 56.171L457.495 45.4665L433.991 35.9703L422.255 54.9889L425.181 56.171Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_185"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_148",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M425.182 56.1709V73.0286L457.495 62.3239V45.4664L425.182 56.1709Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_186"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_187"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_149",
  d: "M481.008 54.9648L457.486 45.4614V62.3189L481.008 71.8223V54.9648Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_188"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_150",
  d: "M458.977 76.6726L435.456 67.1692V70.3317L458.977 79.8352V76.6726Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_189"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_151",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M458.992 76.6787L481.017 54.9695L457.513 45.4734L435.456 67.1692L458.992 76.6787Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_190"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_152",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M458.992 76.6786V79.841L481.017 71.8269V54.9694L458.992 76.6786Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_191"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_192"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_153",
  d: "M504.528 64.4677L481.006 54.9642V71.8217L504.528 81.3251V64.4677Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_193"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_154",
  d: "M472.198 75.1744L469.272 73.9923V90.8498L472.198 92.0319V75.1744Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.396271,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_194"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_155",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M472.225 75.177L504.538 64.4725L481.034 54.9763L469.299 73.9949L472.225 75.177Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_195"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_156",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M472.225 75.1769V92.0346L504.538 81.3299V64.4724L472.225 75.1769Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_196"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_197"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_157",
  d: "M457.486 27.5765L433.964 18.0731V34.9306L457.486 44.434V27.5765Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_198"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_158",
  d: "M435.456 49.2842L411.934 39.7808V42.9433L435.456 52.4467V49.2842Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_199"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_159",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M435.471 49.2903L457.496 27.5811L433.992 18.085L411.934 39.7808L435.471 49.2903Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_200"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_160",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M435.47 49.2902V52.4525L457.495 44.4385V27.581L435.47 49.2902Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_201"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_202"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_161",
  d: "M481.008 37.0817L457.486 27.5782V44.4357L481.008 53.9392V37.0817Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_203"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_162",
  d: "M448.677 47.7881L445.751 46.6061V63.4636L448.677 64.6456V47.7881Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.396271,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_204"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_163",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M448.703 47.7906L481.017 37.0861L457.513 27.59L445.777 46.6086L448.703 47.7906Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_205"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_164",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M448.704 47.7907V64.6483L481.018 53.9436V37.0862L448.704 47.7907Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_206"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_207"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_165",
  d: "M504.528 46.5846L481.006 37.0812V53.9387L504.528 63.4421V46.5846Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_208"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_166",
  d: "M482.499 68.292L458.978 58.7886V61.9511L482.499 71.4546V68.292Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_209"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_167",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M482.514 68.2983L504.539 46.5892L481.035 37.093L458.978 58.7888L482.514 68.2983Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_210"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_168",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M482.514 68.298V71.4603L504.539 63.4463V46.5888L482.514 68.298Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__left"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_211"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_212"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_213"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_169",
  d: "M393.395 231.418L369.9 240.988V257.865L393.395 248.295V231.418Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_214"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_170",
  d: "M421.04 250.529L397.545 260.099V263.265L421.04 253.695V250.529Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.392376,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_215"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_171",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M421.062 250.527L393.416 231.405L369.912 240.972L397.558 260.093L421.062 250.527Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_216"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_172",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M397.558 260.093V263.255L369.912 257.829V240.971L397.558 260.093Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_217"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_218"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_173",
  d: "M369.846 240.959L346.351 250.529V267.406L369.846 257.836V240.959Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_219"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_174",
  d: "M384.328 258.491V275.412L387.26 274.217V257.297L384.328 258.491Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.421308,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_220"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_175",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M387.291 257.292L369.868 240.953L346.364 250.519L384.332 258.476L387.291 257.292Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_221"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_176",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M384.332 258.476V275.353L346.364 267.377V250.519L384.332 258.476Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_222"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_223"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_224"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_177",
  d: "M346.406 250.558L322.911 260.129V277.006L346.406 267.435V250.558Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_225"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_178",
  d: "M374.051 269.669L350.557 279.24V282.406L374.051 272.836V269.669Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.392376,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_226"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_179",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M374.074 269.667L346.429 250.546L322.925 260.112L350.57 279.233L374.074 269.667Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_227"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_180",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M350.57 279.233V282.396L322.925 276.969V260.112L350.57 279.233Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_228"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_229"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_181",
  d: "M322.858 260.099L299.364 269.669V286.546L322.858 276.976V260.099Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_230"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_182",
  d: "M337.341 277.631V294.552L340.273 293.357V276.437L337.341 277.631Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.421308,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_231"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_183",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M340.303 276.432L322.881 260.093L299.377 269.66L337.345 277.616L340.303 276.432Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_232"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_184",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M337.345 277.616V294.493L299.377 286.517V269.66L337.345 277.616Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_233"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_234"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_235"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_185",
  d: "M299.417 269.698L275.922 279.269V296.145L299.417 286.575V269.698Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_236"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_186",
  d: "M327.062 288.809L303.567 298.38V301.546L327.062 291.976V288.809Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.392376,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_237"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_187",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M327.084 288.807L299.438 269.686L275.935 279.252L303.58 298.373L327.084 288.807Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_238"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_188",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M303.58 298.373V301.536L275.934 296.109V279.252L303.58 298.373Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_239"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_240"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_189",
  d: "M275.869 279.239L252.374 288.81V305.687L275.869 296.116V279.239Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_241"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_190",
  d: "M290.35 296.771V313.692L293.282 312.498V295.577L290.35 296.771Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.421308,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_242"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_191",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M293.313 295.573L275.891 279.234L252.387 288.8L290.354 296.757L293.313 295.573Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_243"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_192",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M290.354 296.757V313.634L252.387 305.658V288.8L290.354 296.757Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_244"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_245"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_246"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_193",
  d: "M252.426 288.839L228.932 298.409V315.286L252.426 305.716V288.839Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_247"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_194",
  d: "M280.071 307.95L256.577 317.52V320.686L280.071 311.116V307.95Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.392376,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_248"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_195",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M280.095 307.947L252.449 288.826L228.945 298.392L256.591 317.513L280.095 307.947Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_249"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_196",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M256.591 317.514V320.676L228.945 315.25V298.392L256.591 317.514Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_250"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_251"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_197",
  d: "M228.879 298.379L205.385 307.95V324.827L228.879 315.256V298.379Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_252"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_198",
  d: "M243.361 315.912V332.833L246.294 331.638V314.717L243.361 315.912Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.421308,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_253"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_199",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M246.324 314.713L228.902 298.374L205.398 307.94L243.366 315.897L246.324 314.713Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_254"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_200",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M243.366 315.896V332.774L205.398 324.797V307.94L243.366 315.896Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_255"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_256"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_257"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_201",
  d: "M205.438 307.979L181.943 317.549V334.426L205.438 324.856V307.979Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_258"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_202",
  d: "M233.082 327.09L209.588 336.66V339.826L233.082 330.256V327.09Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.392376,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_259"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_203",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M233.105 327.087L205.459 307.966L181.955 317.532L209.601 336.654L233.105 327.087Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_260"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_204",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M209.601 336.654V339.816L181.956 334.39V317.532L209.601 336.654Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_261"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_262"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_205",
  d: "M181.891 317.52L158.396 327.09V343.967L181.891 334.397V317.52Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_263"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_206",
  d: "M196.372 335.052V351.972L199.304 350.778V333.857L196.372 335.052Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.421308,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_264"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_207",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M199.334 333.853L181.912 317.514L158.408 327.08L196.376 335.037L199.334 333.853Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_265"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_208",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M196.376 335.037V351.914L158.408 343.938V327.08L196.376 335.037Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_266"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_267"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_268"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_209",
  d: "M158.449 327.119L134.955 336.689V353.566L158.449 343.996V327.119Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_269"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_210",
  d: "M186.094 346.23L162.599 355.8V358.967L186.094 349.396V346.23Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.392376,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_270"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_211",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M186.117 346.228L158.471 327.107L134.967 336.673L162.613 355.794L186.117 346.228Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_271"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_212",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M162.613 355.794V358.957L134.967 353.53V336.673L162.613 355.794Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_272"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_273"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_213",
  d: "M134.902 336.66L111.407 346.23V363.107L134.902 353.537V336.66Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_274"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_214",
  d: "M149.383 354.192V371.113L152.315 369.918V352.997L149.383 354.192Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.421308,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_275"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_215",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M152.345 352.993L134.923 336.654L111.419 346.221L149.387 354.177L152.345 352.993Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_276"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_216",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M149.387 354.177V371.055L111.419 363.078V346.221L149.387 354.177Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_277"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_278"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_279"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_217",
  d: "M111.46 346.259L87.9653 355.829V372.706L111.46 363.136V346.259Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_280"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_218",
  d: "M139.105 365.37L115.61 374.94V378.107L139.105 368.536V365.37Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.392376,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_281"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_219",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M139.128 365.368L111.482 346.247L87.9785 355.813L115.624 374.934L139.128 365.368Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_282"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_220",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M115.624 374.934V378.097L87.9785 372.67V355.813L115.624 374.934Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_283"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_284"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_221",
  d: "M87.9122 355.8L64.4175 365.37V382.247L87.9122 372.677V355.8Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_285"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_222",
  d: "M102.394 373.332V390.253L105.326 389.059V372.138L102.394 373.332Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.421308,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_286"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_223",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M105.356 372.133L87.9338 355.794L64.4299 365.361L102.398 373.317L105.356 372.133Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_287"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_224",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M102.398 373.317V390.195L64.4302 382.218V365.361L102.398 373.317Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_288"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_289"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_225",
  d: "M64.471 365.399L40.9763 374.97V391.847L64.471 382.276V365.399Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_290"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_226",
  d: "M92.1158 384.51L68.6211 394.081V397.247L92.1158 387.677V384.51Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.392376,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_291"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_227",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M92.138 384.508L64.4924 365.387L40.9885 374.953L68.6342 394.074L92.138 384.508Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_292"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_228",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M68.6342 394.074V397.237L40.9885 391.81V374.953L68.6342 394.074Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_293"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_294"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_229",
  d: "M40.9224 374.941L17.4277 384.511V401.388L40.9224 391.818V374.941Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_295"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_230",
  d: "M55.405 392.473V409.394L58.3373 408.199V391.279L55.405 392.473Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.421308,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_296"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_231",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M58.3677 391.274L40.9453 374.935L17.4414 384.502L55.4092 392.458L58.3677 391.274Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_297"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_232",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M55.4092 392.458V409.336L17.4414 401.359L17.4414 384.502L55.4092 392.458Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_298"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_299"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_233",
  d: "M394.076 213.96L370.581 223.53V240.407L394.076 230.837V213.96Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_300"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_234",
  d: "M408.558 231.492V248.413L411.49 247.218V230.298L408.558 231.492Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.421308,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_301"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_235",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M411.52 230.293L394.098 213.954L370.594 223.52L408.562 231.477L411.52 230.293Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_302"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_236",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M408.562 231.477V248.354L370.594 240.378V223.521L408.562 231.477Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_303"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_304"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_237",
  d: "M369.899 223.859L346.404 233.429V250.306L369.899 240.736V223.859Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_305"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_238",
  d: "M397.544 242.97L374.049 252.54V255.706L397.544 246.136V242.97Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.392376,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_306"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_239",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M397.566 242.967L369.92 223.846L346.416 233.412L374.062 252.534L397.566 242.967Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_307"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_240",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M374.062 252.534V255.696L346.416 250.27V233.412L374.062 252.534Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_308"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_309"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_241",
  d: "M346.352 233.4L322.857 242.97V259.847L346.352 250.277V233.4Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_310"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_242",
  d: "M360.833 250.932V267.853L363.766 266.658V249.738L360.833 250.932Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.421308,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_311"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_243",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M363.796 249.733L346.374 233.394L322.87 242.96L360.838 250.917L363.796 249.733Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_312"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_244",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M360.838 250.917V267.794L322.87 259.818V242.96L360.838 250.917Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_313"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_314"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_315"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_245",
  d: "M322.91 242.999L299.415 252.569V269.446L322.91 259.876V242.999Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_316"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_246",
  d: "M350.555 262.11L327.061 271.68V274.847L350.555 265.276V262.11Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.392376,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_317"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_247",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M350.577 262.108L322.931 242.986L299.427 252.553L327.073 271.674L350.577 262.108Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_318"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_248",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M327.073 271.674V274.837L299.427 269.41V252.553L327.073 271.674Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_319"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_320"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_249",
  d: "M299.362 252.54L275.867 262.11V278.987L299.362 269.417V252.54Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_321"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_250",
  d: "M313.844 270.072V286.993L316.776 285.798V268.878L313.844 270.072Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.421308,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_322"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_251",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M316.806 268.873L299.383 252.534L275.879 262.101L313.847 270.057L316.806 268.873Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_323"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_252",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M313.848 270.057V286.934L275.88 278.958V262.101L313.848 270.057Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_324"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_325"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_326"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_253",
  d: "M275.921 262.139L252.427 271.709V288.586L275.921 279.016V262.139Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_327"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_254",
  d: "M303.566 281.25L280.072 290.821V293.987L303.566 284.417V281.25Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.392376,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_328"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_255",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M303.589 281.248L275.944 262.127L252.44 271.693L280.086 290.814L303.589 281.248Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_329"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_256",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M280.086 290.814V293.977L252.44 288.55V271.693L280.086 290.814Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_330"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_331"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_257",
  d: "M252.374 271.68L228.879 281.25V298.127L252.374 288.557V271.68Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_332"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_258",
  d: "M266.856 289.212V306.133L269.788 304.938V288.017L266.856 289.212Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.421308,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_333"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_259",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M269.818 288.014L252.395 271.675L228.892 281.241L266.859 289.197L269.818 288.014Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_334"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_260",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M266.859 289.197V306.075L228.892 298.098V281.241L266.859 289.197Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_335"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_336"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_337"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_261",
  d: "M228.932 281.28L205.438 290.85V307.727L228.932 298.157V281.28Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_338"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_262",
  d: "M256.577 300.391L233.083 309.961V313.127L256.577 303.557V300.391Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.392376,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_339"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_263",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M256.6 300.388L228.954 281.267L205.45 290.833L233.096 309.955L256.6 300.388Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_340"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_264",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M233.096 309.955V313.117L205.45 307.691V290.833L233.096 309.955Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_341"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_342"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_265",
  d: "M205.385 290.82L181.891 300.391V317.267L205.385 307.697V290.82Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_343"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_266",
  d: "M219.866 308.353V325.273L222.798 324.079V307.158L219.866 308.353Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.421308,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_344"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_267",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M222.829 307.154L205.407 290.815L181.903 300.381L219.871 308.338L222.829 307.154Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_345"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_268",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M219.871 308.338V325.215L181.903 317.239V300.381L219.871 308.338Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_346"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_347"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_348"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_269",
  d: "M181.943 300.42L158.448 309.99V326.867L181.943 317.297V300.42Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_349"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_270",
  d: "M209.588 319.531L186.093 329.101V332.267L209.588 322.697V319.531Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.392376,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_350"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_271",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M209.61 319.528L181.964 300.407L158.46 309.973L186.106 329.094L209.61 319.528Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_351"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_272",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M186.106 329.094V332.257L158.461 326.831V309.973L186.106 329.094Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_352"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_353"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_273",
  d: "M158.396 309.96L134.901 319.531V336.407L158.396 326.837V309.96Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_354"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_274",
  d: "M172.877 327.492V344.413L175.809 343.219V326.298L172.877 327.492Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.421308,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_355"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_275",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M175.84 326.294L158.417 309.955L134.913 319.521L172.881 327.477L175.84 326.294Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_356"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_276",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M172.881 327.478V344.355L134.913 336.379V319.521L172.881 327.478Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_357"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_358"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_359"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_277",
  d: "M134.954 319.56L111.46 329.13V346.007L134.954 336.437V319.56Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_360"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_278",
  d: "M162.599 338.671L139.104 348.241V351.407L162.599 341.837V338.671Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.392376,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_361"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_279",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M162.622 338.668L134.976 319.547L111.472 329.113L139.118 348.234L162.622 338.668Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_362"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_280",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M139.118 348.234V351.397L111.472 345.97V329.113L139.118 348.234Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_363"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_364"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_281",
  d: "M111.407 329.101L87.9121 338.671V355.548L111.407 345.978V329.101Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_365"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_282",
  d: "M125.889 346.633V363.554L128.821 362.359V345.438L125.889 346.633Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.421308,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_366"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_283",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M128.851 345.434L111.429 329.095L87.9248 338.661L125.893 346.618L128.851 345.434Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_367"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_284",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M125.893 346.618V363.495L87.9248 355.519V338.662L125.893 346.618Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_368"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_369"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_370"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_285",
  d: "M87.9649 338.7L64.4702 348.271V365.147L87.9649 355.577V338.7Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_371"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_286",
  d: "M115.61 357.811L92.1155 367.381V370.547L115.61 360.977V357.811Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.392376,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_372"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_287",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M115.632 357.809L87.9868 338.688L64.4829 348.254L92.1286 367.375L115.632 357.809Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_373"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_288",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M92.1286 367.375V370.538L64.4829 365.111V348.254L92.1286 367.375Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_374"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_375"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_289",
  d: "M64.4178 348.241L40.9231 357.811V374.688L64.4178 365.118V348.241Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_376"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_290",
  d: "M78.8987 365.773V382.694L81.831 381.5V364.579L78.8987 365.773Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.421308,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_377"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_291",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M81.8613 364.574L64.4389 348.235L40.9351 357.802L78.9028 365.758L81.8613 364.574Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_378"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_292",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M78.9031 365.758V382.635L40.9353 374.659V357.802L78.9031 365.758Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_379"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_380"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_293",
  d: "M40.9769 357.841L17.4822 367.411V384.288L40.9769 374.718V357.841Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_381"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_294",
  d: "M68.6212 376.952L45.1265 386.522V389.688L68.6212 380.118V376.952Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.392376,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_382"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_295",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M68.6434 376.949L40.9977 357.828L17.4939 367.394L45.1396 386.515L68.6434 376.949Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_383"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_296",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M45.1396 386.515V389.678L17.4939 384.251L17.4939 367.394L45.1396 386.515Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_384"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_385"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_386"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_297",
  d: "M393.395 196.951L369.9 206.521V223.398L393.395 213.828V196.951Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_387"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_298",
  d: "M421.04 216.061L397.545 225.631V228.798L421.04 219.227V216.061Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.392376,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_388"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_299",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M421.062 216.059L393.416 196.937L369.912 206.504L397.558 225.625L421.062 216.059Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_389"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_300",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M397.558 225.625V228.788L369.912 223.361V206.504L397.558 225.625Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_390"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_391"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_301",
  d: "M369.846 206.491L346.351 216.061V232.938L369.846 223.368V206.491Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_392"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_302",
  d: "M384.328 224.023V240.944L387.26 239.749V222.829L384.328 224.023Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.421308,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_393"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_303",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M387.291 222.825L369.868 206.486L346.364 216.052L384.332 224.008L387.291 222.825Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_394"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_304",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M384.332 224.008V240.885L346.364 232.909V216.052L384.332 224.008Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_395"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_396"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_397"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_305",
  d: "M346.406 216.091L322.911 225.661V242.538L346.406 232.968V216.091Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_398"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_306",
  d: "M374.051 235.202L350.557 244.772V247.938L374.051 238.368V235.202Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.392376,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_399"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_307",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M374.074 235.199L346.429 216.078L322.925 225.644L350.57 244.765L374.074 235.199Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_400"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_308",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M350.57 244.766V247.928L322.925 242.502V225.644L350.57 244.766Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_401"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_402"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_309",
  d: "M322.858 225.631L299.364 235.201V252.078L322.858 242.508V225.631Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_403"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_310",
  d: "M337.341 243.163V260.084L340.273 258.89V241.969L337.341 243.163Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.421308,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_404"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_311",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M340.303 241.965L322.881 225.626L299.377 235.192L337.345 243.148L340.303 241.965Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_405"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_312",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M337.345 243.148V260.026L299.377 252.049V235.192L337.345 243.148Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_406"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_407"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_408"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_313",
  d: "M299.417 235.231L275.922 244.801V261.678L299.417 252.108V235.231Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_409"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_314",
  d: "M327.062 254.342L303.567 263.912V267.078L327.062 257.508V254.342Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.392376,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_410"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_315",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M327.084 254.339L299.438 235.218L275.935 244.784L303.58 263.906L327.084 254.339Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_411"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_316",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M303.58 263.906V267.068L275.934 261.642V244.784L303.58 263.906Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_412"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_413"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_317",
  d: "M275.869 244.771L252.374 254.342V271.219L275.869 261.648V244.771Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_414"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_318",
  d: "M290.35 262.304V279.225L293.282 278.03V261.11L290.35 262.304Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.421308,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_415"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_319",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M293.313 261.105L275.891 244.766L252.387 254.332L290.354 262.289L293.313 261.105Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_416"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_320",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M290.354 262.289V279.166L252.387 271.19V254.332L290.354 262.289Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_417"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_418"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_419"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_321",
  d: "M252.426 254.371L228.932 263.941V280.818L252.426 271.248V254.371Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_420"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_322",
  d: "M280.071 273.482L256.577 283.052V286.219L280.071 276.648V273.482Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.392376,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_421"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_323",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M280.095 273.479L252.449 254.358L228.945 263.924L256.591 283.046L280.095 273.479Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_422"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_324",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M256.591 283.046V286.208L228.945 280.782V263.924L256.591 283.046Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_423"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_424"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_325",
  d: "M228.879 263.912L205.385 273.482V290.359L228.879 280.789V263.912Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_425"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_326",
  d: "M243.361 281.444V298.365L246.294 297.17V280.25L243.361 281.444Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.421308,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_426"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_327",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M246.324 280.245L228.902 263.906L205.398 273.473L243.366 281.429L246.324 280.245Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_427"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_328",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M243.366 281.429V298.306L205.398 290.33V273.473L243.366 281.429Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_428"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_429"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_430"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_329",
  d: "M205.438 273.511L181.943 283.081V299.958L205.438 290.388V273.511Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_431"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_330",
  d: "M233.082 292.622L209.588 302.193V305.359L233.082 295.789V292.622Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.392376,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_432"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_331",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M233.105 292.62L205.459 273.498L181.955 283.065L209.601 302.186L233.105 292.62Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_433"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_332",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M209.601 302.186V305.349L181.956 299.922V283.065L209.601 302.186Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_434"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_435"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_333",
  d: "M181.891 283.052L158.396 292.622V309.499L181.891 299.929V283.052Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_436"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_334",
  d: "M196.372 300.584V317.505L199.304 316.31V299.389L196.372 300.584Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.421308,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_437"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_335",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M199.334 299.385L181.912 283.046L158.408 292.613L196.376 300.569L199.334 299.385Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_438"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_336",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M196.376 300.569V317.446L158.408 309.47V292.613L196.376 300.569Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_439"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_440"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_441"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_337",
  d: "M158.449 292.652L134.955 302.222V319.099L158.449 309.529V292.652Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_442"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_338",
  d: "M186.094 311.763L162.599 321.333V324.499L186.094 314.929V311.763Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.392376,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_443"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_339",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M186.117 311.76L158.471 292.639L134.967 302.205L162.613 321.327L186.117 311.76Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_444"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_340",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M162.613 321.327V324.489L134.967 319.063V302.205L162.613 321.327Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_445"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_446"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_341",
  d: "M134.902 302.192L111.407 311.762V328.639L134.902 319.069V302.192Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_447"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_342",
  d: "M149.383 319.724V336.645L152.315 335.451V318.53L149.383 319.724Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.421308,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_448"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_343",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M152.345 318.526L134.923 302.187L111.419 311.753L149.387 319.71L152.345 318.526Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_449"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_344",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M149.387 319.71V336.587L111.419 328.611V311.753L149.387 319.71Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_450"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_451"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_452"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_345",
  d: "M111.46 311.792L87.9653 321.362V338.239L111.46 328.668V311.792Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_453"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_346",
  d: "M139.105 330.902L115.61 340.473V343.639L139.105 334.069V330.902Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.392376,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_454"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_347",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M139.128 330.9L111.482 311.779L87.9785 321.345L115.624 340.466L139.128 330.9Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_455"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_348",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M115.624 340.466V343.629L87.9785 338.203V321.345L115.624 340.466Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_456"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_457"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_349",
  d: "M87.9122 321.332L64.4175 330.902V347.779L87.9122 338.209V321.332Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_458"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_350",
  d: "M102.394 338.864V355.785L105.326 354.591V337.67L102.394 338.864Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.421308,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_459"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_351",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M105.356 337.666L87.9338 321.327L64.4299 330.893L102.398 338.849L105.356 337.666Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_460"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_352",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M102.398 338.85V355.727L64.4302 347.751V330.893L102.398 338.85Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_461"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_462"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_353",
  d: "M64.471 330.932L40.9763 340.502V357.379L64.471 347.809V330.932Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_463"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_354",
  d: "M92.1158 350.043L68.6211 359.613V362.779L92.1158 353.209V350.043Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.392376,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_464"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_355",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M92.138 350.04L64.4924 330.919L40.9885 340.485L68.6342 359.607L92.138 350.04Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_465"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_356",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M68.6342 359.607V362.769L40.9885 357.343V340.485L68.6342 359.607Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_466"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_467"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_357",
  d: "M40.9224 340.473L17.4277 350.043V366.92L40.9224 357.35V340.473Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_468"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_358",
  d: "M55.405 358.005V374.926L58.3373 373.731V356.811L55.405 358.005Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.421308,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_469"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_359",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M58.3677 356.807L40.9453 340.468L17.4414 350.034L55.4092 357.991L58.3677 356.807Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_470"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_360",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M55.4092 357.99V374.868L17.4414 366.891L17.4414 350.034L55.4092 357.99Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_471"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_472"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_361",
  d: "M394.076 179.492L370.581 189.062V205.939L394.076 196.369V179.492Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_473"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_362",
  d: "M408.558 197.024V213.945L411.49 212.751V195.83L408.558 197.024Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.421308,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_474"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_363",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M411.52 195.825L394.098 179.486L370.594 189.053L408.562 197.009L411.52 195.825Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_475"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_364",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M408.562 197.009V213.887L370.594 205.91V189.053L408.562 197.009Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_476"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_477"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_365",
  d: "M369.899 189.391L346.404 198.961V215.838L369.899 206.268V189.391Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_478"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_366",
  d: "M397.544 208.502L374.049 218.072V221.238L397.544 211.668V208.502Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.392376,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_479"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_367",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M397.566 208.5L369.92 189.378L346.416 198.945L374.062 218.066L397.566 208.5Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_480"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_368",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M374.062 218.066V221.229L346.416 215.802V198.945L374.062 218.066Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_481"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_482"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_369",
  d: "M346.352 198.932L322.857 208.502V225.379L346.352 215.809V198.932Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_483"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_370",
  d: "M360.833 216.464V233.384L363.766 232.19V215.269L360.833 216.464Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.421308,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_484"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_371",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M363.796 215.265L346.374 198.926L322.87 208.493L360.838 216.449L363.796 215.265Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_485"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_372",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M360.838 216.449V233.326L322.87 225.35V208.493L360.838 216.449Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_486"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_487"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_488"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_373",
  d: "M322.91 208.532L299.415 218.102V234.979L322.91 225.409V208.532Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_489"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_374",
  d: "M350.555 227.643L327.061 237.213V240.379L350.555 230.809V227.643Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.392376,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_490"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_375",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M350.577 227.64L322.931 208.519L299.427 218.085L327.073 237.206L350.577 227.64Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_491"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_376",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M327.073 237.206V240.369L299.427 234.942V218.085L327.073 237.206Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_492"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_493"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_377",
  d: "M299.362 218.072L275.867 227.642V244.519L299.362 234.949V218.072Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_494"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_378",
  d: "M313.844 235.604V252.525L316.776 251.331V234.41L313.844 235.604Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.421308,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_495"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_379",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M316.806 234.406L299.383 218.067L275.879 227.633L313.847 235.59L316.806 234.406Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_496"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_380",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M313.848 235.589V252.467L275.88 244.49V227.633L313.848 235.589Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_497"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_498"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_499"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_381",
  d: "M275.921 227.672L252.427 237.242V254.119L275.921 244.549V227.672Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_500"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_382",
  d: "M303.566 246.783L280.072 256.353V259.519L303.566 249.949V246.783Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.392376,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_501"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_383",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M303.589 246.78L275.944 227.659L252.44 237.225L280.086 256.347L303.589 246.78Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_502"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_384",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M280.086 256.347V259.509L252.44 254.083V237.225L280.086 256.347Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_503"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_504"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_385",
  d: "M252.374 237.212L228.879 246.783V263.66L252.374 254.089V237.212Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_505"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_386",
  d: "M266.856 254.744V271.665L269.788 270.471V253.55L266.856 254.744Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.421308,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_506"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_387",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M269.818 253.546L252.395 237.207L228.892 246.773L266.859 254.73L269.818 253.546Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_507"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_388",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M266.859 254.73V271.607L228.892 263.631V246.773L266.859 254.73Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_508"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_509"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_510"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_389",
  d: "M228.932 246.812L205.438 256.382V273.259L228.932 263.689V246.812Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_511"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_390",
  d: "M256.577 265.923L233.083 275.493V278.659L256.577 269.089V265.923Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.392376,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_512"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_391",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M256.6 265.92L228.954 246.799L205.45 256.365L233.096 275.487L256.6 265.92Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_513"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_392",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M233.096 275.487V278.649L205.45 273.223V256.365L233.096 275.487Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_514"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_515"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_393",
  d: "M205.385 256.353L181.891 265.923V282.8L205.385 273.229V256.353Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_516"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_394",
  d: "M219.866 273.884V290.805L222.798 289.611V272.69L219.866 273.884Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.421308,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_517"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_395",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M222.829 272.686L205.407 256.347L181.903 265.913L219.871 273.87L222.829 272.686Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_518"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_396",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M219.871 273.87V290.747L181.903 282.771V265.913L219.871 273.87Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_519"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_520"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_521"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_397",
  d: "M181.943 265.952L158.448 275.522V292.399L181.943 282.829V265.952Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_522"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_398",
  d: "M209.588 285.063L186.093 294.633V297.8L209.588 288.229V285.063Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.392376,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_523"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_399",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M209.61 285.06L181.964 265.939L158.46 275.505L186.106 294.627L209.61 285.06Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_524"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_400",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M186.106 294.627V297.789L158.461 292.363V275.506L186.106 294.627Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_525"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_526"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_401",
  d: "M158.396 275.493L134.901 285.063V301.94L158.396 292.37V275.493Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_527"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_402",
  d: "M172.877 293.025V309.945L175.809 308.751V291.83L172.877 293.025Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.421308,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_528"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_403",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M175.84 291.826L158.417 275.487L134.913 285.053L172.881 293.01L175.84 291.826Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_529"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_404",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M172.881 293.01V309.887L134.913 301.911V285.053L172.881 293.01Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_530"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_531"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_532"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_405",
  d: "M134.954 285.092L111.46 294.662V311.539L134.954 301.969V285.092Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_533"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_406",
  d: "M162.599 304.203L139.105 313.773V316.94L162.599 307.369V304.203Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.392376,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_534"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_407",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M162.622 304.201L134.976 285.079L111.472 294.646L139.118 313.767L162.622 304.201Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_535"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_408",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M139.118 313.767V316.93L111.472 311.503V294.646L139.118 313.767Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_536"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_537"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_409",
  d: "M111.407 294.633L87.9121 304.203V321.08L111.407 311.51V294.633Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_538"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_410",
  d: "M125.889 312.165V329.086L128.821 327.891V310.971L125.889 312.165Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.421308,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_539"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_411",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M128.851 310.967L111.429 294.628L87.9248 304.194L125.893 312.15L128.851 310.967Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_540"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_412",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M125.893 312.15V329.027L87.9248 321.051V304.194L125.893 312.15Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_541"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_542"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_543"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_413",
  d: "M87.9649 304.233L64.4702 313.803V330.68L87.9649 321.11V304.233Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_544"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_414",
  d: "M115.61 323.344L92.1155 332.914V336.08L115.61 326.51V323.344Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.392376,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_545"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_415",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M115.632 323.341L87.9868 304.22L64.4829 313.786L92.1286 332.908L115.632 323.341Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_546"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_416",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M92.1286 332.908V336.07L64.4829 330.644V313.786L92.1286 332.908Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_547"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_548"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_417",
  d: "M64.4178 313.773L40.9231 323.344V340.22L64.4178 330.65V313.773Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_549"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_418",
  d: "M78.8987 331.306V348.227L81.831 347.032V330.111L78.8987 331.306Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.421308,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_550"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_419",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M81.8613 330.107L64.4389 313.768L40.9351 323.334L78.9028 331.291L81.8613 330.107Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_551"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_420",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M78.9031 331.291V348.168L40.9353 340.192V323.334L78.9031 331.291Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_552"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_553"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_421",
  d: "M40.9769 323.373L17.4822 332.943V349.82L40.9769 340.25V323.373Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_554"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_422",
  d: "M68.6212 342.484L45.1265 352.054V355.22L68.6212 345.65V342.484Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.392376,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_555"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_423",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M68.6434 342.481L40.9977 323.36L17.4939 332.926L45.1396 352.048L68.6434 342.481Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_556"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_424",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M45.1396 352.048V355.21L17.4939 349.784L17.4939 332.926L45.1396 352.048Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_557"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_558"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_559"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_425",
  d: "M393.395 162.48L369.9 172.051V188.928L393.395 179.357V162.48Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_560"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_426",
  d: "M421.04 181.591L397.545 191.161V194.328L421.04 184.758V181.591Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.392376,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_561"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_427",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M421.062 181.589L393.416 162.467L369.912 172.034L397.558 191.155L421.062 181.589Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_562"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_428",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M397.558 191.155V194.318L369.912 188.891V172.034L397.558 191.155Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_563"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_564"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_429",
  d: "M369.846 172.021L346.351 181.591V198.468L369.846 188.898V172.021Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_565"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_430",
  d: "M384.328 189.554V206.474L387.26 205.28V188.359L384.328 189.554Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.421308,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_566"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_431",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M387.291 188.354L369.868 172.015L346.364 181.582L384.332 189.538L387.291 188.354Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_567"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_432",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M384.332 189.538V206.415L346.364 198.439V181.582L384.332 189.538Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_568"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_569"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_570"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_433",
  d: "M346.406 181.621L322.911 191.191V208.068L346.406 198.498V181.621Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_571"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_434",
  d: "M374.051 200.732L350.557 210.302V213.468L374.051 203.898V200.732Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.392376,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_572"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_435",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M374.074 200.729L346.429 181.608L322.925 191.174L350.57 210.295L374.074 200.729Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_573"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_436",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M350.57 210.296V213.458L322.925 208.032V191.174L350.57 210.296Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_574"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_575"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_437",
  d: "M322.858 191.161L299.364 200.731V217.608L322.858 208.038V191.161Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_576"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_438",
  d: "M337.341 208.693V225.614L340.273 224.42V207.499L337.341 208.693Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.421308,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_577"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_439",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M340.303 207.495L322.881 191.156L299.377 200.722L337.345 208.679L340.303 207.495Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_578"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_440",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M337.345 208.679V225.556L299.377 217.58V200.722L337.345 208.679Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_579"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_580"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_581"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_441",
  d: "M299.417 200.761L275.922 210.331V227.208L299.417 217.638V200.761Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_582"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_442",
  d: "M327.062 219.872L303.567 229.442V232.608L327.062 223.038V219.872Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.392376,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_583"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_443",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M327.084 219.869L299.438 200.748L275.935 210.314L303.58 229.436L327.084 219.869Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_584"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_444",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M303.58 229.436V232.598L275.934 227.172V210.314L303.58 229.436Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_585"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_586"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_445",
  d: "M275.869 210.302L252.374 219.872V236.749L275.869 227.178V210.302Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_587"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_446",
  d: "M290.35 227.833V244.754L293.282 243.56V226.639L290.35 227.833Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.421308,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_588"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_447",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M293.313 226.635L275.891 210.296L252.387 219.862L290.354 227.819L293.313 226.635Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_589"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_448",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M290.354 227.819V244.696L252.387 236.72V219.862L290.354 227.819Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_590"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_591"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_592"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_449",
  d: "M252.426 219.901L228.932 229.471V246.348L252.426 236.778V219.901Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_593"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_450",
  d: "M280.071 239.012L256.577 248.582V251.748L280.071 242.178V239.012Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.392376,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_594"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_451",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M280.095 239.009L252.449 219.888L228.945 229.454L256.591 248.576L280.095 239.009Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_595"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_452",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M256.591 248.576V251.738L228.945 246.312V229.454L256.591 248.576Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_596"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_597"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_453",
  d: "M228.879 229.442L205.385 239.012V255.889L228.879 246.319V229.442Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_598"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_454",
  d: "M243.361 246.974V263.894L246.294 262.7V245.779L243.361 246.974Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.421308,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_599"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_455",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M246.324 245.775L228.902 229.436L205.398 239.002L243.366 246.959L246.324 245.775Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_600"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_456",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M243.366 246.959V263.836L205.398 255.86V239.002L243.366 246.959Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_601"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_602"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_603"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_457",
  d: "M205.438 239.041L181.943 248.611V265.488L205.438 255.918V239.041Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_604"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_458",
  d: "M233.082 258.152L209.588 267.722V270.889L233.082 261.318V258.152Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.392376,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_605"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_459",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M233.105 258.15L205.459 239.028L181.955 248.595L209.601 267.716L233.105 258.15Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_606"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_460",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M209.601 267.716V270.878L181.956 265.452V248.595L209.601 267.716Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_607"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_608"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_461",
  d: "M181.891 248.582L158.396 258.152V275.029L181.891 265.459V248.582Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_609"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_462",
  d: "M196.372 266.114V283.035L199.304 281.84V264.92L196.372 266.114Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.421308,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_610"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_463",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M199.334 264.915L181.912 248.576L158.408 258.143L196.376 266.099L199.334 264.915Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_611"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_464",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M196.376 266.099V282.976L158.408 275V258.143L196.376 266.099Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_612"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_613"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_614"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_465",
  d: "M158.449 258.182L134.955 267.752V284.629L158.449 275.058V258.182Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_615"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_466",
  d: "M186.094 277.292L162.599 286.863V290.029L186.094 280.459V277.292Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.392376,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_616"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_467",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M186.117 277.29L158.471 258.169L134.967 267.735L162.613 286.856L186.117 277.29Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_617"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_468",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M162.613 286.857V290.019L134.967 284.593V267.735L162.613 286.857Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_618"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_619"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_469",
  d: "M134.902 267.722L111.407 277.292V294.169L134.902 284.599V267.722Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_620"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_470",
  d: "M149.383 285.255V302.175L152.315 300.981V284.06L149.383 285.255Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.421308,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_621"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_471",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M152.345 284.056L134.923 267.717L111.419 277.283L149.387 285.24L152.345 284.056Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_622"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_472",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M149.387 285.24V302.117L111.419 294.141V277.283L149.387 285.24Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_623"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_624"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_625"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_473",
  d: "M111.46 277.321L87.9653 286.891V303.768L111.46 294.198V277.321Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_626"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_474",
  d: "M139.105 296.432L115.61 306.003V309.169L139.105 299.599V296.432Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.392376,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_627"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_475",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M139.128 296.43L111.482 277.309L87.9785 286.875L115.624 305.996L139.128 296.43Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_628"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_476",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M115.624 305.996V309.159L87.9785 303.733V286.875L115.624 305.996Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_629"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_630"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_477",
  d: "M87.9122 286.862L64.4175 296.432V313.309L87.9122 303.739V286.862Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_631"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_478",
  d: "M102.394 304.394V321.315L105.326 320.121V303.2L102.394 304.394Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.421308,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_632"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_479",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M105.356 303.196L87.9338 286.857L64.4299 296.423L102.398 304.379L105.356 303.196Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_633"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_480",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M102.398 304.379V321.257L64.4302 313.28V296.423L102.398 304.379Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_634"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_635"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_481",
  d: "M64.471 296.462L40.9763 306.032V322.909L64.471 313.339V296.462Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_636"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_482",
  d: "M92.1158 315.573L68.6211 325.143V328.309L92.1158 318.739V315.573Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.392376,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_637"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_483",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M92.138 315.57L64.4924 296.449L40.9885 306.015L68.6342 325.137L92.138 315.57Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_638"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_484",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M68.6342 325.137V328.299L40.9885 322.873V306.015L68.6342 325.137Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_639"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_640"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_485",
  d: "M40.9224 306.003L17.4277 315.573V332.45L40.9224 322.88V306.003Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_641"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_486",
  d: "M55.405 323.535V340.456L58.3373 339.262V322.341L55.405 323.535Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.421308,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_642"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_487",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M58.3677 322.337L40.9453 305.998L17.4414 315.564L55.4092 323.521L58.3677 322.337Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_643"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_488",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M55.4092 323.52V340.398L17.4414 332.421L17.4414 315.564L55.4092 323.52Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_644"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_645"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_489",
  d: "M394.076 145.022L370.581 154.592V171.469L394.076 161.899V145.022Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_646"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_490",
  d: "M408.558 162.554V179.475L411.49 178.28V161.36L408.558 162.554Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.421308,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_647"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_491",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M411.52 161.355L394.098 145.016L370.594 154.583L408.562 162.539L411.52 161.355Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_648"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_492",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M408.562 162.539V179.416L370.594 171.44V154.583L408.562 162.539Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_649"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_650"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_493",
  d: "M369.899 154.921L346.404 164.491V181.368L369.899 171.798V154.921Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_651"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_494",
  d: "M397.544 174.032L374.049 183.602V186.768L397.544 177.198V174.032Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.392376,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_652"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_495",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M397.566 174.03L369.92 154.909L346.416 164.475L374.062 183.596L397.566 174.03Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_653"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_496",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M374.062 183.596V186.759L346.416 181.332V164.475L374.062 183.596Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_654"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_655"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_497",
  d: "M346.352 164.462L322.857 174.032V190.909L346.352 181.339V164.462Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_656"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_498",
  d: "M360.833 181.994V198.915L363.766 197.72V180.8L360.833 181.994Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.421308,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_657"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_499",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M363.796 180.795L346.374 164.456L322.87 174.023L360.838 181.979L363.796 180.795Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_658"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_500",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M360.838 181.979V198.856L322.87 190.88V174.023L360.838 181.979Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_659"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_660"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_661"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_501",
  d: "M322.91 174.062L299.415 183.632V200.509L322.91 190.938V174.062Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_662"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_502",
  d: "M350.555 193.172L327.061 202.743V205.909L350.555 196.339V193.172Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.392376,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_663"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_503",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M350.577 193.17L322.931 174.049L299.427 183.615L327.073 202.736L350.577 193.17Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_664"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_504",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M327.073 202.736V205.899L299.427 200.472V183.615L327.073 202.736Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_665"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_666"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_505",
  d: "M299.362 183.602L275.867 193.172V210.049L299.362 200.479V183.602Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_667"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_506",
  d: "M313.844 201.134V218.055L316.776 216.861V199.94L313.844 201.134Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.421308,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_668"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_507",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M316.806 199.936L299.383 183.597L275.879 193.163L313.847 201.119L316.806 199.936Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_669"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_508",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M313.848 201.119V217.997L275.88 210.02V193.163L313.848 201.119Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_670"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_671"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_672"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_509",
  d: "M275.921 193.202L252.427 202.772V219.649L275.921 210.079V193.202Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_673"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_510",
  d: "M303.566 212.313L280.072 221.883V225.049L303.566 215.479V212.313Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.392376,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_674"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_511",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M303.589 212.31L275.944 193.189L252.44 202.755L280.086 221.876L303.589 212.31Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_675"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_512",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M280.086 221.876V225.039L252.44 219.612V202.755L280.086 221.876Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_676"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_677"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_513",
  d: "M252.374 202.742L228.879 212.312V229.189L252.374 219.619V202.742Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_678"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_514",
  d: "M266.856 220.274V237.195L269.788 236.001V219.08L266.856 220.274Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.421308,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_679"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_515",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M269.818 219.076L252.395 202.737L228.892 212.303L266.859 220.26L269.818 219.076Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_680"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_516",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M266.859 220.259V237.137L228.892 229.16V212.303L266.859 220.259Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_681"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_682"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_683"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_517",
  d: "M228.932 212.342L205.438 221.912V238.789L228.932 229.219V212.342Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_684"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_518",
  d: "M256.577 231.453L233.083 241.023V244.189L256.577 234.619V231.453Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.392376,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_685"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_519",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M256.6 231.45L228.954 212.329L205.45 221.895L233.096 241.017L256.6 231.45Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_686"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_520",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M233.096 241.017V244.179L205.45 238.753V221.895L233.096 241.017Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_687"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_688"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_521",
  d: "M205.385 221.883L181.891 231.453V248.33L205.385 238.76V221.883Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_689"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_522",
  d: "M219.866 239.415V256.336L222.798 255.141V238.221L219.866 239.415Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.421308,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_690"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_523",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M222.829 238.216L205.407 221.877L181.903 231.443L219.871 239.4L222.829 238.216Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_691"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_524",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M219.871 239.4V256.277L181.903 248.301V231.443L219.871 239.4Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_692"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_693"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_694"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_525",
  d: "M181.943 231.482L158.448 241.052V257.929L181.943 248.359V231.482Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_695"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_526",
  d: "M209.588 250.593L186.093 260.163V263.329L209.588 253.759V250.593Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.392376,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_696"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_527",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M209.61 250.591L181.964 231.469L158.46 241.036L186.106 260.157L209.61 250.591Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_697"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_528",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M186.106 260.157V263.319L158.461 257.893V241.035L186.106 260.157Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_698"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_699"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_529",
  d: "M158.396 241.023L134.901 250.593V267.47L158.396 257.9V241.023Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_700"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_530",
  d: "M172.877 258.555V275.476L175.809 274.281V257.361L172.877 258.555Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.421308,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_701"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_531",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M175.84 257.356L158.417 241.017L134.913 250.583L172.881 258.54L175.84 257.356Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_702"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_532",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M172.881 258.54V275.417L134.913 267.441V250.583L172.881 258.54Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_703"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_704"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_705"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_533",
  d: "M134.954 250.622L111.46 260.193V277.07L134.954 267.499V250.622Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_706"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_534",
  d: "M162.599 269.733L139.104 279.303V282.47L162.599 272.899V269.733Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.392376,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_707"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_535",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M162.622 269.731L134.976 250.609L111.472 260.176L139.118 279.297L162.622 269.731Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_708"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_536",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M139.118 279.297V282.46L111.472 277.033V260.176L139.118 279.297Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_709"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_710"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_537",
  d: "M111.407 260.163L87.9121 269.733V286.61L111.407 277.04V260.163Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_711"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_538",
  d: "M125.889 277.695V294.616L128.821 293.422V276.501L125.889 277.695Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.421308,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_712"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_539",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M128.851 276.496L111.429 260.157L87.9248 269.724L125.893 277.68L128.851 276.496Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_713"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_540",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M125.893 277.68V294.558L87.9248 286.581V269.724L125.893 277.68Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_714"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_715"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_716"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_541",
  d: "M87.9649 269.763L64.4702 279.333V296.21L87.9649 286.64V269.763Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_717"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_542",
  d: "M115.61 288.874L92.1155 298.444V301.61L115.61 292.04V288.874Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.392376,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_718"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_543",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M115.632 288.871L87.9868 269.75L64.4829 279.316L92.1286 298.437L115.632 288.871Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_719"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_544",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M92.1286 298.437V301.6L64.4829 296.174V279.316L92.1286 298.437Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_720"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_721"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_545",
  d: "M64.4178 279.303L40.9231 288.873V305.75L64.4178 296.18V279.303Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_722"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_546",
  d: "M78.8987 296.836V313.756L81.831 312.562V295.641L78.8987 296.836Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.421308,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_723"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_547",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M81.8613 295.637L64.4389 279.298L40.9351 288.864L78.9028 296.821L81.8613 295.637Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_724"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_548",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M78.9031 296.821V313.698L40.9353 305.722V288.864L78.9031 296.821Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_725"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_726"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_549",
  d: "M40.9769 288.903L17.4822 298.473V315.35L40.9769 305.78V288.903Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_727"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_550",
  d: "M68.6212 308.014L45.1265 317.584V320.75L68.6212 311.18V308.014Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.392376,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_728"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_551",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M68.6434 308.011L40.9977 288.89L17.4939 298.456L45.1396 317.578L68.6434 308.011Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_729"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_552",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M45.1396 317.578V320.74L17.4939 315.314L17.4939 298.456L45.1396 317.578Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_730"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_731"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_732"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_553",
  d: "M393.395 128.013L369.9 137.583V154.46L393.395 144.89V128.013Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_733"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_554",
  d: "M421.04 147.124L397.545 156.694V159.86L421.04 150.29V147.124Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.392376,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_734"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_555",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M421.062 147.121L393.416 128L369.912 137.566L397.558 156.687L421.062 147.121Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_735"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_556",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M397.558 156.687V159.85L369.912 154.423V137.566L397.558 156.687Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_736"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_737"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_557",
  d: "M369.846 137.553L346.351 147.124V164.001L369.846 154.43V137.553Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_738"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_558",
  d: "M384.328 155.085V172.006L387.26 170.812V153.891L384.328 155.085Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.421308,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_739"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_559",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M387.291 153.887L369.868 137.548L346.364 147.114L384.332 155.071L387.291 153.887Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_740"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_560",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M384.332 155.071V171.948L346.364 163.972V147.114L384.332 155.071Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_741"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_742"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_743"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_561",
  d: "M346.406 147.153L322.911 156.723V173.6L346.406 164.03V147.153Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_744"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_562",
  d: "M374.051 166.264L350.557 175.834V179L374.051 169.43V166.264Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.392376,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_745"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_563",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M374.074 166.261L346.429 147.14L322.925 156.706L350.57 175.828L374.074 166.261Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_746"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_564",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M350.57 175.828V178.99L322.925 173.564V156.706L350.57 175.828Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_747"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_748"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_565",
  d: "M322.858 156.694L299.364 166.264V183.141L322.858 173.571V156.694Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_749"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_566",
  d: "M337.341 174.226V191.147L340.273 189.952V173.031L337.341 174.226Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.421308,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_750"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_567",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M340.303 173.027L322.881 156.688L299.377 166.254L337.345 174.211L340.303 173.027Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_751"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_568",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M337.345 174.211V191.088L299.377 183.112V166.254L337.345 174.211Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_752"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_753"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_754"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_569",
  d: "M299.417 166.293L275.922 175.863V192.74L299.417 183.17V166.293Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_755"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_570",
  d: "M327.062 185.404L303.567 194.974V198.141L327.062 188.57V185.404Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.392376,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_756"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_571",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M327.084 185.402L299.438 166.28L275.935 175.847L303.58 194.968L327.084 185.402Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_757"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_572",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M303.58 194.968V198.131L275.934 192.704V175.847L303.58 194.968Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_758"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_759"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_573",
  d: "M275.869 175.834L252.374 185.404V202.281L275.869 192.711V175.834Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_760"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_574",
  d: "M290.35 193.366V210.286L293.282 209.092V192.171L290.35 193.366Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.421308,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_761"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_575",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M293.313 192.167L275.891 175.828L252.387 185.395L290.354 193.351L293.313 192.167Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_762"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_576",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M290.354 193.351V210.229L252.387 202.252V185.395L290.354 193.351Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_763"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_764"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_765"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_577",
  d: "M252.426 185.433L228.932 195.004V211.881L252.426 202.31V185.433Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_766"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_578",
  d: "M280.071 204.544L256.577 214.114V217.281L280.071 207.71V204.544Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.392376,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_767"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_579",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M280.095 204.542L252.449 185.42L228.945 194.987L256.591 214.108L280.095 204.542Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_768"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_580",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M256.591 214.108V217.271L228.945 211.844V194.987L256.591 214.108Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_769"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_770"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_581",
  d: "M228.879 194.974L205.385 204.544V221.421L228.879 211.851V194.974Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_771"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_582",
  d: "M243.361 212.506V229.427L246.294 228.232V211.312L243.361 212.506Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.421308,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_772"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_583",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M246.324 211.307L228.902 194.968L205.398 204.535L243.366 212.491L246.324 211.307Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_773"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_584",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M243.366 212.491V229.368L205.398 221.392V204.535L243.366 212.491Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_774"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_775"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_776"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_585",
  d: "M205.438 204.573L181.943 214.144V231.021L205.438 221.45V204.573Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_777"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_586",
  d: "M233.082 223.685L209.588 233.255V236.421L233.082 226.851V223.685Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.392376,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_778"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_587",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M233.105 223.682L205.459 204.561L181.955 214.127L209.601 233.248L233.105 223.682Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_779"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_588",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M209.601 233.248V236.411L181.956 230.984V214.127L209.601 233.248Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_780"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_781"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_589",
  d: "M181.891 214.114L158.396 223.684V240.561L181.891 230.991V214.114Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_782"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_590",
  d: "M196.372 231.646V248.567L199.304 247.373V230.452L196.372 231.646Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.421308,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_783"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_591",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M199.334 230.448L181.912 214.109L158.408 223.675L196.376 231.632L199.334 230.448Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_784"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_592",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M196.376 231.632V248.509L158.408 240.533V223.675L196.376 231.632Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_785"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_786"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_787"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_593",
  d: "M158.449 223.714L134.955 233.284V250.161L158.449 240.591V223.714Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_788"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_594",
  d: "M186.094 242.825L162.599 252.395V255.561L186.094 245.991V242.825Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.392376,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_789"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_595",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M186.117 242.822L158.471 223.701L134.967 233.267L162.613 252.389L186.117 242.822Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_790"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_596",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M162.613 252.389V255.551L134.967 250.125V233.267L162.613 252.389Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_791"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_792"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_597",
  d: "M134.902 233.255L111.407 242.825V259.702L134.902 250.131V233.255Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_793"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_598",
  d: "M149.383 250.787V267.708L152.315 266.513V249.593L149.383 250.787Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.421308,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_794"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_599",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M152.345 249.588L134.923 233.249L111.419 242.815L149.387 250.772L152.345 249.588Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_795"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_600",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M149.387 250.772V267.649L111.419 259.673V242.815L149.387 250.772Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_796"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_797"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_798"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_601",
  d: "M111.46 242.854L87.9653 252.424V269.301L111.46 259.731V242.854Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_799"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_602",
  d: "M139.105 261.964L115.61 271.535V274.701L139.105 265.131V261.964Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.392376,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_800"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_603",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M139.128 261.962L111.482 242.841L87.9785 252.407L115.624 271.529L139.128 261.962Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_801"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_604",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M115.624 271.529V274.691L87.9785 269.265V252.407L115.624 271.529Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_802"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_803"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_605",
  d: "M87.9122 252.394L64.4175 261.964V278.841L87.9122 269.271V252.394Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_804"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_606",
  d: "M102.394 269.927V286.848L105.326 285.653V268.732L102.394 269.927Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.421308,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_805"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_607",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M105.356 268.728L87.9338 252.389L64.4299 261.955L102.398 269.912L105.356 268.728Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_806"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_608",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M102.398 269.912V286.789L64.4302 278.813V261.955L102.398 269.912Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_807"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_808"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_609",
  d: "M64.471 261.994L40.9763 271.564V288.441L64.471 278.871V261.994Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_809"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_610",
  d: "M92.1158 281.105L68.6211 290.675V293.841L92.1158 284.271V281.105Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.392376,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_810"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_611",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M92.138 281.102L64.4924 261.981L40.9885 271.547L68.6342 290.669L92.138 281.102Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_811"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_612",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M68.6342 290.669V293.831L40.9885 288.405V271.547L68.6342 290.669Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_812"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_813"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_613",
  d: "M40.9224 271.536L17.4277 281.106V297.983L40.9224 288.412V271.536Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_814"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_614",
  d: "M55.405 289.068V305.989L58.3373 304.794V287.874L55.405 289.068Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.421308,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_815"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_615",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M58.3677 287.869L40.9453 271.53L17.4414 281.096L55.4092 289.053L58.3677 287.869Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_816"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_616",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M55.4092 289.053V305.93L17.4414 297.954L17.4414 281.096L55.4092 289.053Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_817"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_818"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_617",
  d: "M394.076 110.554L370.581 120.124V137.001L394.076 127.431V110.554Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_819"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_618",
  d: "M408.558 128.086V145.007L411.49 143.813V126.892L408.558 128.086Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.421308,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_820"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_619",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M411.52 126.888L394.098 110.549L370.594 120.115L408.562 128.071L411.52 126.888Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_821"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_620",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M408.562 128.072V144.949L370.594 136.972V120.115L408.562 128.072Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_822"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_823"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_621",
  d: "M369.899 120.453L346.404 130.023V146.9L369.899 137.33V120.453Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_824"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_622",
  d: "M397.544 139.564L374.049 149.134V152.301L397.544 142.73V139.564Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.392376,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_825"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_623",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M397.566 139.562L369.92 120.44L346.416 130.007L374.062 149.128L397.566 139.562Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_826"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_624",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M374.062 149.128V152.291L346.416 146.864V130.007L374.062 149.128Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_827"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_828"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_625",
  d: "M346.352 129.994L322.857 139.564V156.441L346.352 146.871V129.994Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_829"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_626",
  d: "M360.833 147.526V164.447L363.766 163.252V146.332L360.833 147.526Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.421308,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_830"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_627",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M363.796 146.328L346.374 129.989L322.87 139.555L360.838 147.511L363.796 146.328Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_831"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_628",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M360.838 147.511V164.389L322.87 156.412V139.555L360.838 147.511Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_832"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_833"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_834"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_629",
  d: "M322.91 139.594L299.415 149.164V166.041L322.91 156.471V139.594Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_835"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_630",
  d: "M350.555 158.704L327.061 168.275V171.441L350.555 161.871V158.704Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.392376,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_836"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_631",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M350.577 158.702L322.931 139.581L299.427 149.147L327.073 168.268L350.577 158.702Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_837"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_632",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M327.073 168.268V171.431L299.427 166.005V149.147L327.073 168.268Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_838"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_839"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_633",
  d: "M299.362 149.134L275.867 158.704V175.581L299.362 166.011V149.134Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_840"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_634",
  d: "M313.844 166.666V183.587L316.776 182.393V165.472L313.844 166.666Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.421308,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_841"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_635",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M316.806 165.468L299.383 149.129L275.879 158.695L313.847 166.652L316.806 165.468Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_842"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_636",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M313.848 166.651V183.529L275.88 175.552V158.695L313.848 166.651Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_843"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_844"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_845"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_637",
  d: "M275.921 158.734L252.427 168.304V185.181L275.921 175.611V158.734Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_846"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_638",
  d: "M303.566 177.845L280.072 187.415V190.581L303.566 181.011V177.845Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.392376,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_847"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_639",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M303.589 177.842L275.944 158.721L252.44 168.287L280.086 187.409L303.589 177.842Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_848"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_640",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M280.086 187.409V190.571L252.44 185.145V168.287L280.086 187.409Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_849"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_850"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_641",
  d: "M252.374 168.275L228.879 177.845V194.722L252.374 185.152V168.275Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_851"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_642",
  d: "M266.856 185.807V202.727L269.788 201.533V184.612L266.856 185.807Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.421308,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_852"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_643",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M269.818 184.608L252.395 168.269L228.892 177.835L266.859 185.792L269.818 184.608Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_853"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_644",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M266.859 185.792V202.669L228.892 194.693V177.835L266.859 185.792Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_854"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_855"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_856"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_645",
  d: "M228.932 177.874L205.438 187.444V204.321L228.932 194.751V177.874Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_857"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_646",
  d: "M256.577 196.985L233.083 206.555V209.721L256.577 200.151V196.985Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.392376,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_858"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_647",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M256.6 196.983L228.954 177.861L205.45 187.428L233.096 206.549L256.6 196.983Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_859"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_648",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M233.096 206.549V209.712L205.45 204.285V187.428L233.096 206.549Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_860"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_861"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_649",
  d: "M205.385 187.415L181.891 196.985V213.862L205.385 204.292V187.415Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_862"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_650",
  d: "M219.866 204.947V221.867L222.798 220.673V203.752L219.866 204.947Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.421308,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_863"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_651",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M222.829 203.748L205.407 187.409L181.903 196.976L219.871 204.932L222.829 203.748Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_864"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_652",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M219.871 204.932V221.809L181.903 213.833V196.976L219.871 204.932Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_865"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_866"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_867"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_653",
  d: "M181.943 197.014L158.448 206.585V223.462L181.943 213.891V197.014Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_868"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_654",
  d: "M209.588 216.125L186.093 225.696V228.862L209.588 219.292V216.125Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.392376,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_869"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_655",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M209.61 216.123L181.964 197.001L158.46 206.568L186.106 225.689L209.61 216.123Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_870"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_656",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M186.106 225.689V228.852L158.461 223.425V206.568L186.106 225.689Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_871"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_872"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_657",
  d: "M158.396 206.555L134.901 216.125V233.002L158.396 223.432V206.555Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_873"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_658",
  d: "M172.877 224.087V241.008L175.809 239.814V222.893L172.877 224.087Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.421308,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_874"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_659",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M175.84 222.888L158.417 206.549L134.913 216.116L172.881 224.072L175.84 222.888Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_875"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_660",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M172.881 224.072V240.949L134.913 232.973V216.116L172.881 224.072Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_876"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_877"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_878"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_661",
  d: "M134.954 216.155L111.46 225.725V242.602L134.954 233.032V216.155Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_879"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_662",
  d: "M162.599 235.266L139.104 244.836V248.002L162.599 238.432V235.266Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.392376,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_880"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_663",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M162.622 235.263L134.976 216.142L111.472 225.708L139.118 244.829L162.622 235.263Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_881"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_664",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M139.118 244.829V247.992L111.472 242.565V225.708L139.118 244.829Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_882"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_883"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_665",
  d: "M111.407 225.695L87.9121 235.265V252.142L111.407 242.572V225.695Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_884"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_666",
  d: "M125.889 243.227V260.148L128.821 258.953V242.033L125.889 243.227Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.421308,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_885"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_667",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M128.851 242.029L111.429 225.69L87.9248 235.256L125.893 243.213L128.851 242.029Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_886"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_668",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M125.893 243.213V260.09L87.9248 252.113V235.256L125.893 243.213Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_887"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_888"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_889"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_669",
  d: "M87.9649 235.295L64.4702 244.865V261.742L87.9649 252.172V235.295Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_890"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_670",
  d: "M115.61 254.406L92.1155 263.976V267.142L115.61 257.572V254.406Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.392376,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_891"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_671",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M115.632 254.403L87.9868 235.282L64.4829 244.848L92.1286 263.97L115.632 254.403Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_892"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_672",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M92.1286 263.97V267.132L64.4829 261.706V244.848L92.1286 263.97Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_893"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_894"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_673",
  d: "M64.4178 244.835L40.9231 254.406V271.283L64.4178 261.712V244.835Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_895"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_674",
  d: "M78.8987 262.368V279.288L81.831 278.094V261.173L78.8987 262.368Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.421308,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_896"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_675",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M81.8613 261.169L64.4389 244.83L40.9351 254.396L78.9028 262.353L81.8613 261.169Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_897"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_676",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M78.9031 262.353V279.23L40.9353 271.254V254.396L78.9031 262.353Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_898"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_899"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_677",
  d: "M40.9769 254.435L17.4822 264.005V280.882L40.9769 271.312V254.435Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_900"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_678",
  d: "M68.6212 273.546L45.1265 283.116V286.282L68.6212 276.712V273.546Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.392376,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_901"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_679",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M68.6434 273.543L40.9977 254.422L17.4939 263.988L45.1396 283.11L68.6434 273.543Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_902"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_680",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M45.1396 283.11V286.272L17.4939 280.846L17.4939 263.989L45.1396 283.11Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_903"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_904"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_905"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_681",
  d: "M393.395 93.0101L369.9 102.58V119.457L393.395 109.887V93.0101Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_906"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_682",
  d: "M421.04 112.121L397.545 121.691V124.857L421.04 115.287V112.121Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.392376,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_907"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_683",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M421.062 112.118L393.416 92.9971L369.912 102.563L397.558 121.685L421.062 112.118Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_908"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_684",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M397.558 121.685V124.847L369.912 119.421V102.564L397.558 121.685Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_909"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_910"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_685",
  d: "M369.846 102.551L346.351 112.121V128.998L369.846 119.428V102.551Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_911"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_686",
  d: "M384.328 120.083V137.004L387.26 135.809V118.889L384.328 120.083Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.421308,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_912"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_687",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M387.291 118.884L369.868 102.545L346.364 112.112L384.332 120.068L387.291 118.884Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_913"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_688",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M384.332 120.068V136.945L346.364 128.969V112.111L384.332 120.068Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_914"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_915"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_916"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_689",
  d: "M346.406 112.151L322.911 121.721V138.598L346.406 129.027V112.151Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_917"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_690",
  d: "M374.051 131.261L350.557 140.832V143.998L374.051 134.428V131.261Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.392376,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_918"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_691",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M374.074 131.259L346.429 112.138L322.925 121.704L350.57 140.825L374.074 131.259Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_919"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_692",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M350.57 140.825V143.988L322.925 138.561V121.704L350.57 140.825Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_920"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_921"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_693",
  d: "M322.858 121.691L299.364 131.261V148.138L322.858 138.568V121.691Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_922"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_694",
  d: "M337.341 139.223V156.144L340.273 154.95V138.029L337.341 139.223Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.421308,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_923"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_695",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M340.303 138.025L322.881 121.686L299.377 131.252L337.345 139.208L340.303 138.025Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_924"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_696",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M337.345 139.208V156.086L299.377 148.109V131.252L337.345 139.208Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_925"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_926"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_927"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_697",
  d: "M299.417 131.291L275.922 140.861V157.738L299.417 148.168V131.291Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_928"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_698",
  d: "M327.062 150.402L303.567 159.972V163.138L327.062 153.568V150.402Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.392376,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_929"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_699",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M327.084 150.399L299.438 131.278L275.935 140.844L303.58 159.965L327.084 150.399Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_930"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_700",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M303.58 159.966V163.128L275.934 157.702V140.844L303.58 159.966Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_931"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_932"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_701",
  d: "M275.869 140.831L252.374 150.401V167.278L275.869 157.708V140.831Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_933"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_702",
  d: "M290.35 158.363V175.284L293.282 174.09V157.169L290.35 158.363Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.421308,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_934"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_703",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M293.313 157.165L275.891 140.826L252.387 150.392L290.354 158.349L293.313 157.165Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_935"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_704",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M290.354 158.349V175.226L252.387 167.25V150.392L290.354 158.349Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_936"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_937"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_938"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_705",
  d: "M252.426 150.431L228.932 160.001V176.878L252.426 167.308V150.431Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_939"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_706",
  d: "M280.071 169.542L256.577 179.112V182.278L280.071 172.708V169.542Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.392376,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_940"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_707",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M280.095 169.539L252.449 150.418L228.945 159.984L256.591 179.106L280.095 169.539Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_941"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_708",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M256.591 179.106V182.268L228.945 176.842V159.984L256.591 179.106Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_942"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_943"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_709",
  d: "M228.879 159.971L205.385 169.542V186.419L228.879 176.848V159.971Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_944"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_710",
  d: "M243.361 177.504V194.425L246.294 193.23V176.31L243.361 177.504Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.421308,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_945"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_711",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M246.324 176.305L228.902 159.966L205.398 169.532L243.366 177.489L246.324 176.305Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_946"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_712",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M243.366 177.488V194.366L205.398 186.389V169.532L243.366 177.488Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_947"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_948"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_949"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_713",
  d: "M205.438 169.571L181.943 179.141V196.018L205.438 186.448V169.571Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_950"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_714",
  d: "M233.082 188.682L209.588 198.252V201.419L233.082 191.848V188.682Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.392376,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_951"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_715",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M233.105 188.679L205.459 169.558L181.955 179.125L209.601 198.246L233.105 188.679Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_952"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_716",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M209.601 198.246V201.408L181.956 195.982V179.125L209.601 198.246Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_953"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_954"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_717",
  d: "M181.891 179.112L158.396 188.682V205.559L181.891 195.989V179.112Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_955"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_718",
  d: "M196.372 196.644V213.564L199.304 212.37V195.449L196.372 196.644Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.421308,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_956"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_719",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M199.334 195.445L181.912 179.106L158.408 188.673L196.376 196.629L199.334 195.445Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_957"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_720",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M196.376 196.629V213.506L158.408 205.53V188.673L196.376 196.629Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_958"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_959"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_960"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_721",
  d: "M158.449 188.712L134.955 198.282V215.159L158.449 205.589V188.712Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_961"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_722",
  d: "M186.094 207.822L162.599 217.393V220.559L186.094 210.989V207.822Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.392376,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_962"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_723",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M186.117 207.82L158.471 188.699L134.967 198.265L162.613 217.386L186.117 207.82Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_963"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_724",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M162.613 217.386V220.549L134.967 215.123V198.265L162.613 217.386Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_964"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_965"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_725",
  d: "M134.902 198.252L111.407 207.822V224.699L134.902 215.129V198.252Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_966"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_726",
  d: "M149.383 215.784V232.705L152.315 231.511V214.59L149.383 215.784Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.421308,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_967"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_727",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M152.345 214.585L134.923 198.246L111.419 207.813L149.387 215.769L152.345 214.585Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_968"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_728",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M149.387 215.769V232.647L111.419 224.67V207.813L149.387 215.769Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_969"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_970"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_971"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_729",
  d: "M111.46 207.851L87.9653 217.421V234.298L111.46 224.728V207.851Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_972"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_730",
  d: "M139.105 226.962L115.61 236.532V239.698L139.105 230.128V226.962Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.392376,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_973"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_731",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M139.128 226.96L111.482 207.839L87.9785 217.405L115.624 236.526L139.128 226.96Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_974"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_732",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M115.624 236.526V239.689L87.9785 234.262V217.405L115.624 236.526Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_975"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_976"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_733",
  d: "M87.9122 217.392L64.4175 226.962V243.839L87.9122 234.269V217.392Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_977"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_734",
  d: "M102.394 234.924V251.845L105.326 250.651V233.73L102.394 234.924Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.421308,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_978"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_735",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M105.356 233.726L87.9338 217.387L64.4299 226.953L102.398 234.909L105.356 233.726Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_979"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_736",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M102.398 234.909V251.787L64.4302 243.81V226.953L102.398 234.909Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_980"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_981"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_737",
  d: "M64.471 226.992L40.9763 236.562V253.439L64.471 243.869V226.992Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_982"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_738",
  d: "M92.1158 246.102L68.6211 255.672V258.839L92.1158 249.269V246.102Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.392376,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_983"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_739",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M92.138 246.1L64.4924 226.979L40.9885 236.545L68.6342 255.666L92.138 246.1Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_984"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_740",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M68.6342 255.666V258.829L40.9885 253.403V236.545L68.6342 255.666Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_985"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_986"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_741",
  d: "M40.9224 236.533L17.4277 246.103V262.98L40.9224 253.41V236.533Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_987"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_742",
  d: "M55.405 254.065V270.986L58.3373 269.791V252.871L55.405 254.065Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.421308,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_988"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_743",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M58.3677 252.866L40.9453 236.527L17.4414 246.094L55.4092 254.05L58.3677 252.866Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_989"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_744",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M55.4092 254.05V270.927L17.4414 262.951L17.4414 246.094L55.4092 254.05Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_990"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_991"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_745",
  d: "M394.076 75.5516L370.581 85.1218V101.999L394.076 92.4286V75.5516Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_992"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_746",
  d: "M408.558 93.0839V110.005L411.49 108.81V91.8895L408.558 93.0839Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.421308,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_993"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_747",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M411.52 91.8852L394.098 75.5462L370.594 85.1125L408.562 93.069L411.52 91.8852Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_994"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_748",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M408.562 93.0691V109.946L370.594 101.97V85.1126L408.562 93.0691Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_995"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_996"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_749",
  d: "M369.899 85.4509L346.404 95.0211V111.898L369.899 102.328V85.4509Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_997"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_750",
  d: "M397.544 104.562L374.049 114.132V117.298L397.544 107.728V104.562Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.392376,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_998"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_751",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M397.566 104.559L369.92 85.438L346.416 95.0044L374.062 114.126L397.566 104.559Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_999"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_752",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M374.062 114.126V117.288L346.416 111.862V95.0045L374.062 114.126Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1000"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1001"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_753",
  d: "M346.352 94.9918L322.857 104.562V121.439L346.352 111.869V94.9918Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1002"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_754",
  d: "M360.833 112.524V129.445L363.766 128.25V111.33L360.833 112.524Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.421308,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1003"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_755",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M363.796 111.325L346.374 94.9861L322.87 104.552L360.838 112.509L363.796 111.325Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1004"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_756",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M360.838 112.509V129.386L322.87 121.41V104.553L360.838 112.509Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1005"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1006"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1007"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_757",
  d: "M322.91 104.591L299.415 114.161V131.038L322.91 121.468V104.591Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1008"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_758",
  d: "M350.555 123.702L327.061 133.272V136.438L350.555 126.868V123.702Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.392376,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1009"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_759",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M350.577 123.7L322.931 104.578L299.427 114.145L327.073 133.266L350.577 123.7Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1010"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_760",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M327.073 133.266V136.428L299.427 131.002V114.145L327.073 133.266Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1011"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1012"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_761",
  d: "M299.362 114.132L275.867 123.702V140.579L299.362 131.009V114.132Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1013"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_762",
  d: "M313.844 131.664V148.585L316.776 147.39V130.469L313.844 131.664Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.421308,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1014"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_763",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M316.806 130.465L299.383 114.126L275.879 123.693L313.847 131.649L316.806 130.465Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1015"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_764",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M313.848 131.649V148.526L275.88 140.55V123.693L313.848 131.649Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1016"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1017"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1018"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_765",
  d: "M275.921 123.731L252.427 133.302V150.179L275.921 140.608V123.731Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1019"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_766",
  d: "M303.566 142.842L280.072 152.413V155.579L303.566 146.009V142.842Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.392376,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1020"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_767",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M303.589 142.84L275.944 123.719L252.44 133.285L280.086 152.406L303.589 142.84Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1021"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_768",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M280.086 152.406V155.569L252.44 150.142V133.285L280.086 152.406Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1022"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1023"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_769",
  d: "M252.374 133.272L228.879 142.842V159.719L252.374 150.149V133.272Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1024"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_770",
  d: "M266.856 150.805V167.725L269.788 166.531V149.61L266.856 150.805Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.421308,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1025"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_771",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M269.818 149.606L252.395 133.267L228.892 142.833L266.859 150.789L269.818 149.606Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1026"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_772",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M266.859 150.79V167.667L228.892 159.691V142.833L266.859 150.79Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1027"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1028"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1029"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_773",
  d: "M228.932 142.871L205.438 152.442V169.319L228.932 159.748V142.871Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1030"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_774",
  d: "M256.577 161.982L233.083 171.553V174.719L256.577 165.149V161.982Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.392376,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1031"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_775",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M256.6 161.98L228.954 142.859L205.45 152.425L233.096 171.546L256.6 161.98Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1032"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_776",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M233.096 171.546V174.709L205.45 169.283V152.425L233.096 171.546Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1033"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1034"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_777",
  d: "M205.385 152.412L181.891 161.982V178.859L205.385 169.289V152.412Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1035"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_778",
  d: "M219.866 169.945V186.865L222.798 185.671V168.75L219.866 169.945Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.421308,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1036"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_779",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M222.829 168.746L205.407 152.407L181.903 161.973L219.871 169.93L222.829 168.746Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1037"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_780",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M219.871 169.93V186.807L181.903 178.831V161.973L219.871 169.93Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1038"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1039"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1040"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_781",
  d: "M181.943 162.012L158.448 171.582V188.459L181.943 178.889V162.012Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1041"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_782",
  d: "M209.588 181.123L186.093 190.693V193.859L209.588 184.289V181.123Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.392376,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1042"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_783",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M209.61 181.12L181.964 161.999L158.46 171.565L186.106 190.687L209.61 181.12Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1043"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_784",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M186.106 190.687V193.849L158.461 188.423V171.565L186.106 190.687Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1044"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1045"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_785",
  d: "M158.396 171.553L134.901 181.123V198L158.396 188.43V171.553Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1046"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_786",
  d: "M172.877 189.085V206.006L175.809 204.811V187.89L172.877 189.085Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.421308,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1047"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_787",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M175.84 187.886L158.417 171.547L134.913 181.113L172.881 189.07L175.84 187.886Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1048"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_788",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M172.881 189.07V205.947L134.913 197.971V181.113L172.881 189.07Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1049"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1050"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1051"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_789",
  d: "M134.954 181.152L111.46 190.722V207.599L134.954 198.029V181.152Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1052"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_790",
  d: "M162.599 200.263L139.104 209.833V212.999L162.599 203.429V200.263Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.392376,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1053"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_791",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M162.622 200.26L134.976 181.139L111.472 190.705L139.118 209.827L162.622 200.26Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1054"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_792",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M139.118 209.827V212.989L111.472 207.563V190.705L139.118 209.827Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1055"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1056"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_793",
  d: "M111.407 190.693L87.9121 200.263V217.14L111.407 207.57V190.693Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1057"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_794",
  d: "M125.889 208.225V225.145L128.821 223.951V207.03L125.889 208.225Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.421308,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1058"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_795",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M128.851 207.026L111.429 190.687L87.9248 200.253L125.893 208.21L128.851 207.026Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1059"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_796",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M125.893 208.21V225.087L87.9248 217.111V200.253L125.893 208.21Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1060"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1061"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1062"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_797",
  d: "M87.9649 200.292L64.4702 209.863V226.739L87.9649 217.169V200.292Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1063"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_798",
  d: "M115.61 219.403L92.1155 228.974V232.14L115.61 222.57V219.403Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.392376,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1064"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_799",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M115.632 219.401L87.9868 200.279L64.4829 209.846L92.1286 228.967L115.632 219.401Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1065"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_800",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M92.1286 228.967V232.13L64.4829 226.704V209.846L92.1286 228.967Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1066"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1067"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_801",
  d: "M64.4178 209.833L40.9231 219.403V236.28L64.4178 226.71V209.833Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1068"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_802",
  d: "M78.8987 227.365V244.286L81.831 243.091V226.171L78.8987 227.365Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.421308,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1069"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_803",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M81.8613 226.167L64.4389 209.828L40.9351 219.394L78.9028 227.35L81.8613 226.167Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1070"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_804",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M78.9031 227.35V244.228L40.9353 236.251V219.394L78.9031 227.35Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1071"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1072"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_805",
  d: "M40.9769 219.433L17.4822 229.003V245.88L40.9769 236.31V219.433Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1073"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_806",
  d: "M68.6212 238.544L45.1265 248.114V251.28L68.6212 241.71V238.544Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.392376,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1074"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_807",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M68.6434 238.541L40.9977 219.42L17.4939 228.986L45.1396 248.107L68.6434 238.541Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1075"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_808",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M45.1396 248.108V251.27L17.4939 245.844L17.4939 228.986L45.1396 248.108Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1076"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1077"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1078"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_809",
  d: "M393.395 58.006L369.9 67.5762V84.4531L393.395 74.8829V58.006Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1079"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_810",
  d: "M421.04 77.117L397.545 86.6871V89.8533L421.04 80.2832V77.117Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.392376,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1080"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_811",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M421.062 77.1143L393.416 57.993L369.912 67.5593L397.558 86.6806L421.062 77.1143Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1081"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_812",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M397.558 86.6807V89.8432L369.912 84.4168V67.5593L397.558 86.6807Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1082"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1083"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_813",
  d: "M369.846 67.5468L346.351 77.1169V93.9939L369.846 84.4237V67.5468Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1084"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_814",
  d: "M384.328 85.079V102L387.26 100.805V83.8846L384.328 85.079Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.421308,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1085"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_815",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M387.291 83.8801L369.868 67.5411L346.364 77.1074L384.332 85.0639L387.291 83.8801Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1086"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_816",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M384.332 85.0638V101.941L346.364 93.9648V77.1073L384.332 85.0638Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1087"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1088"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1089"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_817",
  d: "M346.406 77.1464L322.911 86.7166V103.593L346.406 94.0233V77.1464Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1090"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_818",
  d: "M374.051 96.2573L350.557 105.828V108.994L374.051 99.4235V96.2573Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.392376,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1091"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_819",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M374.074 96.2548L346.429 77.1335L322.925 86.6998L350.57 105.821L374.074 96.2548Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1092"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_820",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M350.57 105.821V108.984L322.925 103.557V86.7L350.57 105.821Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1093"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1094"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_821",
  d: "M322.858 86.6869L299.364 96.2571V113.134L322.858 103.564V86.6869Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1095"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_822",
  d: "M337.341 104.219V121.14L340.273 119.945V103.025L337.341 104.219Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.421308,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1096"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_823",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M340.303 103.02L322.881 86.6813L299.377 96.2477L337.345 104.204L340.303 103.02Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1097"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_824",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M337.345 104.204V121.081L299.377 113.105V96.2477L337.345 104.204Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1098"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1099"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1100"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_825",
  d: "M299.417 96.2863L275.922 105.856V122.733L299.417 113.163V96.2863Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1101"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_826",
  d: "M327.062 115.397L303.567 124.967V128.134L327.062 118.563V115.397Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.392376,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1102"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_827",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M327.084 115.395L299.438 96.2734L275.935 105.84L303.58 124.961L327.084 115.395Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1103"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_828",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M303.58 124.961V128.124L275.934 122.697V105.84L303.58 124.961Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1104"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1105"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_829",
  d: "M275.869 105.827L252.374 115.397V132.274L275.869 122.704V105.827Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1106"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_830",
  d: "M290.35 123.359V140.28L293.282 139.085V122.165L290.35 123.359Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.421308,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1107"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_831",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M293.313 122.16L275.891 105.821L252.387 115.388L290.354 123.344L293.313 122.16Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1108"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_832",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M290.354 123.344V140.222L252.387 132.245V115.388L290.354 123.344Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1109"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1110"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1111"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_833",
  d: "M252.426 115.427L228.932 124.997V141.874L252.426 132.304V115.427Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1112"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_834",
  d: "M280.071 134.538L256.577 144.108V147.274L280.071 137.704V134.538Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.392376,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1113"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_835",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M280.095 134.535L252.449 115.414L228.945 124.98L256.591 144.102L280.095 134.535Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1114"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_836",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M256.591 144.102V147.264L228.945 141.838V124.98L256.591 144.102Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1115"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1116"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_837",
  d: "M228.879 124.967L205.385 134.538V151.415L228.879 141.844V124.967Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1117"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_838",
  d: "M243.361 142.499V159.42L246.294 158.226V141.305L243.361 142.499Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.421308,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1118"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_839",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M246.324 141.301L228.902 124.962L205.398 134.528L243.366 142.485L246.324 141.301Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1119"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_840",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M243.366 142.484V159.362L205.398 151.385V134.528L243.366 142.484Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1120"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1121"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1122"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_841",
  d: "M205.438 134.567L181.943 144.137V161.014L205.438 151.444V134.567Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1123"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_842",
  d: "M233.082 153.678L209.588 163.248V166.414L233.082 156.844V153.678Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.392376,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1124"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_843",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M233.105 153.675L205.459 134.554L181.955 144.12L209.601 163.241L233.105 153.675Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1125"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_844",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M209.601 163.242V166.404L181.956 160.978V144.12L209.601 163.242Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1126"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1127"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_845",
  d: "M181.891 144.108L158.396 153.678V170.555L181.891 160.984V144.108Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1128"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_846",
  d: "M196.372 161.64V178.561L199.304 177.366V160.446L196.372 161.64Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.421308,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1129"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_847",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M199.334 160.441L181.912 144.102L158.408 153.668L196.376 161.625L199.334 160.441Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1130"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_848",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M196.376 161.625V178.502L158.408 170.526V153.668L196.376 161.625Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1131"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1132"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1133"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_849",
  d: "M158.449 153.707L134.955 163.277V180.154L158.449 170.584V153.707Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1134"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_850",
  d: "M186.094 172.818L162.599 182.388V185.554L186.094 175.984V172.818Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.392376,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1135"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_851",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M186.117 172.816L158.471 153.694L134.967 163.261L162.613 182.382L186.117 172.816Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1136"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_852",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M162.613 182.382V185.545L134.967 180.118V163.261L162.613 182.382Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1137"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1138"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_853",
  d: "M134.902 163.248L111.407 172.818V189.695L134.902 180.125V163.248Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1139"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_854",
  d: "M149.383 180.78V197.7L152.315 196.506V179.585L149.383 180.78Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.421308,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1140"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_855",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M152.345 179.581L134.923 163.242L111.419 172.809L149.387 180.765L152.345 179.581Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1141"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_856",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M149.387 180.765V197.643L111.419 189.666V172.809L149.387 180.765Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1142"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1143"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1144"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_857",
  d: "M111.46 172.847L87.9653 182.417V199.294L111.46 189.724V172.847Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1145"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_858",
  d: "M139.105 191.958L115.61 201.528V204.694L139.105 195.124V191.958Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.392376,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1146"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_859",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M139.128 191.956L111.482 172.834L87.9785 182.401L115.624 201.522L139.128 191.956Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1147"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_860",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M115.624 201.522V204.685L87.9785 199.258V182.401L115.624 201.522Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1148"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1149"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_861",
  d: "M87.9122 182.388L64.4175 191.958V208.835L87.9122 199.265V182.388Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1150"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_862",
  d: "M102.394 199.92V216.841L105.326 215.646V198.725L102.394 199.92Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.421308,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1151"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_863",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M105.356 198.721L87.9338 182.382L64.4299 191.948L102.398 199.905L105.356 198.721Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1152"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_864",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M102.398 199.905V216.782L64.4302 208.806V191.949L102.398 199.905Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1153"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1154"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_865",
  d: "M64.471 191.987L40.9763 201.558V218.435L64.471 208.864V191.987Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1155"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_866",
  d: "M92.1158 211.098L68.6211 220.669V223.835L92.1158 214.265V211.098Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.392376,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1156"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_867",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M92.138 211.096L64.4924 191.974L40.9885 201.541L68.6342 220.662L92.138 211.096Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1157"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_868",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M68.6342 220.662V223.825L40.9885 218.398V201.541L68.6342 220.662Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1158"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1159"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_869",
  d: "M40.9224 201.529L17.4277 211.099V227.976L40.9224 218.406V201.529Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1160"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_870",
  d: "M55.405 219.061V235.982L58.3373 234.788V217.867L55.405 219.061Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.421308,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1161"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_871",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M58.3677 217.862L40.9453 201.523L17.4414 211.09L55.4092 219.046L58.3677 217.862Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1162"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_872",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M55.4092 219.046V235.924L17.4414 227.947L17.4414 211.09L55.4092 219.046Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1163"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1164"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_873",
  d: "M394.076 40.5476L370.581 50.1178V66.9947L394.076 57.4246V40.5476Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1165"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_874",
  d: "M408.558 58.0794V75.0001L411.49 73.8057V56.885L408.558 58.0794Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.421308,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1166"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_875",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M411.52 56.8809L394.098 40.5419L370.594 50.1083L408.562 58.0647L411.52 56.8809Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1167"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_876",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M408.562 58.0647V74.942L370.594 66.9657V50.1082L408.562 58.0647Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1168"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1169"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_877",
  d: "M369.899 50.4467L346.404 60.0168V76.8938L369.899 67.3236V50.4467Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1170"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_878",
  d: "M397.544 69.5576L374.049 79.1278V82.294L397.544 72.7238V69.5576Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.392376,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1171"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_879",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M397.566 69.5553L369.92 50.434L346.416 60.0004L374.062 79.1217L397.566 69.5553Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1172"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_880",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M374.062 79.1217V82.2842L346.416 76.8578V60.0004L374.062 79.1217Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1173"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1174"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_881",
  d: "M346.352 59.9872L322.857 69.5574V86.4343L346.352 76.8641V59.9872Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1175"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_882",
  d: "M360.833 77.5197V94.4404L363.766 93.246V76.3253L360.833 77.5197Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.421308,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1176"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_883",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M363.796 76.3208L346.374 59.9818L322.87 69.5481L360.838 77.5046L363.796 76.3208Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1177"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_884",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M360.838 77.5046V94.3819L322.87 86.4056V69.5481L360.838 77.5046Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1178"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1179"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1180"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_885",
  d: "M322.91 69.5869L299.415 79.1571V96.034L322.91 86.4639V69.5869Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1181"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_886",
  d: "M350.555 88.6978L327.061 98.2679V101.434L350.555 91.864V88.6978Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.392376,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1182"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_887",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M350.577 88.6954L322.931 69.574L299.427 79.1404L327.073 98.2617L350.577 88.6954Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1183"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_888",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M327.073 98.2616V101.424L299.427 95.9977V79.1403L327.073 98.2616Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1184"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1185"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_889",
  d: "M299.362 79.1275L275.867 88.6976V105.575L299.362 96.0044V79.1275Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1186"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_890",
  d: "M313.844 96.6594V113.58L316.776 112.386V95.465L313.844 96.6594Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.421308,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1187"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_891",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M316.806 95.4609L299.383 79.1219L275.879 88.6882L313.847 96.6447L316.806 95.4609Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1188"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_892",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M313.848 96.6448V113.522L275.88 105.546V88.6883L313.848 96.6448Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1189"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1190"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1191"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_893",
  d: "M275.921 88.7273L252.427 98.2975V115.174L275.921 105.604V88.7273Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1192"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_894",
  d: "M303.566 107.838L280.072 117.408V120.574L303.566 111.004V107.838Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.392376,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1193"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_895",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M303.589 107.836L275.944 88.7142L252.44 98.2805L280.086 117.402L303.589 107.836Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1194"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_896",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M280.086 117.402V120.565L252.44 115.138V98.2806L280.086 117.402Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1195"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1196"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_897",
  d: "M252.374 98.268L228.879 107.838V124.715L252.374 115.145V98.268Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1197"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_898",
  d: "M266.856 115.8V132.721L269.788 131.526V114.606L266.856 115.8Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.421308,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1198"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_899",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M269.818 114.602L252.395 98.2625L228.892 107.829L266.859 115.785L269.818 114.602Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1199"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_900",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M266.859 115.785V132.662L228.892 124.686V107.829L266.859 115.785Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1200"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1201"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1202"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_901",
  d: "M228.932 107.867L205.438 117.438V134.314L228.932 124.744V107.867Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1203"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_902",
  d: "M256.577 126.978L233.083 136.549V139.715L256.577 130.145V126.978Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.392376,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1204"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_903",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M256.6 126.976L228.954 107.854L205.45 117.421L233.096 136.542L256.6 126.976Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1205"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_904",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M233.096 136.542V139.705L205.45 134.278V117.421L233.096 136.542Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1206"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1207"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_905",
  d: "M205.385 117.408L181.891 126.978V143.855L205.385 134.285V117.408Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1208"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_906",
  d: "M219.866 134.94V151.861L222.798 150.666V133.746L219.866 134.94Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.421308,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1209"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_907",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M222.829 133.742L205.407 117.403L181.903 126.969L219.871 134.926L222.829 133.742Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1210"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_908",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M219.871 134.925V151.803L181.903 143.826V126.969L219.871 134.925Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1211"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1212"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1213"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_909",
  d: "M181.943 127.008L158.448 136.578V153.455L181.943 143.885V127.008Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1214"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_910",
  d: "M209.588 146.119L186.093 155.689V158.855L209.588 149.285V146.119Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.392376,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1215"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_911",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M209.61 146.116L181.964 126.995L158.46 136.561L186.106 155.682L209.61 146.116Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1216"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_912",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M186.106 155.682V158.845L158.461 153.419V136.561L186.106 155.682Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1217"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1218"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_913",
  d: "M158.396 136.548L134.901 146.119V162.996L158.396 153.425V136.548Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1219"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_914",
  d: "M172.877 154.081V171.001L175.809 169.807V152.886L172.877 154.081Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.421308,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1220"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_915",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M175.84 152.882L158.417 136.543L134.913 146.109L172.881 154.065L175.84 152.882Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1221"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_916",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M172.881 154.065V170.943L134.913 162.966V146.109L172.881 154.065Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1222"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1223"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1224"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_917",
  d: "M134.954 146.148L111.46 155.718V172.595L134.954 163.025V146.148Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1225"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_918",
  d: "M162.599 165.259L139.104 174.829V177.995L162.599 168.425V165.259Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.392376,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1226"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_919",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M162.622 165.256L134.976 146.135L111.472 155.701L139.118 174.823L162.622 165.256Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1227"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_920",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M139.118 174.823V177.985L111.472 172.559V155.701L139.118 174.823Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1228"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1229"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_921",
  d: "M111.407 155.689L87.9121 165.259V182.136L111.407 172.566V155.689Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1230"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_922",
  d: "M125.889 173.221V190.141L128.821 188.947V172.026L125.889 173.221Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.421308,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1231"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_923",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M128.851 172.022L111.429 155.683L87.9248 165.249L125.893 173.206L128.851 172.022Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1232"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_924",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M125.893 173.206V190.083L87.9248 182.107V165.249L125.893 173.206Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1233"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1234"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1235"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_925",
  d: "M87.9649 165.288L64.4702 174.858V191.735L87.9649 182.165V165.288Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1236"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_926",
  d: "M115.61 184.399L92.1155 193.969V197.136L115.61 187.565V184.399Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.392376,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1237"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_927",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M115.632 184.397L87.9868 165.275L64.4829 174.842L92.1286 193.963L115.632 184.397Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1238"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_928",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M92.1286 193.963V197.126L64.4829 191.699V174.842L92.1286 193.963Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1239"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1240"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_929",
  d: "M64.4178 174.829L40.9231 184.399V201.276L64.4178 191.706V174.829Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1241"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_930",
  d: "M78.8987 192.361V209.282L81.831 208.087V191.166L78.8987 192.361Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.421308,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1242"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_931",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M81.8613 191.162L64.4389 174.823L40.9351 184.39L78.9028 192.346L81.8613 191.162Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1243"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_932",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M78.9031 192.346V209.223L40.9353 201.247V184.39L78.9031 192.346Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1244"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1245"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_933",
  d: "M40.9769 184.428L17.4822 193.999V210.876L40.9769 201.305V184.428Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1246"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_934",
  d: "M68.6212 203.539L45.1265 213.11V216.276L68.6212 206.706V203.539Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.392376,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1247"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_935",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M68.6434 203.537L40.9977 184.415L17.4939 193.982L45.1396 213.103L68.6434 203.537Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1248"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_936",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M45.1396 213.103V216.266L17.4939 210.839L17.4939 193.982L45.1396 213.103Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1249"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1250"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1251"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_937",
  d: "M393.395 23.7463L369.9 33.3165V50.1935L393.395 40.6233V23.7463Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1252"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_938",
  d: "M421.04 42.8573L397.545 52.4275V55.5937L421.04 46.0235V42.8573Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.392376,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1253"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_939",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M421.062 42.8545L393.416 23.7332L369.912 33.2996L397.558 52.4209L421.062 42.8545Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1254"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_940",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M397.558 52.4209V55.5834L369.912 50.157V33.2996L397.558 52.4209Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1255"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1256"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_941",
  d: "M369.845 33.2869L346.351 42.8571V59.734L369.845 50.1638V33.2869Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1257"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_942",
  d: "M384.327 50.819V67.7397L387.259 66.5453V49.6246L384.327 50.819Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.421308,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1258"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_943",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M387.29 49.6203L369.868 33.2813L346.364 42.8476L384.332 50.8041L387.29 49.6203Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1259"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_944",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M384.332 50.8039V67.6812L346.364 59.7049V42.8475L384.332 50.8039Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1260"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1261"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1262"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_945",
  d: "M346.406 42.8866L322.912 52.4568V69.3337L346.406 59.7635V42.8866Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1263"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_946",
  d: "M374.052 61.9972L350.557 71.5674V74.7336L374.052 65.1634V61.9972Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.392376,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1264"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_947",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M374.075 61.9948L346.429 42.8735L322.925 52.4398L350.571 71.5611L374.075 61.9948Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1265"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_948",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M350.571 71.5613V74.7238L322.925 69.2974V52.4399L350.571 71.5613Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1266"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1267"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_949",
  d: "M322.858 52.4271L299.364 61.9973V78.8743L322.858 69.3041V52.4271Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1268"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_950",
  d: "M337.341 69.9593V86.88L340.273 85.6856V68.7649L337.341 69.9593Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.421308,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1269"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_951",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M340.303 68.7606L322.881 52.4216L299.377 61.9879L337.345 69.9444L340.303 68.7606Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1270"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_952",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M337.345 69.9442V86.8215L299.377 78.8452V61.9877L337.345 69.9442Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1271"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1272"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1273"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_953",
  d: "M299.417 62.0266L275.922 71.5968V88.4737L299.417 78.9036V62.0266Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1274"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_954",
  d: "M327.061 81.1376L303.566 90.7078V93.874L327.061 84.3038V81.1376Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.392376,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1275"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_955",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M327.084 81.1352L299.438 62.0139L275.934 71.5802L303.58 90.7015L327.084 81.1352Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1276"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_956",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M303.579 90.7014V93.864L275.934 88.4375V71.5801L303.579 90.7014Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1277"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1278"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_957",
  d: "M275.869 71.5671L252.374 81.1373V98.0143L275.869 88.4441V71.5671Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1279"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_958",
  d: "M290.35 89.0997V106.02L293.282 104.826V87.9053L290.35 89.0997Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.421308,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1280"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_959",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M293.313 87.9008L275.891 71.5618L252.387 81.1282L290.354 89.0846L293.313 87.9008Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1281"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_960",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M290.354 89.0846V105.962L252.387 97.9856V81.1281L290.354 89.0846Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1282"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1283"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1284"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_961",
  d: "M252.427 81.1669L228.932 90.7371V107.614L252.427 98.0438V81.1669Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1285"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_962",
  d: "M280.072 100.277L256.577 109.848V113.014L280.072 103.444V100.277Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.392376,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1286"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_963",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M280.095 100.275L252.45 81.1537L228.946 90.7201L256.591 109.841L280.095 100.275Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1287"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_964",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M256.591 109.841V113.004L228.946 107.578V90.7201L256.591 109.841Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1288"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1289"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_965",
  d: "M228.879 90.7075L205.385 100.278V117.155L228.879 107.584V90.7075Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1290"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_966",
  d: "M243.361 108.239V125.16L246.294 123.966V107.045L243.361 108.239Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.421308,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1291"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_967",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M246.324 107.041L228.902 90.702L205.398 100.268L243.366 108.225L246.324 107.041Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1292"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_968",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M243.366 108.224V125.102L205.398 117.125V100.268L243.366 108.224Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1293"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1294"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1295"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_969",
  d: "M205.438 100.307L181.943 109.877V126.754L205.438 117.184V100.307Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1296"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_970",
  d: "M233.082 119.418L209.588 128.988V132.154L233.082 122.584V119.418Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.392376,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1297"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_971",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M233.105 119.416L205.459 100.294L181.955 109.861L209.601 128.982L233.105 119.416Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1298"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_972",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M209.601 128.982V132.144L181.956 126.718V109.86L209.601 128.982Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1299"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1300"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_973",
  d: "M181.891 109.848L158.396 119.418V136.295L181.891 126.725V109.848Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1301"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_974",
  d: "M196.372 127.38V144.301L199.304 143.106V126.185L196.372 127.38Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.421308,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1302"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_975",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M199.334 126.181L181.912 109.842L158.408 119.408L196.376 127.365L199.334 126.181Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1303"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_976",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M196.376 127.365V144.242L158.408 136.266V119.408L196.376 127.365Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1304"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1305"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1306"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_977",
  d: "M158.449 119.448L134.955 129.018V145.895L158.449 136.324V119.448Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1307"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_978",
  d: "M186.094 138.558L162.599 148.128V151.295L186.094 141.724V138.558Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.392376,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1308"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_979",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M186.117 138.556L158.471 119.435L134.967 129.001L162.613 148.122L186.117 138.556Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1309"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_980",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M162.613 148.122V151.285L134.967 145.858V129.001L162.613 148.122Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1310"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1311"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_981",
  d: "M134.902 128.988L111.407 138.558V155.435L134.902 145.865V128.988Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1312"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_982",
  d: "M149.383 146.52V163.441L152.315 162.247V145.326L149.383 146.52Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.421308,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1313"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_983",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M152.345 145.321L134.923 128.982L111.419 138.549L149.387 146.505L152.345 145.321Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1314"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_984",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M149.387 146.505V163.383L111.419 155.406V138.549L149.387 146.505Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1315"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1316"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1317"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_985",
  d: "M111.46 138.587L87.9653 148.157V165.034L111.46 155.464V138.587Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1318"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_986",
  d: "M139.105 157.698L115.61 167.268V170.434L139.105 160.864V157.698Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.392376,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1319"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_987",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M139.128 157.696L111.482 138.574L87.9785 148.141L115.624 167.262L139.128 157.696Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1320"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_988",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M115.624 167.262V170.425L87.9785 164.998V148.141L115.624 167.262Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1321"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1322"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_989",
  d: "M87.9122 148.128L64.4175 157.698V174.575L87.9122 165.005V148.128Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1323"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_990",
  d: "M102.394 165.66V182.581L105.326 181.387V164.466L102.394 165.66Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.421308,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1324"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_991",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M105.356 164.462L87.9338 148.122L64.4299 157.689L102.398 165.645L105.356 164.462Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1325"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_992",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M102.398 165.645V182.523L64.4302 174.546V157.689L102.398 165.645Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1326"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1327"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_993",
  d: "M64.471 157.728L40.9763 167.298V184.175L64.471 174.604V157.728Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1328"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_994",
  d: "M92.1158 176.839L68.6211 186.409V189.575L92.1158 180.005V176.839Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.392376,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1329"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_995",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M92.138 176.836L64.4924 157.715L40.9885 167.281L68.6342 186.402L92.138 176.836Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1330"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_996",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M68.6342 186.402V189.565L40.9885 184.139V167.281L68.6342 186.402Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1331"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1332"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_997",
  d: "M40.9224 167.269L17.4277 176.839V193.716L40.9224 184.146V167.269Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.87883,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1333"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_998",
  d: "M55.405 184.801V201.722L58.3373 200.527V183.607L55.405 184.801Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.421308,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1334"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_999",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M58.3677 183.602L40.9453 167.263L17.4414 176.83L55.4092 184.786L58.3677 183.602Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1335"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1000",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M55.4092 184.786V201.664L17.4414 193.687L17.4414 176.83L55.4092 184.786Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__door"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1336"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1001",
  d: "M579.441 181.432L512.287 154.3V279.488L579.441 306.621V181.432Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.912333,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1337"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1002",
  d: "M646.614 208.564L579.46 181.432V306.621L646.614 333.753V208.564Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.912333,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1338"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1339"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1340"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1341"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1342"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1003",
  d: "M603.919 290.543L585.718 283.189V296.233L603.919 303.587V290.543Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.605677,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1343"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1004",
  d: "M578.895 298.824L576.631 297.91V310.954L578.895 311.868V298.824Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.39621,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1344"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1005",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M578.924 298.827L603.928 290.544L585.741 283.196L576.66 297.913L578.924 298.827Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1345"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1006",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M578.924 298.828V311.872L603.928 303.589V290.545L578.924 298.828Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1346"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1347"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1007",
  d: "M622.216 297.936L604.015 290.582V303.626L622.216 310.98V297.936Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.605677,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1348"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1008",
  d: "M605.17 314.731L586.969 307.377V309.824L605.17 317.178V314.731Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1349"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1009",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M605.182 314.736L622.225 297.937L604.038 290.589L586.97 307.377L605.182 314.736Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1350"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1010",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M605.182 314.735V317.182L622.224 310.981V297.937L605.182 314.735Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1351"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1352"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1011",
  d: "M640.415 305.288L622.214 297.934V310.978L640.415 318.332V305.288Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.605677,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1353"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1012",
  d: "M615.405 313.569L613.142 312.654V325.699L615.405 326.613V313.569Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.39621,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1354"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1013",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M615.418 313.572L640.422 305.289L622.235 297.941L613.154 312.658L615.418 313.572Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1355"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1014",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M615.418 313.572V326.617L640.422 318.334V305.289L615.418 313.572Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1356"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1357"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1358"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1359"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1015",
  d: "M603.923 277.499L585.722 270.146V283.19L603.923 290.543V277.499Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.605677,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1360"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1016",
  d: "M586.877 294.295L568.676 286.941V289.388L586.877 296.742V294.295Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1361"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1017",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M586.889 294.299L603.931 277.501L585.744 270.153L568.676 286.941L586.889 294.299Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1362"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1018",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M586.889 294.299V296.746L603.931 290.545V277.501L586.889 294.299Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1363"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1364"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1019",
  d: "M622.12 284.851L603.919 277.498V290.542L622.12 297.895V284.851Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.605677,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1365"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1020",
  d: "M597.111 293.133L594.847 292.218V305.262L597.111 306.177V293.133Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.39621,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1366"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1021",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M597.124 293.136L622.128 284.853L603.941 277.505L594.86 292.221L597.124 293.136Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1367"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1022",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M597.125 293.136V306.181L622.129 297.898V284.853L597.125 293.136Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1368"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1369"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1023",
  d: "M640.314 292.202L622.113 284.849V297.893L640.314 305.247V292.202Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.605677,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1370"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1024",
  d: "M623.268 308.998L605.067 301.644V304.091L623.268 311.445V308.998Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1371"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1025",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M623.28 309.002L640.322 292.204L622.135 284.856L605.067 301.644L623.28 309.002Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1372"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1026",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M623.28 309.002V311.449L640.322 305.248V292.204L623.28 309.002Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
})))))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1373"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1374"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1375"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1376"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1027",
  d: "M603.919 264.4L585.718 257.046V270.09L603.919 277.444V264.4Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.605677,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1377"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1028",
  d: "M578.895 272.682L576.631 271.767V284.812L578.895 285.726V272.682Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.39621,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1378"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1029",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M578.924 272.685L603.928 264.402L585.741 257.054L576.66 271.77L578.924 272.685Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1379"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1030",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M578.924 272.685V285.729L603.928 277.446V264.402L578.924 272.685Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1380"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1381"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1031",
  d: "M622.216 271.793L604.015 264.439V277.483L622.216 284.837V271.793Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.605677,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1382"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1032",
  d: "M605.17 288.588L586.969 281.235V283.682L605.17 291.036V288.588Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1383"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1033",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M605.182 288.593L622.225 271.795L604.038 264.447L586.97 281.235L605.182 288.593Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1384"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1034",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M605.182 288.593V291.04L622.224 284.839V271.795L605.182 288.593Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1385"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1386"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1035",
  d: "M640.415 279.145L622.214 271.792V284.836L640.415 292.189V279.145Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.605677,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1387"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1036",
  d: "M615.405 287.427L613.142 286.512V299.556L615.405 300.471V287.427Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.39621,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1388"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1037",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M615.418 287.43L640.422 279.147L622.235 271.799L613.154 286.515L615.418 287.43Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1389"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1038",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M615.418 287.43V300.474L640.422 292.191V279.147L615.418 287.43Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1390"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1391"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1392"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1393"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1039",
  d: "M603.923 251.357L585.722 244.003V257.047L603.923 264.401V251.357Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.605677,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1394"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1040",
  d: "M586.877 268.152L568.676 260.798V263.246L586.877 270.599V268.152Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1395"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1041",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M586.889 268.157L603.931 251.359L585.744 244.011L568.676 260.799L586.889 268.157Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1396"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1042",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M586.889 268.157V270.604L603.931 264.403V251.359L586.889 268.157Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1397"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1398"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1043",
  d: "M622.12 258.709L603.919 251.355V264.399L622.12 271.753V258.709Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.605677,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1399"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1044",
  d: "M597.111 266.991L594.847 266.076V279.12L597.111 280.035V266.991Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.39621,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1400"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1045",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M597.124 266.994L622.128 258.711L603.941 251.363L594.86 266.079L597.124 266.994Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1401"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1046",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M597.125 266.994V280.038L622.129 271.755V258.711L597.125 266.994Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1402"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1403"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1047",
  d: "M640.314 266.06L622.113 258.706V271.751L640.314 279.104V266.06Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.605677,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1404"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1048",
  d: "M623.268 282.856L605.067 275.502V277.949L623.268 285.303V282.856Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1405"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1049",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M623.28 282.86L640.322 266.062L622.135 258.714L605.067 275.502L623.28 282.86Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1406"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1050",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M623.28 282.86V285.307L640.322 279.106V266.062L623.28 282.86Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
})))))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1407"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1408"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1409"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1410"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1051",
  d: "M603.919 238.258L585.718 230.904V243.949L603.919 251.302V238.258Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.605677,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1411"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1052",
  d: "M578.895 246.54L576.631 245.625V258.67L578.895 259.584V246.54Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.39621,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1412"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1053",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M578.924 246.543L603.928 238.26L585.741 230.912L576.66 245.628L578.924 246.543Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1413"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1054",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M578.924 246.543V259.587L603.928 251.304V238.26L578.924 246.543Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1414"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1415"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1055",
  d: "M622.216 245.651L604.015 238.297V251.342L622.216 258.695V245.651Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.605677,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1416"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1056",
  d: "M605.17 262.446L586.969 255.093V257.54L605.17 264.894V262.446Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1417"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1057",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M605.182 262.451L622.225 245.653L604.038 238.305L586.97 255.093L605.182 262.451Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1418"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1058",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M605.182 262.451V264.898L622.224 258.697V245.653L605.182 262.451Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1419"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1420"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1059",
  d: "M640.415 253.003L622.214 245.65V258.694L640.415 266.048V253.003Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.605677,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1421"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1060",
  d: "M615.405 261.285L613.142 260.37V273.414L615.405 274.329V261.285Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.39621,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1422"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1061",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M615.418 261.288L640.422 253.005L622.235 245.657L613.154 260.373L615.418 261.288Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1423"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1062",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M615.418 261.288V274.332L640.422 266.049V253.005L615.418 261.288Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1424"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1425"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1426"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1427"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1063",
  d: "M603.923 225.215L585.722 217.861V230.906L603.923 238.259V225.215Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.605677,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1428"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1064",
  d: "M586.877 242.01L568.676 234.657V237.104L586.877 244.457V242.01Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1429"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1065",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M586.889 242.015L603.931 225.217L585.744 217.869L568.676 234.657L586.889 242.015Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1430"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1066",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M586.889 242.015V244.462L603.931 238.261V225.217L586.889 242.015Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1431"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1432"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1067",
  d: "M622.12 232.567L603.919 225.213V238.258L622.12 245.611V232.567Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.605677,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1433"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1068",
  d: "M597.111 240.848L594.847 239.934V252.978L597.111 253.893V240.848Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.39621,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1434"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1069",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M597.124 240.852L622.128 232.569L603.941 225.221L594.86 239.937L597.124 240.852Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1435"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1070",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M597.125 240.852V253.896L622.129 245.613V232.569L597.125 240.852Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1436"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1437"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1071",
  d: "M640.314 239.918L622.113 232.564V245.608L640.314 252.962V239.918Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.605677,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1438"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1072",
  d: "M623.268 256.713L605.067 249.36V251.807L623.268 259.161V256.713Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1439"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1073",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M623.28 256.718L640.322 239.92L622.135 232.572L605.067 249.36L623.28 256.718Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1440"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1074",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M623.28 256.718V259.165L640.322 252.964V239.92L623.28 256.718Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
})))))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1441"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1442"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1443"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1444"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1075",
  d: "M603.919 212.116L585.718 204.763V217.807L603.919 225.16V212.116Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.605677,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1445"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1076",
  d: "M578.895 220.398L576.631 219.483V232.527L578.895 233.442V220.398Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.39621,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1446"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1077",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M578.924 220.401L603.928 212.118L585.741 204.77L576.66 219.486L578.924 220.401Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1447"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1078",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M578.924 220.401V233.445L603.928 225.162V212.118L578.924 220.401Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1448"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1449"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1079",
  d: "M622.216 219.509L604.015 212.155V225.199L622.216 232.553V219.509Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.605677,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1450"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1080",
  d: "M605.17 236.304L586.969 228.951V231.398L605.17 238.752V236.304Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1451"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1081",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M605.182 236.309L622.225 219.511L604.038 212.163L586.97 228.951L605.182 236.309Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1452"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1082",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M605.182 236.309V238.756L622.224 232.555V219.511L605.182 236.309Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1453"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1454"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1083",
  d: "M640.415 226.861L622.214 219.507V232.552L640.415 239.905V226.861Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.605677,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1455"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1084",
  d: "M615.405 235.143L613.142 234.228V247.272L615.405 248.187V235.143Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.39621,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1456"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1085",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M615.418 235.146L640.422 226.863L622.235 219.515L613.154 234.231L615.418 235.146Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1457"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1086",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M615.418 235.146V248.19L640.422 239.907V226.863L615.418 235.146Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1458"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1459"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1460"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1461"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1087",
  d: "M603.923 199.073L585.722 191.719V204.764L603.923 212.117V199.073Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.605677,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1462"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1088",
  d: "M586.877 215.868L568.676 208.515V210.962L586.877 218.315V215.868Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1463"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1089",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M586.889 215.873L603.931 199.075L585.744 191.727L568.676 208.515L586.889 215.873Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1464"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1090",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M586.889 215.873V218.32L603.931 212.119V199.075L586.889 215.873Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1465"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1466"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1091",
  d: "M622.12 206.425L603.919 199.072V212.116L622.12 219.469V206.425Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.605677,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1467"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1092",
  d: "M597.111 214.707L594.847 213.792V226.836L597.111 227.751V214.707Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.39621,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1468"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1093",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M597.124 214.71L622.128 206.427L603.941 199.079L594.86 213.795L597.124 214.71Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1469"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1094",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M597.125 214.71V227.754L622.129 219.471V206.427L597.125 214.71Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1470"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1471"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1095",
  d: "M640.314 213.776L622.113 206.423V219.467L640.314 226.82V213.776Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.605677,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1472"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1096",
  d: "M623.268 230.571L605.067 223.218V225.665L623.268 233.018V230.571Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1473"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1097",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M623.28 230.576L640.322 213.778L622.135 206.43L605.067 223.218L623.28 230.576Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1474"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1098",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M623.28 230.576V233.023L640.322 226.822V213.778L623.28 230.576Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
}))))))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1475"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1476"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1477"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1478"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1099",
  d: "M535.741 262.835L517.54 255.481V268.525L535.741 275.879V262.835Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.605677,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1479"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1100",
  d: "M510.717 271.116L508.454 270.202V283.246L510.717 284.161V271.116Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.39621,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1480"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1101",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M510.745 271.119L535.749 262.836L517.562 255.488L508.481 270.205L510.745 271.119Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1481"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1102",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M510.746 271.119V284.164L535.75 275.881V262.836L510.746 271.119Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1482"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1483"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1103",
  d: "M554.039 270.227L535.838 262.874V275.918L554.039 283.272V270.227Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.605677,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1484"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1104",
  d: "M536.992 287.023L518.791 279.669V282.116L536.992 289.47V287.023Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1485"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1105",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M537.004 287.028L554.046 270.229L535.859 262.881L518.791 279.669L537.004 287.028Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1486"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1106",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M537.004 287.028V289.475L554.046 283.273V270.229L537.004 287.028Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1487"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1488"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1489"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1107",
  d: "M535.841 249.824L517.64 242.471V255.515L535.841 262.869V249.824Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.605677,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1490"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1108",
  d: "M518.796 266.62L500.595 259.266V261.713L518.796 269.067V266.62Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1491"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1109",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M518.807 266.624L535.85 249.826L517.663 242.478L500.595 259.266L518.807 266.624Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1492"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1110",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M518.808 266.624V269.072L535.85 262.87V249.826L518.808 266.624Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1493"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1494"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1111",
  d: "M554.04 257.176L535.839 249.823V262.867L554.04 270.221V257.176Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.605677,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1495"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1112",
  d: "M529.03 265.458L526.767 264.543V277.588L529.03 278.502V265.458Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.39621,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1496"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1113",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M529.043 265.461L554.047 257.178L535.86 249.83L526.779 264.547L529.043 265.461Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1497"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1114",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M529.043 265.461V278.506L554.048 270.222V257.178L529.043 265.461Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1498"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1499"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1500"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1115",
  d: "M535.741 236.773L517.54 229.419V242.464L535.741 249.817V236.773Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.605677,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1501"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1116",
  d: "M510.717 245.055L508.454 244.14V257.184L510.717 258.099V245.055Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.39621,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1502"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1117",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M510.745 245.058L535.749 236.775L517.562 229.427L508.481 244.143L510.745 245.058Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1503"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1118",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M510.746 245.058V258.102L535.75 249.819V236.775L510.746 245.058Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1504"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1505"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1119",
  d: "M554.039 244.166L535.838 236.812V249.856L554.039 257.21V244.166Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.605677,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1506"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1120",
  d: "M536.992 260.961L518.791 253.608V256.055L536.992 263.408V260.961Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1507"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1121",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M537.004 260.966L554.046 244.168L535.859 236.82L518.791 253.608L537.004 260.966Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1508"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1122",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M537.004 260.966V263.413L554.046 257.212V244.168L537.004 260.966Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1509"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1510"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1511"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1123",
  d: "M535.841 223.763L517.64 216.409V229.453L535.841 236.807V223.763Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.605677,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1512"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1124",
  d: "M518.796 240.558L500.595 233.204V235.651L518.796 243.005V240.558Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1513"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1125",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M518.807 240.563L535.85 223.764L517.663 216.416L500.595 233.204L518.807 240.563Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1514"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1126",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M518.808 240.563V243.01L535.85 236.808V223.764L518.808 240.563Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1515"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1516"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1127",
  d: "M554.04 231.115L535.839 223.761V236.805L554.04 244.159V231.115Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.605677,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1517"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1128",
  d: "M529.03 239.396L526.767 238.482V251.526L529.03 252.441V239.396Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.39621,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1518"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1129",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M529.043 239.4L554.047 231.117L535.86 223.769L526.779 238.485L529.043 239.4Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1519"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1130",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M529.043 239.399V252.444L554.048 244.161V231.116L529.043 239.399Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1520"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1521"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1522"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1131",
  d: "M535.741 210.711L517.54 203.358V216.402L535.741 223.756V210.711Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.605677,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1523"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1132",
  d: "M510.717 218.993L508.454 218.078V231.123L510.717 232.037V218.993Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.39621,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1524"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1133",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M510.745 218.996L535.749 210.713L517.562 203.365L508.481 218.081L510.745 218.996Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1525"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1134",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M510.746 218.996V232.041L535.75 223.758V210.713L510.746 218.996Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1526"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1527"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1135",
  d: "M554.039 218.104L535.838 210.751V223.795L554.039 231.148V218.104Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.605677,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1528"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1136",
  d: "M536.992 234.9L518.791 227.546V229.993L536.992 237.347V234.9Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1529"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1137",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M537.004 234.904L554.046 218.106L535.859 210.758L518.791 227.546L537.004 234.904Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1530"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1138",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M537.004 234.904V237.351L554.046 231.15V218.106L537.004 234.904Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1531"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1532"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1533"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1139",
  d: "M535.841 197.701L517.64 190.348V203.392L535.841 210.745V197.701Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.605677,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1534"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1140",
  d: "M518.796 214.497L500.595 207.143V209.59L518.796 216.944V214.497Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1535"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1141",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M518.807 214.501L535.85 197.703L517.663 190.355L500.595 207.143L518.807 214.501Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1536"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1142",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M518.808 214.501V216.948L535.85 210.747V197.703L518.808 214.501Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1537"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1538"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1143",
  d: "M554.04 205.053L535.839 197.7V210.744L554.04 218.097V205.053Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.605677,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1539"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1144",
  d: "M529.03 213.335L526.767 212.42V225.464L529.03 226.379V213.335Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.39621,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1540"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1145",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M529.043 213.338L554.047 205.055L535.86 197.707L526.779 212.423L529.043 213.338Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1541"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1146",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M529.043 213.338V226.382L554.048 218.099V205.055L529.043 213.338Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1542"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1543"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1544"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1147",
  d: "M535.741 184.65L517.54 177.296V190.34L535.741 197.694V184.65Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.605677,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1545"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1148",
  d: "M510.717 192.931L508.454 192.017V205.061L510.717 205.975V192.931Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.39621,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1546"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1149",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M510.745 192.934L535.749 184.651L517.562 177.303L508.481 192.02L510.745 192.934Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1547"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1150",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M510.746 192.935V205.979L535.75 197.696V184.651L510.746 192.935Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1548"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1549"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1151",
  d: "M554.039 192.043L535.838 184.689V197.733L554.039 205.087V192.043Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.605677,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1550"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1152",
  d: "M536.992 208.838L518.791 201.484V203.931L536.992 211.285V208.838Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1551"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1153",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M537.004 208.843L554.046 192.044L535.859 184.696L518.791 201.484L537.004 208.843Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1552"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1154",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M537.004 208.843V211.29L554.046 205.088V192.044L537.004 208.843Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1553"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1554"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1555"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1155",
  d: "M535.841 171.639L517.64 164.286V177.33L535.841 184.683V171.639Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.605677,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1556"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1156",
  d: "M518.796 188.435L500.595 181.081V183.528L518.796 190.882V188.435Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1557"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1157",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M518.807 188.439L535.85 171.641L517.663 164.293L500.595 181.081L518.807 188.439Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1558"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1158",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M518.808 188.439V190.886L535.85 184.685V171.641L518.808 188.439Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1559"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1560"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1159",
  d: "M554.04 178.991L535.839 171.638V184.682L554.04 192.036V178.991Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.605677,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1561"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1160",
  d: "M529.03 187.273L526.767 186.358V199.402L529.03 200.317V187.273Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.39621,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1562"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1161",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M529.043 187.276L554.047 178.993L535.86 171.645L526.779 186.362L529.043 187.276Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1563"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1162",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M529.043 187.276V200.32L554.048 192.037V178.993L529.043 187.276Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1564"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1565"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1163",
  d: "M572.237 277.58L554.036 270.226V283.27L572.237 290.624V277.58Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.605677,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1566"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1164",
  d: "M547.228 285.861L544.964 284.947V297.991L547.228 298.906V285.861Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.39621,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1567"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1165",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M547.241 285.864L572.245 277.581L554.058 270.233L544.977 284.95L547.241 285.864Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1568"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1166",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M547.241 285.864V298.909L572.245 290.626V277.581L547.241 285.864Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1569"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1570"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1167",
  d: "M572.237 264.536L554.036 257.182V270.226L572.237 277.58V264.536Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.605677,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1571"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1168",
  d: "M547.228 272.817L544.964 271.902V284.947L547.228 285.861V272.817Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.39621,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1572"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1169",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M547.241 272.82L572.245 264.537L554.058 257.189L544.977 271.906L547.241 272.82Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1573"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1170",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M547.241 272.82V285.865L572.245 277.581V264.537L547.241 272.82Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1574"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1575"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1171",
  d: "M572.237 251.491L554.036 244.138V257.182L572.237 264.535V251.491Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.605677,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1576"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1172",
  d: "M547.228 259.773L544.964 258.858V271.902L547.228 272.817V259.773Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.39621,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1577"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1173",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M547.241 259.776L572.245 251.493L554.058 244.145L544.977 258.861L547.241 259.776Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1578"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1174",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M547.241 259.776V272.82L572.245 264.537V251.493L547.241 259.776Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1579"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1580"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1175",
  d: "M572.237 238.447L554.036 231.094V244.138L572.237 251.491V238.447Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.605677,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1581"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1176",
  d: "M547.228 246.729L544.964 245.814V258.858L547.228 259.773V246.729Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.39621,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1582"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1177",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M547.241 246.732L572.245 238.449L554.058 231.101L544.977 245.817L547.241 246.732Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1583"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1178",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M547.241 246.732V259.776L572.245 251.493V238.449L547.241 246.732Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1584"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1585"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1179",
  d: "M572.237 225.403L554.036 218.049V231.094L572.237 238.447V225.403Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.605677,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1586"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1180",
  d: "M547.228 233.684L544.964 232.77V245.814L547.228 246.729V233.684Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.39621,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1587"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1181",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M547.241 233.688L572.245 225.405L554.058 218.057L544.977 232.773L547.241 233.688Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1588"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1182",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M547.241 233.688V246.732L572.245 238.449V225.405L547.241 233.688Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1589"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1590"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1183",
  d: "M572.237 212.359L554.036 205.005V218.049L572.237 225.403V212.359Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.605677,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1591"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1184",
  d: "M547.228 220.64L544.964 219.726V232.77L547.228 233.684V220.64Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.39621,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1592"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1185",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M547.241 220.643L572.245 212.36L554.058 205.012L544.977 219.729L547.241 220.643Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1593"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1186",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M547.241 220.643V233.688L572.245 225.405V212.36L547.241 220.643Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1594"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1595"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1187",
  d: "M572.237 199.315L554.036 191.961V205.005L572.237 212.359V199.315Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.605677,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1596"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1188",
  d: "M547.228 207.596L544.964 206.682V219.726L547.228 220.64V207.596Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.39621,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1597"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1189",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M547.241 207.599L572.245 199.316L554.058 191.968L544.977 206.685L547.241 207.599Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1598"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1190",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M547.241 207.599V220.644L572.245 212.361V199.316L547.241 207.599Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1599"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1600"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1191",
  d: "M572.237 186.271L554.036 178.917V191.961L572.237 199.315V186.271Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.605677,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1601"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1192",
  d: "M547.228 194.552L544.964 193.637V206.682L547.228 207.596V194.552Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.39621,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1602"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1193",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M547.241 194.555L572.245 186.272L554.058 178.924L544.977 193.641L547.241 194.555Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1603"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1194",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M547.241 194.555V207.6L572.245 199.316V186.272L547.241 194.555Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.354823,
  strokeMiterlimit: 1.5
}))))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__top-door"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1604"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1605"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1606"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1195",
  d: "M528.051 125.298L504.529 115.794V132.652L528.051 142.155V125.298Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1607"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1196",
  d: "M495.721 136.004L492.795 134.822V151.68L495.721 152.862V136.004Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.396271,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1608"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1197",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M495.747 136.007L528.06 125.303L504.556 115.806L492.821 134.825L495.747 136.007Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1609"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1198",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M495.747 136.007V152.865L528.061 142.16V125.302L495.747 136.007Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1610"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1611"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1199",
  d: "M528.051 108.329L504.529 98.8256V115.683L528.051 125.186V108.329Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1612"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1200",
  d: "M506.021 130.037L482.5 120.533V123.696L506.021 133.199V130.037Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1613"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1201",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M506.036 130.043L528.061 108.334L504.557 98.8376L482.5 120.533L506.036 130.043Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1614"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1202",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M506.036 130.043V133.205L528.06 125.191V108.334L506.036 130.043Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1615"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1616"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1203",
  d: "M528.051 90.9397L504.529 81.4363V98.2938L528.051 107.797V90.9397Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1617"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1204",
  d: "M495.721 101.646L492.795 100.464V117.321L495.721 118.503V101.646Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.396271,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1618"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1205",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M495.747 101.649L528.06 90.9442L504.556 81.448L492.821 100.467L495.747 101.649Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1619"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1206",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M495.747 101.649V118.506L528.061 107.802V90.9441L495.747 101.649Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1620"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1621"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1207",
  d: "M528.051 73.9729L504.529 64.4695V81.327L528.051 90.8304V73.9729Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1622"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1208",
  d: "M506.021 95.6804L482.5 86.177V89.3396L506.021 98.843V95.6804Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1623"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1209",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M506.036 95.6868L528.061 73.9776L504.557 64.4814L482.5 86.1772L506.036 95.6868Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1624"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1210",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M506.036 95.6863V98.8486L528.06 90.8346V73.9771L506.036 95.6863Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1625"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1626"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1211",
  d: "M528.051 56.0875L504.529 46.5841V63.4416L528.051 72.945V56.0875Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1627"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1212",
  d: "M495.721 66.7939L492.795 65.6118V82.4693L495.721 83.6514V66.7939Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.396271,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1628"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1213",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M495.747 66.7966L528.06 56.0921L504.556 46.596L492.821 65.6145L495.747 66.7966Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1629"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1214",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M495.747 66.7967V83.6543L528.061 72.9496V56.0922L495.747 66.7967Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1630"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1631"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1215",
  d: "M551.573 134.801L528.051 125.297V142.155L551.573 151.658V134.801Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1632"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1216",
  d: "M529.542 156.508L506.021 147.005V150.168L529.542 159.671V156.508Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1633"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1217",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M529.557 156.515L551.582 134.805L528.078 125.309L506.021 147.005L529.557 156.515Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1634"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1218",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M529.557 156.515V159.677L551.582 151.663V134.805L529.557 156.515Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1635"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1636"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1219",
  d: "M575.095 144.304L551.573 134.801V151.658L575.095 161.161V144.304Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1637"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1220",
  d: "M542.764 155.01L539.838 153.828V170.686L542.764 171.868V155.01Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.396271,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1638"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1221",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M542.79 155.013L575.104 144.308L551.6 134.812L539.864 153.831L542.79 155.013Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1639"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1222",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M542.791 155.013V171.871L575.104 161.166V144.308L542.791 155.013Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1640"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1641"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1223",
  d: "M598.616 153.807L575.094 144.304V161.161L598.616 170.665V153.807Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1642"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1224",
  d: "M576.586 175.514L553.064 166.011V169.174L576.586 178.677V175.514Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1643"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1225",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M576.601 175.521L598.625 153.812L575.122 144.315L553.064 166.011L576.601 175.521Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1644"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1226",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M576.601 175.521V178.683L598.625 170.669V153.811L576.601 175.521Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1645"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1646"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1227",
  d: "M551.573 117.834L528.051 108.331V125.188L551.573 134.692V117.834Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1647"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1228",
  d: "M519.243 128.541L516.317 127.359V144.216L519.243 145.398V128.541Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.396271,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1648"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1229",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M519.269 128.543L551.582 117.839L528.078 108.343L516.343 127.361L519.269 128.543Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1649"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1230",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M519.269 128.543V145.401L551.583 134.696V117.839L519.269 128.543Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1650"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1651"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1231",
  d: "M575.096 127.337L551.574 117.834V134.691L575.096 144.195V127.337Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1652"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1232",
  d: "M553.065 149.045L529.543 139.542V142.704L553.065 152.207V149.045Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1653"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1233",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M553.08 149.051L575.104 127.342L551.601 117.846L529.543 139.541L553.08 149.051Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1654"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1234",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M553.08 149.051V152.213L575.104 144.199V127.342L553.08 149.051Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1655"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1656"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1235",
  d: "M598.616 136.84L575.094 127.337V144.194L598.616 153.698V136.84Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1657"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1236",
  d: "M566.286 147.547L563.36 146.365V163.222L566.286 164.404V147.547Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.396271,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1658"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1237",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M566.312 147.549L598.626 136.845L575.122 127.349L563.386 146.367L566.312 147.549Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1659"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1238",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M566.312 147.549V164.407L598.626 153.702V136.845L566.312 147.549Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1660"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1661"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1239",
  d: "M551.573 100.443L528.051 90.9391V107.797L551.573 117.3V100.443Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1662"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1240",
  d: "M529.542 122.15L506.021 112.647V115.809L529.542 125.313V122.15Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1663"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1241",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M529.557 122.156L551.582 100.447L528.078 90.951L506.021 112.647L529.557 122.156Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1664"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1242",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M529.557 122.156V125.319L551.582 117.305V100.447L529.557 122.156Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1665"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1666"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1243",
  d: "M575.095 109.946L551.573 100.442V117.3L575.095 126.803V109.946Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1667"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1244",
  d: "M542.764 120.652L539.838 119.47V136.327L542.764 137.509V120.652Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.396271,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1668"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1245",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M542.79 120.655L575.104 109.95L551.6 100.454L539.864 119.473L542.79 120.655Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1669"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1246",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M542.791 120.655V137.512L575.104 126.808V109.95L542.791 120.655Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1670"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1671"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1247",
  d: "M598.616 119.451L575.094 109.947V126.805L598.616 136.308V119.451Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1672"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1248",
  d: "M576.586 141.158L553.064 131.655V134.817L576.586 144.321V141.158Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1673"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1249",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M576.601 141.164L598.625 119.455L575.122 109.959L553.064 131.655L576.601 141.164Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1674"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1250",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M576.601 141.164V144.327L598.625 136.313V119.455L576.601 141.164Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1675"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1676"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1251",
  d: "M551.573 83.4757L528.051 73.9723V90.8298L551.573 100.333V83.4757Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1677"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1252",
  d: "M519.243 94.1823L516.317 93.0002V109.858L519.243 111.04V94.1823Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.396271,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1678"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1253",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M519.269 94.1851L551.582 83.4805L528.078 73.9844L516.343 93.003L519.269 94.1851Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1679"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1254",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M519.269 94.1852V111.043L551.583 100.338V83.4807L519.269 94.1852Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1680"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1681"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1255",
  d: "M575.096 92.9789L551.574 83.4755V100.333L575.096 109.836V92.9789Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1682"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1256",
  d: "M553.065 114.687L529.543 105.183V108.346L553.065 117.849V114.687Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1683"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1257",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M553.08 114.692L575.104 92.9833L551.601 83.4872L529.543 105.183L553.08 114.692Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1684"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1258",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M553.08 114.692V117.855L575.104 109.841V92.9833L553.08 114.692Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1685"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1686"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1259",
  d: "M598.616 102.482L575.094 92.9785V109.836L598.616 119.339V102.482Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1687"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1260",
  d: "M566.286 113.188L563.36 112.006V128.864L566.286 130.046V113.188Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.396271,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1688"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1261",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M566.312 113.191L598.626 102.486L575.122 92.9902L563.386 112.009L566.312 113.191Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1689"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1262",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M566.312 113.191V130.049L598.626 119.344V102.486L566.312 113.191Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1690"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1691"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1263",
  d: "M551.573 65.5905L528.051 56.087V72.9445L551.573 82.4479V65.5905Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1692"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1264",
  d: "M529.542 87.2982L506.021 77.7948V80.9574L529.542 90.4608V87.2982Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1693"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1265",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M529.557 87.3043L551.582 65.5951L528.078 56.099L506.021 77.7948L529.557 87.3043Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1694"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1266",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M529.557 87.3043V90.4667L551.582 82.4526V65.5952L529.557 87.3043Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1695"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1696"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1267",
  d: "M575.095 75.0935L551.573 65.5901V82.4476L575.095 91.951V75.0935Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1697"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1268",
  d: "M542.764 85.8001L539.838 84.618V101.476L542.764 102.658V85.8001Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.396271,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1698"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1269",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M542.79 85.8026L575.104 75.0981L551.6 65.6019L539.864 84.6205L542.79 85.8026Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1699"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1270",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M542.791 85.8026V102.66L575.104 91.9556V75.0981L542.791 85.8026Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1700"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1701"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1271",
  d: "M598.616 84.5963L575.094 75.0929V91.9504L598.616 101.454V84.5963Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1702"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1272",
  d: "M576.586 106.304L553.064 96.8007V99.9632L576.586 109.467V106.304Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1703"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1273",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M576.601 106.31L598.625 84.601L575.122 75.1048L553.064 96.8006L576.601 106.31Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1704"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1274",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M576.601 106.31V109.473L598.625 101.459V84.6011L576.601 106.31Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1705"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1706"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1275",
  d: "M622.098 163.754L598.576 154.251V171.108L622.098 180.612V163.754Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1707"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1276",
  d: "M589.767 174.461L586.842 173.279V190.136L589.767 191.318V174.461Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.396271,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1708"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1277",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M589.793 174.463L622.107 163.759L598.603 154.263L586.867 173.281L589.793 174.463Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1709"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1278",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M589.794 174.463V191.321L622.108 180.616V163.759L589.794 174.463Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1710"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1711"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1279",
  d: "M645.619 173.257L622.098 163.754V180.611L645.619 190.114V173.257Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1712"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1280",
  d: "M623.59 194.965L600.068 185.461V188.624L623.59 198.127V194.965Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1713"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1281",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M623.605 194.971L645.629 173.262L622.126 163.765L600.068 185.461L623.605 194.971Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1714"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1282",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M623.604 194.971V198.133L645.629 190.119V173.262L623.604 194.971Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1715"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1716"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1283",
  d: "M669.141 182.76L645.62 173.256V190.114L669.141 199.617V182.76Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1717"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1284",
  d: "M636.811 193.466L633.886 192.284V209.142L636.811 210.324V193.466Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.396271,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1718"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1285",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M636.837 193.469L669.151 182.765L645.647 173.268L633.912 192.287L636.837 193.469Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1719"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1286",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M636.838 193.469V210.327L669.152 199.622V182.765L636.838 193.469Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1720"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1721"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1287",
  d: "M622.098 146.785L598.576 137.282V154.139L622.098 163.643V146.785Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1722"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1288",
  d: "M600.067 168.493L576.545 158.989V162.152L600.067 171.655V168.493Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1723"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1289",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M600.082 168.499L622.107 146.79L598.603 137.294L576.545 158.989L600.082 168.499Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1724"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1290",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M600.083 168.499V171.661L622.107 163.647V146.79L600.083 168.499Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1725"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1726"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1291",
  d: "M622.098 112.245L598.576 102.741V119.599L622.098 129.102V112.245Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1727"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1292",
  d: "M600.067 133.952L576.545 124.449V127.611L600.067 137.115V133.952Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1728"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1293",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M600.082 133.958L622.107 112.249L598.603 102.753L576.545 124.449L600.082 133.958Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1729"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1294",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M600.083 133.958V137.12L622.107 129.106V112.249L600.083 133.958Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1730"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1731"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1295",
  d: "M645.619 156.288L622.098 146.785V163.642L645.619 173.146V156.288Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1732"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1296",
  d: "M613.289 166.995L610.363 165.813V182.67L613.289 183.852V166.995Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.396271,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1733"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1297",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M613.315 166.997L645.629 156.293L622.125 146.797L610.389 165.815L613.315 166.997Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1734"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1298",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M613.315 166.997V183.855L645.629 173.15V156.293L613.315 166.997Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1735"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1736"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1299",
  d: "M645.619 121.748L622.098 112.244V129.102L645.619 138.605V121.748Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1737"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1300",
  d: "M613.289 132.454L610.363 131.272V148.129L613.289 149.311V132.454Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.396271,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1738"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1301",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M613.315 132.457L645.629 121.752L622.125 112.256L610.389 131.275L613.315 132.457Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1739"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1302",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M613.315 132.457V149.314L645.629 138.61V121.752L613.315 132.457Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1740"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1741"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1303",
  d: "M669.141 165.793L645.619 156.29V173.147L669.141 182.651V165.793Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1742"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1304",
  d: "M647.111 187.501L623.589 177.998V181.16L647.111 190.664V187.501Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1743"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1305",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M647.126 187.507L669.15 165.798L645.647 156.302L623.589 177.998L647.126 187.507Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1744"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1306",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M647.125 187.507V190.669L669.15 182.655V165.798L647.125 187.507Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1745"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1746"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1307",
  d: "M669.141 131.251L645.619 121.747V138.605L669.141 148.108V131.251Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1747"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1308",
  d: "M647.111 152.958L623.589 143.455V146.617L647.111 156.121V152.958Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1748"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1309",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M647.126 152.964L669.15 131.255L645.647 121.759L623.589 143.455L647.126 152.964Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1749"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1310",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M647.125 152.964V156.126L669.15 148.112V131.255L647.125 152.964Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1750"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1751"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1311",
  d: "M622.098 128.902L598.576 119.399V136.256L622.098 145.76V128.902Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1752"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1312",
  d: "M589.767 139.608L586.842 138.426V155.284L589.767 156.466V139.608Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.396271,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1753"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1313",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M589.793 139.611L622.107 128.907L598.603 119.41L586.867 138.429L589.793 139.611Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1754"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1314",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M589.794 139.611V156.469L622.108 145.764V128.907L589.794 139.611Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1755"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1756"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1315",
  d: "M622.098 94.3589L598.576 84.8555V101.713L622.098 111.216V94.3589Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1757"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1316",
  d: "M589.767 105.066L586.842 103.884V120.741L589.767 121.923V105.066Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.396271,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1758"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1317",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M589.793 105.068L622.107 94.3637L598.603 84.8676L586.867 103.886L589.793 105.068Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1759"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1318",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M589.794 105.068V121.926L622.108 111.221V94.3638L589.794 105.068Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1760"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1761"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1319",
  d: "M645.619 138.405L622.098 128.902V145.759L645.619 155.263V138.405Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1762"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1320",
  d: "M623.59 160.113L600.068 150.609V153.772L623.59 163.275V160.113Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1763"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1321",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M623.605 160.119L645.629 138.41L622.126 128.913L600.068 150.609L623.605 160.119Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1764"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1322",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M623.604 160.119V163.281L645.629 155.267V138.409L623.604 160.119Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1765"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1766"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1323",
  d: "M645.619 103.862L622.098 94.3584V111.216L645.619 120.719V103.862Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1767"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1324",
  d: "M623.59 125.57L600.068 116.066V119.229L623.59 128.732V125.57Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1768"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1325",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M623.605 125.576L645.629 103.867L622.126 94.3705L600.068 116.066L623.605 125.576Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1769"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1326",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M623.604 125.576V128.738L645.629 120.724V103.866L623.604 125.576Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1770"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1771"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1327",
  d: "M669.141 147.908L645.62 138.404V155.262L669.141 164.765V147.908Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1772"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1328",
  d: "M636.811 158.615L633.886 157.432V174.29L636.811 175.472V158.615Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.396271,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1773"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1329",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M636.837 158.617L669.151 147.912L645.647 138.416L633.912 157.435L636.837 158.617Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1774"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1330",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M636.838 158.617V175.474L669.152 164.77V147.912L636.838 158.617Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1775"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1776"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1331",
  d: "M669.141 113.367L645.62 103.864V120.721L669.141 130.225V113.367Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1777"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1332",
  d: "M636.811 124.074L633.886 122.892V139.749L636.811 140.931V124.074Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.396271,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1778"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1333",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M636.837 124.076L669.151 113.372L645.647 103.876L633.912 122.894L636.837 124.076Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1779"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1334",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M636.838 124.076V140.934L669.152 130.229V113.372L636.838 124.076Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Right-2"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1780"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1781"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1335",
  d: "M692.649 330.016L669.127 320.513V337.37L692.649 346.874V330.016Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.605989,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1782"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1336",
  d: "M670.619 351.723L647.097 342.22V345.382L670.619 354.886V351.723Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1783"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1337",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M670.634 351.729L692.658 330.02L669.155 320.524L647.097 342.219L670.634 351.729Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1784"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1338",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M670.634 351.729V354.891L692.659 346.877V330.02L670.634 351.729Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1785"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1339",
  d: "M716.171 339.52L692.649 330.016V346.874L716.171 356.377V339.52Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.605989,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1786"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1340",
  d: "M683.857 350.223L680.931 349.041V365.898L683.857 367.08V350.223Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.396271,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1787"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1341",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M683.868 350.228L716.182 339.523L692.678 330.027L680.942 349.046L683.868 350.228Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1788"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1342",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M683.868 350.228V367.086L716.182 356.381V339.524L683.868 350.228Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1789"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1343",
  d: "M739.691 349.023L716.169 339.52V356.377L739.691 365.88V349.023Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.605989,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1790"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1344",
  d: "M717.662 370.73L694.141 361.226V364.389L717.662 373.892V370.73Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1791"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1345",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M717.677 370.736L739.702 349.027L716.198 339.531L694.141 361.226L717.677 370.736Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1792"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1346",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M717.678 370.736V373.898L739.702 365.884V349.027L717.678 370.736Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1793"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1347",
  d: "M692.649 313.049L669.127 303.545V320.403L692.649 329.906V313.049Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.605989,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1794"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1348",
  d: "M660.34 323.753L657.415 322.571V339.429L660.34 340.611V323.753Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.396271,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1795"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1349",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M660.345 323.757L692.659 313.052L669.155 303.556L657.419 322.575L660.345 323.757Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1796"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1350",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M660.345 323.757V340.615L692.659 329.91V313.052L660.345 323.757Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1797"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1351",
  d: "M716.171 322.552L692.649 313.048V329.906L716.171 339.409V322.552Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.605989,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1798"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1352",
  d: "M694.142 344.259L670.62 334.755V337.918L694.142 347.421V344.259Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1799"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1353",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M694.157 344.265L716.181 322.556L692.678 313.06L670.62 334.755L694.157 344.265Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1800"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1354",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M694.157 344.265V347.427L716.182 339.413V322.556L694.157 344.265Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1801"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1355",
  d: "M739.691 332.055L716.169 322.552V339.409L739.691 348.913V332.055Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.605989,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1802"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1356",
  d: "M707.395 342.759L704.469 341.577V358.435L707.395 359.617V342.759Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.396271,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1803"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1357",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M707.388 342.764L739.701 332.059L716.197 322.563L704.462 341.582L707.388 342.764Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1804"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1358",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M707.389 342.764V359.621L739.702 348.917V332.059L707.389 342.764Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1805"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1359",
  d: "M692.649 295.491L669.127 285.987V302.845L692.649 312.348V295.491Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.605989,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1806"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1360",
  d: "M670.619 317.198L647.097 307.694V310.857L670.619 320.36V317.198Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1807"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1361",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M670.634 317.204L692.658 295.495L669.155 285.999L647.097 307.694L670.634 317.204Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1808"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1362",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M670.634 317.204V320.366L692.659 312.352V295.495L670.634 317.204Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1809"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1363",
  d: "M716.171 304.995L692.649 295.491V312.349L716.171 321.852V304.995Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.605989,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1810"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1364",
  d: "M683.857 315.699L680.931 314.517V331.375L683.857 332.557V315.699Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.396271,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1811"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1365",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M683.868 315.703L716.182 304.998L692.678 295.502L680.942 314.521L683.868 315.703Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1812"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1366",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M683.868 315.703V332.56L716.182 321.856V304.998L683.868 315.703Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1813"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1367",
  d: "M739.691 314.498L716.169 304.994V321.852L739.691 331.355V314.498Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.605989,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1814"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1368",
  d: "M717.662 336.205L694.141 326.701V329.864L717.662 339.367V336.205Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1815"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1369",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M717.677 336.21L739.702 314.501L716.198 305.005L694.141 326.701L717.677 336.21Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1816"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1370",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M717.678 336.211V339.373L739.702 331.359V314.502L717.678 336.211Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1817"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1371",
  d: "M692.649 278.523L669.127 269.02V285.877L692.649 295.381V278.523Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.605989,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1818"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1372",
  d: "M660.34 289.228L657.415 288.046V304.903L660.34 306.085V289.228Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.396271,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1819"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1373",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M660.345 289.232L692.659 278.527L669.155 269.031L657.419 288.049L660.345 289.232Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1820"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1374",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M660.345 289.232V306.089L692.659 295.385V278.527L660.345 289.232Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1821"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1375",
  d: "M716.171 288.026L692.649 278.523V295.381L716.171 304.884V288.026Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.605989,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1822"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1376",
  d: "M694.142 309.733L670.62 300.23V303.393L694.142 312.896V309.733Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1823"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1377",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M694.157 309.739L716.181 288.03L692.678 278.534L670.62 300.23L694.157 309.739Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1824"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1378",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M694.157 309.74V312.902L716.182 304.888V288.03L694.157 309.74Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1825"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1379",
  d: "M739.691 297.53L716.169 288.027V304.884L739.691 314.388V297.53Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.605989,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1826"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1380",
  d: "M707.395 308.234L704.469 307.052V323.909L707.395 325.091V308.234Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.396271,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1827"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1381",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M707.388 308.238L739.701 297.534L716.197 288.038L704.462 307.056L707.388 308.238Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1828"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1382",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M707.389 308.238V325.096L739.702 314.391V297.534L707.389 308.238Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1829"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1383",
  d: "M692.649 260.966L669.127 251.462V268.32L692.649 277.823V260.966Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.605989,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1830"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1384",
  d: "M670.619 282.672L647.097 273.169V276.332L670.619 285.835V282.672Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1831"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1385",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M670.634 282.678L692.658 260.969L669.155 251.473L647.097 273.169L670.634 282.678Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1832"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1386",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M670.634 282.678V285.841L692.659 277.827V260.969L670.634 282.678Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1833"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1387",
  d: "M716.171 270.469L692.649 260.965V277.823L716.171 287.326V270.469Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.605989,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1834"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1388",
  d: "M683.857 281.174L680.931 279.992V296.849L683.857 298.031V281.174Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.396271,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1835"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1389",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M683.868 281.177L716.182 270.473L692.678 260.977L680.942 279.995L683.868 281.177Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1836"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1390",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M683.868 281.177V298.035L716.182 287.33V270.473L683.868 281.177Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1837"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1391",
  d: "M739.691 279.972L716.169 270.469V287.326L739.691 296.83V279.972Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.605989,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1838"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1392",
  d: "M717.662 301.679L694.141 292.176V295.339L717.662 304.842V301.679Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1839"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1393",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M717.677 301.685L739.702 279.976L716.198 270.48L694.141 292.176L717.677 301.685Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1840"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1394",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M717.678 301.686V304.848L739.702 296.834V279.976L717.678 301.686Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1841"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1395",
  d: "M692.649 243.998L669.127 234.495V251.352L692.649 260.856V243.998Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.605989,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1842"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1396",
  d: "M660.34 254.702L657.415 253.52V270.377L660.34 271.559V254.702Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.396271,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1843"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1397",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M660.345 254.706L692.659 244.002L669.155 234.506L657.419 253.524L660.345 254.706Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1844"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1398",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M660.345 254.706V271.564L692.659 260.859V244.002L660.345 254.706Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1845"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1399",
  d: "M716.171 253.501L692.649 243.998V260.855L716.171 270.358V253.501Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.605989,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1846"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1400",
  d: "M694.142 275.208L670.62 265.705V268.867L694.142 278.371V275.208Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1847"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1401",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M694.157 275.214L716.181 253.505L692.678 244.009L670.62 265.705L694.157 275.214Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1848"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1402",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M694.157 275.214V278.377L716.182 270.363V253.505L694.157 275.214Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1849"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1403",
  d: "M739.691 263.005L716.169 253.501V270.359L739.691 279.862V263.005Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.605989,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1850"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1404",
  d: "M707.395 273.708L704.469 272.526V289.383L707.395 290.565V273.708Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.396271,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1851"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1405",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M707.388 273.713L739.701 263.008L716.197 253.512L704.462 272.531L707.388 273.713Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1852"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1406",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M707.389 273.713V290.571L739.702 279.866V263.008L707.389 273.713Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1853"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1854"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1407",
  d: "M692.665 226.439L669.144 216.935V233.793L692.665 243.296V226.439Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1855"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1408",
  d: "M670.635 248.146L647.113 238.643V241.806L670.635 251.309V248.146Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1856"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1409",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M670.65 248.153L692.674 226.444L669.17 216.947L647.113 238.643L670.65 248.153Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1857"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1410",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M670.65 248.153V251.315L692.674 243.301V226.443L670.65 248.153Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1858"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1859"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1411",
  d: "M716.186 235.942L692.665 226.439V243.296L716.186 252.8V235.942Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1860"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1412",
  d: "M683.856 246.648L680.931 245.466V262.324L683.856 263.506V246.648Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.396271,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1861"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1413",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M683.882 246.651L716.196 235.946L692.692 226.45L680.957 245.469L683.882 246.651Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1862"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1414",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M683.883 246.651V263.509L716.197 252.804V235.947L683.883 246.651Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1863"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1864"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1415",
  d: "M739.708 245.447L716.186 235.944V252.801L739.708 262.305V245.447Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1865"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1416",
  d: "M717.678 267.155L694.156 257.651V260.814L717.678 270.317V267.155Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1866"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1417",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M717.693 267.161L739.717 245.451L716.213 235.955L694.156 257.651L717.693 267.161Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1867"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1418",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M717.693 267.161V270.323L739.718 262.309V245.452L717.693 267.161Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1868"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1869"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1419",
  d: "M692.665 209.472L669.143 199.969V216.826L692.665 226.33V209.472Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1870"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1420",
  d: "M660.334 220.179L657.409 218.997V235.854L660.334 237.036V220.179Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.396271,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1871"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1421",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M660.36 220.181L692.674 209.477L669.17 199.981L657.435 218.999L660.36 220.181Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1872"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1422",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M660.361 220.181V237.039L692.675 226.334V209.477L660.361 220.181Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1873"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1874"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1423",
  d: "M716.186 218.975L692.665 209.472V226.329L716.186 235.833V218.975Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1875"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1424",
  d: "M694.157 240.683L670.635 231.18V234.342L694.157 243.846V240.683Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1876"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1425",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M694.172 240.689L716.196 218.98L692.692 209.484L670.635 231.18L694.172 240.689Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1877"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1426",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M694.171 240.689V243.851L716.195 235.837V218.98L694.171 240.689Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1878"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1879"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1427",
  d: "M739.708 228.478L716.186 218.975V235.832L739.708 245.336V228.478Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1880"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1428",
  d: "M707.378 239.185L704.452 238.003V254.86L707.378 256.042V239.185Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.396271,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1881"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1429",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M707.404 239.187L739.717 228.483L716.214 218.987L704.478 238.005L707.404 239.187Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1882"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1430",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M707.403 239.187V256.045L739.717 245.34V228.483L707.403 239.187Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1883"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1884"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1431",
  d: "M692.665 192.081L669.144 182.577V199.435L692.665 208.938V192.081Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1885"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1432",
  d: "M670.635 213.788L647.113 204.285V207.447L670.635 216.951V213.788Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1886"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1433",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M670.65 213.794L692.674 192.085L669.17 182.589L647.113 204.285L670.65 213.794Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1887"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1434",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M670.65 213.794V216.957L692.674 208.943V192.085L670.65 213.794Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1888"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1889"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1435",
  d: "M716.186 201.583L692.665 192.08V208.938L716.186 218.441V201.583Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1890"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1436",
  d: "M683.856 212.29L680.931 211.108V227.965L683.856 229.147V212.29Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.396271,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1891"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1437",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M683.882 212.292L716.196 201.588L692.692 192.092L680.957 211.11L683.882 212.292Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1892"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1438",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M683.883 212.293V229.15L716.197 218.446V201.588L683.883 212.293Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1893"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1894"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1439",
  d: "M739.708 211.089L716.186 201.585V218.443L739.708 227.946V211.089Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1895"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1440",
  d: "M717.678 232.796L694.156 223.293V226.455L717.678 235.959V232.796Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1896"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1441",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M717.693 232.802L739.717 211.093L716.213 201.597L694.156 223.293L717.693 232.802Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1897"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1442",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M717.693 232.802V235.965L739.718 227.951V211.093L717.693 232.802Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1898"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1899"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1443",
  d: "M692.665 175.114L669.143 165.61V182.468L692.665 191.971V175.114Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1900"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1444",
  d: "M660.334 185.82L657.409 184.638V201.496L660.334 202.678V185.82Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.396271,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1901"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1445",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M660.36 185.823L692.674 175.118L669.17 165.622L657.435 184.641L660.36 185.823Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1902"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1446",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M660.361 185.823V202.681L692.675 191.976V175.119L660.361 185.823Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1903"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1904"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1447",
  d: "M716.186 184.617L692.665 175.113V191.971L716.186 201.474V184.617Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1905"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1448",
  d: "M694.157 206.325L670.635 196.821V199.984L694.157 209.487V206.325Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1906"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1449",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M694.172 206.331L716.196 184.622L692.692 175.126L670.635 196.821L694.172 206.331Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1907"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1450",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M694.171 206.331V209.493L716.195 201.479V184.621L694.171 206.331Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1908"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1909"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1451",
  d: "M739.708 194.12L716.186 184.617V201.474L739.708 210.977V194.12Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1910"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1452",
  d: "M707.378 204.826L704.452 203.644V220.502L707.378 221.684V204.826Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.396271,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1911"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1453",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M707.404 204.829L739.717 194.124L716.214 184.628L704.478 203.647L707.404 204.829Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1912"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1454",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M707.403 204.829V221.687L739.717 210.982V194.124L707.403 204.829Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1913"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1914"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1455",
  d: "M692.665 157.722L669.144 148.219V165.076L692.665 174.58V157.722Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1915"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1456",
  d: "M670.635 179.43L647.113 169.926V173.089L670.635 182.592V179.43Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1916"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1457",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M670.65 179.436L692.674 157.727L669.17 148.231L647.113 169.927L670.65 179.436Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1917"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1458",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M670.65 179.436V182.598L692.674 174.584V157.726L670.65 179.436Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1918"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1919"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1459",
  d: "M716.186 167.225L692.665 157.722V174.579L716.186 184.083V167.225Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1920"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1460",
  d: "M683.856 177.932L680.931 176.75V193.607L683.856 194.789V177.932Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.396271,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1921"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1461",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M683.882 177.934L716.196 167.23L692.692 157.734L680.957 176.752L683.882 177.934Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1922"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1462",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M683.883 177.934V194.792L716.197 184.087V167.23L683.883 177.934Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1923"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1924"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1463",
  d: "M739.708 176.73L716.186 167.227V184.085L739.708 193.588V176.73Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1925"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1464",
  d: "M717.678 198.438L694.156 188.934V192.097L717.678 201.6V198.438Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1926"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1465",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M717.693 198.444L739.717 176.735L716.213 167.239L694.156 188.935L717.693 198.444Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1927"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1466",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M717.693 198.444V201.607L739.718 193.593V176.735L717.693 198.444Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1928"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1929"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1467",
  d: "M692.665 140.756L669.143 131.252V148.11L692.665 157.613V140.756Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1930"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1468",
  d: "M660.334 151.462L657.409 150.28V167.138L660.334 168.32V151.462Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.396271,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1931"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1469",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M660.36 151.465L692.674 140.76L669.17 131.264L657.435 150.283L660.36 151.465Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1932"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1470",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M660.361 151.465V168.323L692.675 157.618V140.76L660.361 151.465Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1933"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1934"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1471",
  d: "M716.186 150.259L692.665 140.755V157.613L716.186 167.116V150.259Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1935"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1472",
  d: "M694.157 171.966L670.635 162.463V165.625L694.157 175.129V171.966Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1936"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1473",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M694.172 171.973L716.196 150.263L692.692 140.767L670.635 162.463L694.172 171.973Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1937"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1474",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M694.171 171.972V175.135L716.195 167.12V150.263L694.171 171.972Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1938"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1939"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1475",
  d: "M739.708 159.762L716.186 150.258V167.116L739.708 176.619V159.762Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1940"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1476",
  d: "M707.378 170.468L704.452 169.286V186.144L707.378 187.326V170.468Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.396271,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1941"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1477",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M707.404 170.471L739.717 159.766L716.214 150.27L704.478 169.289L707.404 170.471Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1942"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1478",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M707.403 170.471V187.328L739.717 176.624V159.766L707.403 170.471Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1943"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1944"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1479",
  d: "M692.664 122.87L669.143 113.367V130.224L692.664 139.728V122.87Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1945"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1480",
  d: "M670.635 144.578L647.113 135.074V138.237L670.635 147.74V144.578Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1946"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1481",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M670.649 144.584L692.674 122.875L669.17 113.379L647.112 135.074L670.649 144.584Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1947"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1482",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M670.649 144.584V147.746L692.674 139.732V122.875L670.649 144.584Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1948"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1949"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1483",
  d: "M716.186 132.373L692.665 122.87V139.727L716.186 149.231V132.373Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1950"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1484",
  d: "M683.856 143.08L680.931 141.898V158.755L683.856 159.937V143.08Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.396271,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1951"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1485",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M683.882 143.082L716.196 132.378L692.692 122.881L680.957 141.9L683.882 143.082Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1952"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1486",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M683.883 143.082V159.94L716.197 149.235V132.378L683.883 143.082Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1953"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1954"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1487",
  d: "M739.708 141.878L716.186 132.375V149.232L739.708 158.736V141.878Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1955"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1488",
  d: "M717.678 163.586L694.156 154.083V157.245L717.678 166.748V163.586Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1956"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1489",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M717.693 163.592L739.717 141.883L716.213 132.387L694.156 154.083L717.693 163.592Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1957"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1490",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M717.693 163.592V166.754L739.718 158.74V141.883L717.693 163.592Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1958"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1959"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1960"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1961"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1491",
  d: "M762.234 358.195L738.712 348.692V365.549L762.234 375.052V358.195Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1962"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1492",
  d: "M729.904 368.901L726.978 367.719V384.577L729.904 385.759V368.901Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.396271,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1963"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1493",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M729.93 368.904L762.244 358.199L738.74 348.703L727.004 367.722L729.93 368.904Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1964"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1494",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M729.93 368.904V385.762L762.244 375.057V358.199L729.93 368.904Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1965"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1966"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1495",
  d: "M785.757 367.698L762.235 358.194V375.052L785.757 384.555V367.698Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1967"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1496",
  d: "M763.726 389.405L740.205 379.902V383.064L763.726 392.568V389.405Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1968"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1497",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M763.742 389.411L785.766 367.702L762.262 358.206L740.205 379.902L763.742 389.411Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1969"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1498",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M763.741 389.411V392.574L785.766 384.56V367.702L763.741 389.411Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1970"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1971"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1499",
  d: "M762.234 341.065L738.712 331.562V348.419L762.234 357.922V341.065Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1972"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1500",
  d: "M740.203 362.773L716.682 353.269V356.432L740.203 365.935V362.773Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1973"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1501",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M740.219 362.779L762.243 341.07L738.739 331.573L716.682 353.269L740.219 362.779Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1974"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1502",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M740.219 362.779V365.941L762.244 357.927V341.07L740.219 362.779Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1975"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1976"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1503",
  d: "M785.757 350.57L762.235 341.067V357.924L785.757 367.428V350.57Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1977"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1504",
  d: "M753.426 361.277L750.5 360.095V376.952L753.426 378.134V361.277Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.396271,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1978"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1505",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M753.452 361.279L785.766 350.575L762.262 341.078L750.526 360.097L753.452 361.279Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1979"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1506",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M753.453 361.279V378.137L785.767 367.432V350.575L753.453 361.279Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1980"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1981"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1507",
  d: "M762.234 323.675L738.712 314.172V331.029L762.234 340.533V323.675Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1982"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1508",
  d: "M729.904 334.382L726.978 333.2V350.057L729.904 351.239V334.382Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.396271,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1983"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1509",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M729.93 334.385L762.244 323.68L738.74 314.184L727.004 333.202L729.93 334.385Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1984"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1510",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M729.93 334.385V351.242L762.244 340.537V323.68L729.93 334.385Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1985"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1986"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1511",
  d: "M785.757 333.179L762.235 323.675V340.533L785.757 350.036V333.179Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1987"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1512",
  d: "M763.726 354.886L740.205 345.383V348.545L763.726 358.049V354.886Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1988"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1513",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M763.742 354.892L785.766 333.183L762.262 323.687L740.205 345.383L763.742 354.892Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1989"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1514",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M763.741 354.892V358.055L785.766 350.041V333.183L763.741 354.892Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1990"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1991"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1515",
  d: "M762.234 306.706L738.712 297.203V314.06L762.234 323.564V306.706Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1992"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1516",
  d: "M740.203 328.414L716.682 318.911V322.073L740.203 331.577V328.414Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1993"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1517",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M740.219 328.42L762.243 306.711L738.739 297.215L716.682 318.911L740.219 328.42Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1994"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1518",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M740.219 328.42V331.583L762.244 323.569V306.711L740.219 328.42Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1995"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1996"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1519",
  d: "M785.757 316.212L762.235 306.708V323.566L785.757 333.069V316.212Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1997"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1520",
  d: "M753.426 326.918L750.5 325.736V342.594L753.426 343.776V326.918Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.396271,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1998"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1521",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M753.452 326.921L785.766 316.216L762.262 306.72L750.526 325.739L753.452 326.921Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_1999"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1522",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M753.453 326.921V343.778L785.767 333.074V316.216L753.453 326.921Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2000"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2001"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1523",
  d: "M762.234 289.317L738.712 279.814V296.671L762.234 306.175V289.317Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2002"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1524",
  d: "M729.904 300.024L726.978 298.842V315.699L729.904 316.881V300.024Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.396271,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2003"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1525",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M729.93 300.026L762.244 289.321L738.74 279.825L727.004 298.844L729.93 300.026Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2004"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1526",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M729.93 300.026V316.884L762.244 306.179V289.321L729.93 300.026Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2005"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2006"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1527",
  d: "M785.757 298.82L762.235 289.317V306.174L785.757 315.677V298.82Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2007"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1528",
  d: "M763.726 320.528L740.205 311.024V314.187L763.726 323.69V320.528Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2008"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1529",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M763.742 320.534L785.766 298.825L762.262 289.328L740.205 311.024L763.742 320.534Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2009"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1530",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M763.741 320.534V323.696L785.766 315.682V298.825L763.741 320.534Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2010"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2011"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1531",
  d: "M762.234 272.348L738.712 262.845V279.702L762.234 289.206V272.348Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2012"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1532",
  d: "M740.203 294.056L716.682 284.553V287.715L740.203 297.219V294.056Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2013"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1533",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M740.219 294.062L762.243 272.353L738.739 262.857L716.682 284.553L740.219 294.062Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2014"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1534",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M740.219 294.062V297.224L762.244 289.21V272.353L740.219 294.062Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2015"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2016"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1535",
  d: "M785.757 281.853L762.235 272.35V289.207L785.757 298.711V281.853Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2017"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1536",
  d: "M753.426 292.56L750.5 291.378V308.235L753.426 309.417V292.56Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.396271,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2018"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1537",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M753.452 292.563L785.766 281.858L762.262 272.362L750.526 291.381L753.452 292.563Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2019"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1538",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M753.453 292.563V309.42L785.767 298.715V281.858L753.453 292.563Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2020"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2021"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1539",
  d: "M762.234 254.465L738.712 244.962V261.819L762.234 271.323V254.465Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2022"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1540",
  d: "M729.904 265.172L726.978 263.99V280.847L729.904 282.029V265.172Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.396271,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2023"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1541",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M729.93 265.174L762.244 254.47L738.74 244.974L727.004 263.992L729.93 265.174Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2024"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1542",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M729.93 265.174V282.032L762.244 271.327V254.47L729.93 265.174Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2025"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2026"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1543",
  d: "M785.757 263.968L762.235 254.464V271.322L785.757 280.825V263.968Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2027"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1544",
  d: "M763.726 285.676L740.205 276.172V279.335L763.726 288.838V285.676Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2028"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1545",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M763.742 285.682L785.766 263.973L762.262 254.476L740.205 276.172L763.742 285.682Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2029"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1546",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M763.741 285.682V288.844L785.766 280.83V263.972L763.741 285.682Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2030"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2031"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1547",
  d: "M762.234 237.58L738.712 228.077V244.934L762.234 254.438V237.58Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2032"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1548",
  d: "M740.203 259.288L716.682 249.784V252.947L740.203 262.45V259.288Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2033"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1549",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M740.219 259.294L762.243 237.585L738.739 228.088L716.682 249.784L740.219 259.294Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2034"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1550",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M740.219 259.294V262.456L762.244 254.442V237.585L740.219 259.294Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2035"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2036"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1551",
  d: "M785.757 247.083L762.235 237.579V254.437L785.757 263.94V247.083Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2037"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1552",
  d: "M753.426 257.79L750.5 256.608V273.465L753.426 274.647V257.79Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.396271,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2038"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1553",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M753.452 257.792L785.766 247.088L762.262 237.592L750.526 256.61L753.452 257.792Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2039"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1554",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M753.453 257.792V274.65L785.767 263.945V247.088L753.453 257.792Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2040"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2041"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1555",
  d: "M762.234 220.188L738.712 210.685V227.542L762.234 237.046V220.188Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2042"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1556",
  d: "M729.904 230.895L726.978 229.713V246.57L729.904 247.752V230.895Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.396271,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2043"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1557",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M729.93 230.897L762.244 220.193L738.74 210.697L727.004 229.715L729.93 230.897Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2044"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1558",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M729.93 230.897V247.755L762.244 237.05V220.193L729.93 230.897Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2045"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2046"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1559",
  d: "M785.757 229.693L762.235 220.19V237.047L785.757 246.551V229.693Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2047"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1560",
  d: "M763.726 251.401L740.205 241.898V245.06L763.726 254.564V251.401Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2048"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1561",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M763.742 251.407L785.766 229.698L762.262 220.202L740.205 241.898L763.742 251.407Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2049"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1562",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M763.741 251.407V254.569L785.766 246.555V229.698L763.741 251.407Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2050"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2051"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1563",
  d: "M762.234 203.222L738.712 193.718V210.576L762.234 220.079V203.222Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2052"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1564",
  d: "M740.203 224.929L716.682 215.426V218.588L740.203 228.092V224.929Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2053"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1565",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M740.219 224.935L762.243 203.226L738.739 193.73L716.682 215.426L740.219 224.935Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2054"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1566",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M740.219 224.935V228.098L762.244 220.084V203.226L740.219 224.935Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2055"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2056"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1567",
  d: "M785.757 212.724L762.235 203.221V220.079L785.757 229.582V212.724Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2057"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1568",
  d: "M753.426 223.431L750.5 222.249V239.107L753.426 240.289V223.431Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.396271,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2058"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1569",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M753.452 223.434L785.766 212.729L762.262 203.233L750.526 222.252L753.452 223.434Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2059"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1570",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M753.453 223.434V240.292L785.767 229.587V212.729L753.453 223.434Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2060"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2061"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1571",
  d: "M762.234 185.83L738.712 176.327V193.184L762.234 202.687V185.83Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2062"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1572",
  d: "M729.904 196.537L726.978 195.355V212.212L729.904 213.394V196.537Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.396271,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2063"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1573",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M729.93 196.539L762.244 185.835L738.74 176.339L727.004 195.357L729.93 196.539Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2064"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1574",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M729.93 196.539V213.397L762.244 202.692V185.835L729.93 196.539Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2065"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2066"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1575",
  d: "M785.757 195.335L762.235 185.832V202.689L785.757 212.192V195.335Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2067"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1576",
  d: "M763.726 217.043L740.205 207.539V210.702L763.726 220.205V217.043Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2068"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1577",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M763.742 217.049L785.766 195.34L762.262 185.844L740.205 207.539L763.742 217.049Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2069"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1578",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M763.741 217.049V220.211L785.766 212.197V195.34L763.741 217.049Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2070"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2071"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1579",
  d: "M762.234 168.864L738.712 159.36V176.218L762.234 185.721V168.864Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2072"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1580",
  d: "M740.203 190.571L716.682 181.068V184.23L740.203 193.733V190.571Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2073"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1581",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M740.219 190.577L762.243 168.868L738.739 159.372L716.682 181.068L740.219 190.577Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2074"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1582",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M740.219 190.577V193.74L762.244 185.725V168.868L740.219 190.577Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2075"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2076"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1583",
  d: "M785.757 178.366L762.235 168.863V185.72L785.757 195.224V178.366Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2077"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1584",
  d: "M753.426 189.073L750.5 187.891V204.748L753.426 205.93V189.073Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.396271,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2078"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1585",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M753.452 189.075L785.766 178.371L762.262 168.875L750.526 187.893L753.452 189.075Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2079"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1586",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M753.453 189.075V205.933L785.767 195.228V178.371L753.453 189.075Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2080"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2081"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1587",
  d: "M762.234 150.978L738.712 141.474V158.332L762.234 167.835V150.978Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2082"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1588",
  d: "M729.904 161.684L726.978 160.502V177.36L729.904 178.542V161.684Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.396271,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2083"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1589",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M729.93 161.687L762.244 150.982L738.74 141.486L727.004 160.505L729.93 161.687Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2084"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1590",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M729.93 161.687V178.545L762.244 167.84V150.983L729.93 161.687Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2085"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2086"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1591",
  d: "M785.757 160.483L762.235 150.979V167.837L785.757 177.34V160.483Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2087"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1592",
  d: "M763.726 182.191L740.205 172.687V175.85L763.726 185.353V182.191Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2088"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1593",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M763.742 182.197L785.766 160.488L762.262 150.991L740.205 172.687L763.742 182.197Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2089"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1594",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M763.741 182.197V185.359L785.766 177.345V160.487L763.741 182.197Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2090"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2091"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1595",
  d: "M808.967 377.076L785.445 367.573V384.43L808.967 393.933V377.076Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2092"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1596",
  d: "M776.637 387.782L773.711 386.6V403.458L776.637 404.64V387.782Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.396271,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2093"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1597",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M776.663 387.785L808.977 377.08L785.473 367.584L773.737 386.603L776.663 387.785Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2094"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1598",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M776.664 387.785V404.643L808.977 393.938V377.081L776.664 387.785Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2095"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2096"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1599",
  d: "M808.967 359.946L785.445 350.443V367.3L808.967 376.804V359.946Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2097"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1600",
  d: "M786.937 381.654L763.416 372.15V375.313L786.937 384.816V381.654Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2098"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1601",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M786.952 381.66L808.977 359.951L785.473 350.455L763.416 372.15L786.952 381.66Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2099"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1602",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M786.952 381.66V384.822L808.976 376.808V359.951L786.952 381.66Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2100"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2101"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1603",
  d: "M808.967 342.557L785.445 333.053V349.911L808.967 359.414V342.557Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2102"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1604",
  d: "M776.637 353.263L773.711 352.081V368.939L776.637 370.121V353.263Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.396271,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2103"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1605",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M776.663 353.266L808.977 342.561L785.473 333.065L773.737 352.084L776.663 353.266Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2104"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1606",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M776.664 353.266V370.124L808.977 359.419V342.561L776.664 353.266Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2105"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2106"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1607",
  d: "M808.967 325.588L785.445 316.085V332.942L808.967 342.446V325.588Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2107"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1608",
  d: "M786.937 347.296L763.416 337.792V340.955L786.937 350.458V347.296Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2108"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1609",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M786.952 347.302L808.977 325.593L785.473 316.096L763.416 337.792L786.952 347.302Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2109"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1610",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M786.952 347.302V350.464L808.976 342.45V325.593L786.952 347.302Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2110"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2111"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1611",
  d: "M808.967 308.198L785.445 298.695V315.552L808.967 325.056V308.198Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2112"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1612",
  d: "M776.637 318.905L773.711 317.723V334.58L776.637 335.762V318.905Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.396271,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2113"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1613",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M776.663 318.907L808.977 308.203L785.473 298.707L773.737 317.725L776.663 318.907Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2114"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1614",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M776.664 318.907V335.765L808.977 325.06V308.203L776.664 318.907Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2115"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2116"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1615",
  d: "M808.967 291.23L785.445 281.726V298.584L808.967 308.087V291.23Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2117"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1616",
  d: "M786.937 312.937L763.416 303.434V306.596L786.937 316.1V312.937Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2118"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1617",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M786.952 312.943L808.977 291.234L785.473 281.738L763.416 303.434L786.952 312.943Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2119"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1618",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M786.952 312.943V316.106L808.976 308.092V291.234L786.952 312.943Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2120"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2121"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1619",
  d: "M808.967 273.346L785.445 263.843V280.7L808.967 290.204V273.346Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2122"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1620",
  d: "M776.637 284.053L773.711 282.871V299.728L776.637 300.91V284.053Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.396271,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2123"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1621",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M776.663 284.055L808.977 273.351L785.473 263.855L773.737 282.873L776.663 284.055Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2124"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1622",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M776.664 284.055V300.913L808.977 290.208V273.351L776.664 284.055Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2125"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2126"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1623",
  d: "M808.967 256.461L785.445 246.958V263.815L808.967 273.319V256.461Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2127"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1624",
  d: "M786.937 278.169L763.416 268.665V271.828L786.937 281.331V278.169Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2128"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1625",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M786.952 278.175L808.977 256.466L785.473 246.97L763.416 268.666L786.952 278.175Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2129"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1626",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M786.952 278.175V281.337L808.976 273.323V256.466L786.952 278.175Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2130"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2131"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1627",
  d: "M808.967 239.069L785.445 229.566V246.424L808.967 255.927V239.069Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2132"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1628",
  d: "M776.637 249.776L773.711 248.594V265.451L776.637 266.633V249.776Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.396271,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2133"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1629",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M776.663 249.779L808.977 239.074L785.473 229.578L773.737 248.596L776.663 249.779Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2134"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1630",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M776.664 249.779V266.636L808.977 255.932V239.074L776.664 249.779Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2135"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2136"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1631",
  d: "M808.967 222.103L785.445 212.599V229.457L808.967 238.96V222.103Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2137"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1632",
  d: "M786.937 243.81L763.416 234.307V237.47L786.937 246.973V243.81Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2138"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1633",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M786.952 243.817L808.977 222.107L785.473 212.611L763.416 234.307L786.952 243.817Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2139"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1634",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M786.952 243.817V246.979L808.976 238.965V222.107L786.952 243.817Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2140"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2141"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1635",
  d: "M808.967 204.711L785.445 195.208V212.065L808.967 221.568V204.711Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2142"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1636",
  d: "M776.637 215.418L773.711 214.235V231.093L776.637 232.275V215.418Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.396271,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2143"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1637",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M776.663 215.42L808.977 204.716L785.473 195.22L773.737 214.238L776.663 215.42Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2144"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1638",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M776.664 215.42V232.278L808.977 221.573V204.716L776.664 215.42Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2145"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2146"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1639",
  d: "M808.967 187.744L785.445 178.241V195.098L808.967 204.602V187.744Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2147"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1640",
  d: "M786.937 209.452L763.416 199.949V203.111L786.937 212.615V209.452Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2148"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1641",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M786.952 209.458L808.977 187.749L785.473 178.253L763.416 199.949L786.952 209.458Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2149"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1642",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M786.952 209.458V212.621L808.976 204.607V187.749L786.952 209.458Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2150"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2151"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1643",
  d: "M808.967 169.859L785.445 160.356V177.213L808.967 186.717V169.859Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.60599,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2152"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1644",
  d: "M776.637 180.565L773.711 179.383V196.241L776.637 197.423V180.565Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.396271,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2153"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1645",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M776.663 180.568L808.977 169.864L785.473 160.368L773.737 179.386L776.663 180.568Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2154"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1646",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M776.664 180.568V197.426L808.977 186.721V169.864L776.664 180.568Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.355435,
  strokeMiterlimit: 1.5
}))))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2155"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group 7"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1647",
  d: "M354.966 482.214C362.366 479.2 368.366 470.278 368.366 462.288C368.366 454.297 362.366 450.263 354.966 453.278C347.566 456.292 341.567 465.213 341.567 473.204C341.567 481.194 347.566 485.229 354.966 482.214Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1648",
  d: "M491.163 426.736C498.564 423.722 504.563 414.801 504.563 406.81C504.563 398.82 498.564 394.785 491.163 397.8C483.763 400.814 477.764 409.736 477.764 417.726C477.764 425.717 483.763 429.751 491.163 426.736Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1649",
  d: "M358.947 482.545C366.347 479.531 372.346 470.609 372.346 462.619C372.346 454.628 366.347 450.594 358.947 453.608C351.546 456.623 345.547 465.544 345.547 473.535C345.547 481.525 351.546 485.559 358.947 482.545Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1650",
  d: "M353.86 459.924L338.974 454",
  stroke: "#6E32F0",
  strokeWidth: 0.963631,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1651",
  d: "M495.144 427.068C502.544 424.053 508.543 415.132 508.543 407.141C508.543 399.151 502.544 395.117 495.144 398.131C487.744 401.146 481.745 410.067 481.745 418.057C481.745 426.048 487.744 430.082 495.144 427.068Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1652",
  d: "M361.93 482.653C369.33 479.639 375.33 470.717 375.33 462.727C375.33 454.736 369.33 450.702 361.93 453.716C354.53 456.731 348.531 465.652 348.531 473.643C348.531 481.633 354.53 485.667 361.93 482.653Z",
  fill: "white",
  stroke: "#6E32F0",
  strokeWidth: 1.21745,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1653",
  d: "M498.127 427.174C505.527 424.16 511.526 415.238 511.526 407.248C511.526 399.257 505.527 395.223 498.127 398.237C490.727 401.252 484.728 410.173 484.728 418.164C484.728 426.154 490.727 430.188 498.127 427.174Z",
  fill: "white",
  stroke: "#6E32F0",
  strokeWidth: 1.21745,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1654",
  d: "M384.447 472.225C391.847 469.211 397.847 460.289 397.847 452.299C397.847 444.308 391.847 440.274 384.447 443.288C377.047 446.303 371.048 455.224 371.048 463.215C371.048 471.205 377.047 475.239 384.447 472.225Z",
  fill: "white",
  stroke: "#6E32F0",
  strokeWidth: 1.21745,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1655",
  d: "M520.645 416.747C528.045 413.733 534.044 404.812 534.044 396.821C534.044 388.831 528.045 384.796 520.645 387.811C513.245 390.825 507.246 399.747 507.246 407.737C507.246 415.728 513.245 419.762 520.645 416.747Z",
  fill: "white",
  stroke: "#6E32F0",
  strokeWidth: 1.21745,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1656",
  d: "M490.057 404.447L478.411 399.744",
  stroke: "#6E32F0",
  strokeWidth: 0.963631,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1657",
  d: "M528.242 387.259L520.529 384.144",
  stroke: "#6E32F0",
  strokeWidth: 1.03321,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1658",
  d: "M591.973 393.411L556.516 379.086L326.153 472.92L361.611 487.246L591.973 393.411Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1659",
  d: "M252.663 412.852L210.973 429.833L325.958 476.29L556.317 382.457L531.841 372.567",
  stroke: "#D1DAE9",
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1660",
  d: "M535.441 387.954L489.157 406.81L475.047 401.11",
  stroke: "#6E32F0",
  strokeWidth: 0.851653,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1661",
  d: "M535.447 387.961L521.49 382.323",
  stroke: "#6E32F0",
  strokeWidth: 1.00591,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1662",
  d: "M399.244 443.431L352.96 462.288L335.473 455",
  stroke: "#6E32F0",
  strokeWidth: 0.851653,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1663",
  d: "M392.045 442.737L384.332 439.621",
  stroke: "#6E32F0",
  strokeWidth: 1.03321,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1664",
  d: "M399.25 443.439L385.292 437.801",
  stroke: "#6E32F0",
  strokeWidth: 1.00591,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1665",
  d: "M398.922 431.937V424.363C399.864 420.078 392.866 385.848 393.422 379.937L385.075 383.359C360.763 394.104 339.618 405.606 330.651 412.177C329.731 412.857 349.27 409.406 349.27 409.406L351.796 409.779L345.461 418.249C342.208 422.376 336.002 423.944 328.233 424.164C328.233 424.164 310.256 425.612 302.423 424.363C294.141 423.045 278.539 416.17 278.539 416.17C278.539 416.17 262.617 409.375 260.733 406.576C259.706 405.062 258.294 398.241 258.893 392.536C257.266 395.347 256.432 398.089 255.747 401.911C254.591 408.339 254.591 416.288 256.71 427.074C257.866 430.325 267.432 435.164 278.539 440.291C289.882 445.407 301.31 449.369 312.952 450.52L319.801 454.445C329.153 455.919 338.762 456.25 349.27 452.76C349.27 452.76 350.597 443.796 351.196 437.536C352.373 425.055 360.613 412.831 372.212 408.099C383.833 403.376 393.25 409.71 393.25 422.244C393.25 427.732 392.907 431.749 391.345 435.631L398.922 431.937Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2156"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2157"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1666",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M507.001 332.936L500.884 359.697C500.014 363.501 496.409 365.418 492.835 363.974L445.549 344.869C441.976 343.426 439.782 339.166 440.652 335.361L444.631 307.737C448.27 304.165 451.244 302.879 454.817 304.323L502.103 323.428C505.677 324.871 507.87 329.132 507.001 332.936Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.72359,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2158"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1667",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M502.497 334.561L496.935 358.895C496.144 362.354 492.863 364.097 489.614 362.784L442.002 343.547C438.757 342.236 436.759 338.361 437.55 334.902L443.112 310.568C443.903 307.109 447.184 305.366 450.429 306.678L498.041 325.914C501.29 327.227 503.288 331.102 502.497 334.561Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.723429,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2159"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1668",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M493.126 366.985L483.49 370.91C479.818 372.406 474.759 372.78 472.194 371.744L418.308 349.972C415.748 348.938 416.895 344.116 416.872 340.476L429.958 341.463C433.63 339.967 438.691 339.593 441.251 340.627L496.577 356.157C496.583 360.123 496.798 365.489 493.126 366.985Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 1.1509,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2160"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1669",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M493.116 359.335L483.479 363.26C479.807 364.756 474.748 365.13 472.183 364.094L418.298 342.322C415.737 341.288 416.638 339.234 420.31 337.738L429.947 333.813C433.619 332.317 438.681 331.942 441.241 332.977L495.127 354.748C497.691 355.784 496.788 357.839 493.116 359.335Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 1.1509,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2161"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1670",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M419.013 333.743L404.818 341.413L411.858 349.628L416.036 341.953L420.906 337.058L419.013 333.743Z",
  fill: "white"
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2162"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1671",
  d: "M437.167 347.965L455.486 340.503",
  stroke: "#8496B9",
  strokeWidth: 0.779838,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2163"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1672",
  d: "M459.45 337.751L465.855 316.755",
  stroke: "#8496B9",
  strokeWidth: 0.779838,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2164"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1673",
  d: "M453.431 354.831L471.749 347.369",
  stroke: "#8496B9",
  strokeWidth: 0.779838,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2165"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1674",
  d: "M475.73 344.619L482.135 323.622",
  stroke: "#8496B9",
  strokeWidth: 0.779838,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2166"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2167"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1675",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M452.687 355.98L446.57 382.741C445.7 386.545 442.095 388.462 438.521 387.019L428.648 383.029C425.074 381.586 422.88 377.325 423.75 373.521L427.729 345.897C431.368 342.325 434.342 341.039 437.915 342.483L447.789 346.472C451.363 347.916 453.556 352.176 452.687 355.98Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.72359,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2168"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1676",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M448.184 357.605L442.622 381.939C441.831 385.399 438.55 387.141 435.301 385.828L425.102 381.707C421.852 380.394 419.86 376.521 420.65 373.062L426.212 348.728C427.003 345.269 430.28 343.525 433.529 344.837L443.729 348.958C446.978 350.271 448.975 354.146 448.184 357.605Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.723429,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2169"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1677",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M438.813 390.029L429.177 393.954C425.505 395.45 420.446 395.824 417.881 394.788L401.408 388.132C398.848 387.098 399.995 382.276 399.972 378.636L413.058 379.623C416.73 378.127 421.791 377.752 424.351 378.787L442.264 379.201C442.27 383.167 442.485 388.533 438.813 390.029Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 1.1509,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2170"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1678",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M438.802 382.379L429.165 386.304C425.493 387.8 420.434 388.174 417.87 387.138L401.397 380.482C398.837 379.448 399.738 377.394 403.41 375.898L413.047 371.973C416.719 370.477 421.78 370.102 424.34 371.137L440.813 377.792C443.378 378.828 442.474 380.883 438.802 382.379Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 1.1509,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group 4"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1679",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M450.033 342.131L449.296 344.873C448.473 347 444.057 347.383 441.925 346.521L438.601 345.045C436.469 344.183 435.159 341.641 435.678 339.371L435.139 336.113C437.311 333.982 439.086 333.215 441.218 334.076L447.11 336.457C449.243 337.318 450.552 339.861 450.033 342.131Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.72359,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1680",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M447.346 343.101L446.94 344.395C446.468 346.459 444.51 347.499 442.571 346.715L436.485 344.256C434.546 343.473 433.356 341.162 433.828 339.097L434.235 337.803C434.706 335.739 436.662 334.698 438.601 335.481L444.687 337.941C446.626 338.724 447.818 341.036 447.346 343.101Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.723429,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2171"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1681",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M466.811 307.459L461.617 309.575L458.853 320.665L451.585 317.728L454.349 306.639L459.543 304.523L466.811 307.459Z",
  fill: "white",
  stroke: "#6E32F0",
  strokeWidth: 1.62879,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2172"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2173"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1682",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M413.678 336.325L407.561 363.086C406.691 366.89 403.085 368.807 399.512 367.364L389.638 363.374C386.065 361.931 383.871 357.67 384.741 353.866L388.719 326.242C392.359 322.67 395.333 321.384 398.906 322.828L408.78 326.817C412.353 328.261 414.547 332.521 413.678 336.325Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.72359,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2174"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1683",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M409.175 337.95L403.613 362.284C402.822 365.744 399.541 367.486 396.292 366.173L386.092 362.052C382.843 360.739 380.85 356.866 381.641 353.407L387.203 329.073C387.994 325.614 391.271 323.87 394.52 325.182L404.719 329.303C407.969 330.616 409.966 334.491 409.175 337.95Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.723429,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2175"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1684",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M399.804 370.374L390.167 374.3C386.495 375.795 381.436 376.169 378.872 375.133L362.399 368.477C359.839 367.443 360.986 362.621 360.963 358.981L374.049 359.968C377.721 358.472 382.782 358.098 385.342 359.132L403.255 359.546C403.261 363.512 403.476 368.878 399.804 370.374Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 1.1509,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2176"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1685",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M399.793 362.724L390.156 366.649C386.484 368.145 381.425 368.519 378.861 367.483L362.388 360.827C359.828 359.793 360.729 357.739 364.401 356.243L374.037 352.318C377.71 350.822 382.771 350.447 385.331 351.482L401.804 358.137C404.368 359.173 403.465 361.228 399.793 362.724Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 1.1509,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group 4_2"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1686",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M411.032 322.131L410.295 324.873C409.472 327 405.056 327.383 402.924 326.521L399.6 325.045C397.468 324.183 396.158 321.641 396.677 319.371L396.138 316.113C398.31 313.982 400.085 313.215 402.217 314.076L408.109 316.457C410.242 317.318 411.551 319.861 411.032 322.131Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.72359,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1687",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M408.345 323.101L407.939 324.395C407.467 326.459 405.509 327.499 403.57 326.715L397.484 324.256C395.545 323.473 394.355 321.162 394.827 319.097L395.234 317.803C395.705 315.739 397.661 314.698 399.6 315.481L405.686 317.941C407.625 318.724 408.817 321.036 408.345 323.101Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.723429,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group 4_3"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1688",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M504.033 319.131L503.297 321.873C502.474 324 498.058 324.383 495.925 323.521L492.601 322.045C490.469 321.183 489.16 318.641 489.679 316.371L489.14 313.113C491.312 310.982 493.086 310.215 495.219 311.076L501.111 313.457C503.243 314.318 504.552 316.861 504.033 319.131Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.72359,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1689",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M501.347 320.101L500.94 321.395C500.468 323.459 498.51 324.499 496.572 323.715L490.485 321.256C488.546 320.473 487.357 318.162 487.829 316.097L488.235 314.803C488.707 312.739 490.662 311.698 492.601 312.481L498.688 314.941C500.627 315.724 501.818 318.036 501.347 320.101Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.723429,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group 5"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1690",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M486.033 312.131L485.297 314.873C484.474 317 480.058 317.383 477.925 316.521L474.601 315.045C472.469 314.183 471.16 311.641 471.679 309.371L471.14 306.113C473.312 303.982 475.086 303.215 477.219 304.076L483.111 306.457C485.243 307.318 486.552 309.861 486.033 312.131Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.72359,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1691",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M483.347 313.101L482.94 314.395C482.468 316.459 480.51 317.499 478.572 316.715L472.485 314.256C470.546 313.473 469.357 311.162 469.829 309.097L470.235 307.803C470.707 305.739 472.662 304.698 474.601 305.481L480.688 307.941C482.627 308.724 483.818 311.036 483.347 313.101Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.723429,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group 6"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1692",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M470.033 305.131L469.297 307.873C468.474 310 464.058 310.383 461.925 309.521L458.601 308.045C456.469 307.183 455.16 304.641 455.679 302.371L455.14 299.113C457.312 296.982 459.086 296.215 461.219 297.076L467.111 299.457C469.243 300.318 470.552 302.861 470.033 305.131Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.72359,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1693",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M467.347 306.101L466.94 307.395C466.468 309.459 464.51 310.499 462.572 309.715L456.485 307.256C454.546 306.473 453.357 304.162 453.829 302.097L454.235 300.803C454.707 298.739 456.662 297.698 458.601 298.481L464.688 300.941C466.627 301.724 467.818 304.036 467.347 306.101Z",
  fill: "white",
  stroke: "#8496B9",
  strokeWidth: 0.723429,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2177"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2178"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1694",
  d: "M458.712 316.301L448.591 312.687C443.579 311.747 439.929 314.666 438.216 317.496C437.234 319.12 438.339 320.94 440.106 321.631L454.237 327.16C456.028 327.861 458.016 327.866 459.811 327.176L464.032 325.553C464.899 325.22 465.535 324.414 465.469 323.488C465.339 321.661 464.559 320.162 462.362 318.3C461.295 317.397 460.028 316.771 458.712 316.301Z",
  fill: "white",
  stroke: "#6E32F0",
  strokeWidth: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2179"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1695",
  d: "M452.697 316.794C456.517 316.794 459.614 313.213 459.614 308.796C459.614 304.379 456.517 300.798 452.697 300.798C448.877 300.798 445.781 304.379 445.781 308.796C445.781 313.213 448.877 316.794 452.697 316.794Z",
  fill: "white",
  stroke: "#6E32F0",
  strokeWidth: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2180"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1696",
  d: "M460.479 309.012C460.479 310.445 459.705 311.606 458.75 311.606C457.795 311.606 457.021 310.445 457.021 309.012C457.021 307.58 457.795 306.418 458.75 306.418C459.705 306.418 460.479 307.58 460.479 309.012Z",
  fill: "white",
  stroke: "#6E32F0",
  strokeWidth: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2181"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2182"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1697",
  d: "M262.556 392.539C272.022 378.085 277.25 371.899 291.787 362.464",
  stroke: "#D1DAE9",
  strokeWidth: 0.480103,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2183"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1698",
  d: "M534.021 328.473C534.021 328.473 532.251 330.939 531.3 332.265C530.921 332.795 530.739 333.441 530.79 334.091C530.857 334.977 530.951 336.212 530.995 336.778C531.011 336.992 531.053 337.202 531.117 337.406C532.209 340.829 533.652 342.517 535.669 341.366",
  stroke: "#D1DAE9",
  strokeWidth: 0.954745,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2184"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1699",
  d: "M400.566 418.255L480.164 385.832",
  stroke: "#D1DAE9",
  strokeWidth: 0.397117,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2185"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2186"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2187"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1700",
  d: "M497.222 395.997L485.729 391.351",
  stroke: "#6E32F0",
  strokeWidth: 0.943573,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2188"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1701",
  d: "M520.474 355.5L509.974 351",
  stroke: "#6E32F0",
  strokeWidth: 0.934351,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2189"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1702",
  d: "M484.998 396.855V396.639C485.94 392.353 485.917 390.911 486.474 385C494.974 368.136 500.474 360 507.974 352.171C519.38 347.513 527.864 353.163 527.864 365.495C527.864 370.583 527.308 373.821 525.96 378.817C531.074 374.965 532.915 372.887 537.302 362.493V352.171L535.398 347.599C535.933 338.816 532.956 350.95 530.474 347.599C520.501 335.278 523.468 346.144 518.974 344.5C467.988 351 484.676 373.151 469.974 382.359C461.092 387.908 432.666 390.249 421.474 410L396.974 417C396.974 422.488 392.459 431.312 390.896 435.194L484.998 396.855Z",
  fill: "white"
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2190"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1703",
  d: "M390.878 435.19L387.993 434.024",
  stroke: "#D1DAE9",
  strokeWidth: 0.962514,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2191"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1704",
  d: "M382.787 410.113L374.455 406.75",
  stroke: "#6E32F0",
  strokeWidth: 0.962514,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2192"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1705",
  d: "M260.984 395.717C273.794 403.44 289.213 409.651 307.402 414.291",
  stroke: "#D1DAE9",
  strokeWidth: 0.962514,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2193"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1706",
  d: "M260.269 398.551C273.01 406.651 288.083 412.79 305.925 416.613",
  stroke: "#D1DAE9",
  strokeWidth: 0.962514,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2194"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1707",
  d: "M258.949 399.084C257.956 403.141 274.714 411.112 295.28 417.614C301.719 419.652 306.636 419.903 308.667 419.133",
  stroke: "#D1DAE9",
  strokeWidth: 0.962514,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2195"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1708",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M279.978 405.599C281.98 406.408 282.667 409.384 282.162 411.343C281.636 413.432 280.039 415.147 278.038 414.338C276.056 413.537 274.965 410.64 275.531 408.562C276.178 406.19 277.977 404.79 279.978 405.599Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.819688,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2196"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1709",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M325.369 341.011C326.781 341.842 321.944 348.535 317.086 347.987C317.086 347.987 315.588 345.892 315.16 343.922C315.096 341.169 317.086 339.194 319.612 337.78C321.816 336.535 325.583 339.978 325.369 341.011Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.819815,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2197"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1710",
  d: "M384.841 382.922L393.012 379.594",
  stroke: "#D1DAE9",
  strokeWidth: 0.962514,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2198"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1711",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M517.01 300.276C520.015 301.535 518.999 307.245 518.999 307.245C517.889 305.562 516.431 304.054 514.299 302.943C496.515 295.046 478.607 285.983 462.608 283.61C463.446 283.546 467.985 282.305 469.361 282.509C481.33 284.249 508.586 296.745 517.01 300.276Z",
  stroke: "#D1DAE9",
  strokeWidth: 1.62879,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2199"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1712",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M442.5 326.058C444.979 335.539 446.6 346.886 447.316 357.374L392.811 379.576L393.43 376.339C404.494 356.048 416.296 338.849 425.309 333.902C432.2 330.109 442.5 326.058 442.5 326.058Z",
  stroke: "#D1DAE9",
  strokeWidth: 1.2171,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2200"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1713",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M449.693 406.693C449.502 392.574 450.742 364.446 447.547 357.374L393.042 379.575C396.117 388.958 397.119 403.372 396.856 428.215L449.693 406.693Z",
  stroke: "#D1DAE9",
  strokeWidth: 1.2171,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2201"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1714",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M447.316 357.374L490.305 339.863C491.14 342.41 496.242 349.596 494.144 352.929C487.706 363.034 484.178 375.516 482.652 393.174L449.462 406.693C449.271 392.574 450.511 364.446 447.316 357.374Z",
  stroke: "#D1DAE9",
  strokeWidth: 1.2171,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2202"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1715",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M442.5 326.058C444.98 335.539 446.601 346.885 447.316 357.374L490.305 339.863C486.681 332.412 482.89 321.733 478.837 314.577C463.911 318.419 442.5 326.058 442.5 326.058Z",
  stroke: "#D1DAE9",
  strokeWidth: 1.2171,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2203"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1716",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M484.998 396.639V396.855L390.896 435.194C392.459 431.312 392.801 427.296 392.801 421.808C392.801 409.274 383.385 402.939 371.764 407.663C360.164 412.394 351.925 424.618 350.748 437.099C350.148 443.36 348.822 452.324 348.822 452.324C338.314 455.813 328.704 455.482 319.352 454.008L312.504 450.084C300.861 448.932 289.433 444.97 278.091 439.854C266.983 434.727 257.417 429.889 256.261 426.638C254.143 415.851 254.143 407.902 255.298 401.474C255.983 397.653 256.818 394.91 258.444 392.099C257.845 397.804 259.257 404.625 260.285 406.139C262.168 408.938 278.091 415.733 278.091 415.733C278.091 415.733 293.692 422.608 301.974 423.927C309.807 425.175 327.784 423.727 327.784 423.727C335.553 423.507 341.759 421.939 345.012 417.812L351.347 409.342L348.822 408.969C348.822 408.969 329.282 412.42 330.203 411.741C339.17 405.169 360.314 393.668 384.626 382.922L387.001 378.299L386.102 375.961L392.801 371.548C403.994 351.797 414.866 336.758 423.747 331.21C438.45 322.001 482.344 309.628 514.296 302.941C518.79 304.585 523.499 315.25 533.472 327.57C535.954 330.922 535.933 338.816 535.398 347.599L537.302 352.171V362.493C532.915 372.887 531.074 374.965 525.959 378.817C527.308 373.821 527.864 370.583 527.864 365.495C527.864 353.163 518.597 347.854 507.191 352.511C495.762 357.16 487.651 370.079 486.496 382.359C485.939 388.27 485.939 392.353 484.998 396.639Z",
  stroke: "#D1DAE9",
  strokeWidth: 0.819815,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2204"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1717",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M502.227 309.236C506.495 308.364 509.499 311.543 512.742 314.867L518.321 322.676L515.173 328.819L490.305 339.863C486.443 331.907 482.556 320.978 478.837 314.577C490.353 311.089 502.227 309.236 502.227 309.236Z",
  stroke: "#D1DAE9",
  strokeWidth: 1.2171,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2205"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1718",
  d: "M507.743 395.263C517.927 391.114 526.184 378.836 526.184 367.839C526.184 356.842 517.927 351.29 507.743 355.439C497.558 359.587 489.301 371.865 489.301 382.863C489.301 393.86 497.558 399.412 507.743 395.263Z",
  fill: "white",
  stroke: "#6E32F0",
  strokeWidth: 1.21683,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1719",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M510.358 360.695L513.035 360.544L510.413 370.29L517.255 362.137L518.907 363.916L512.065 372.069L520.533 368.62V371.661L512.065 375.11L518.907 377.689L517.255 380.815L510.413 378.236L513.035 385.846L510.358 387.875L507.75 380.26L505.127 390.006L502.464 390.152L505.073 380.411L498.23 388.564L496.578 386.785L503.42 378.632L494.966 382.075V379.034L503.42 375.591L496.578 373.011L498.23 369.886L505.073 372.465L502.464 364.85L505.127 362.825L507.75 370.435L510.358 360.695Z",
  stroke: "#D1DAE9",
  strokeWidth: 1.21516,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1720",
  d: "M507.745 389.868C515.166 386.845 521.182 377.899 521.182 369.886C521.182 361.873 515.166 357.828 507.745 360.851C500.324 363.873 494.308 372.82 494.308 380.833C494.308 388.846 500.324 392.891 507.745 389.868Z",
  stroke: "#6E32F0",
  strokeWidth: 1.21532,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1721",
  d: "M507.755 378.451C509.339 377.805 510.624 375.895 510.624 374.185C510.624 372.474 509.339 371.61 507.755 372.256C506.171 372.901 504.886 374.811 504.886 376.522C504.886 378.232 506.171 379.096 507.755 378.451Z",
  stroke: "#D1DAE9",
  strokeWidth: 1.21596,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2206"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1722",
  d: "M304.842 442.106C318.253 443.272 329.909 443.561 338.888 442.656",
  stroke: "#D1DAE9",
  strokeWidth: 0.962514,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2207"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1723",
  d: "M259.369 390.152L261.031 395.537",
  stroke: "#D1DAE9",
  strokeWidth: 0.962514,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2208"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1724",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M305.933 416.614L315.563 424.372C322.005 424.198 327.783 423.727 327.783 423.727C335.552 423.507 341.758 421.939 345.011 417.812L351.346 409.342L348.821 408.969C348.821 408.969 331.315 411.573 330.202 411.741C323.46 412.791 308.415 412.3 308.886 411.938L305.933 416.614Z",
  stroke: "#D1DAE9",
  strokeWidth: 0.819815,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2209"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1725",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M310.088 416.301L316.012 421.074C321.272 420.932 328.628 420.783 328.628 420.783C334.954 420.596 339.34 420.649 341.996 417.279L346.154 411.952L351.344 409.345C351.344 409.345 337.61 412.35 331.861 413.184C326.339 413.977 311.539 414.005 311.923 413.71L310.088 416.301Z",
  stroke: "#D1DAE9",
  strokeWidth: 0.820072,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2210"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1726",
  d: "M312.711 450.21L322.286 450.364C322.286 450.364 339.743 450.974 341.752 448.795L344.146 446.366C341.665 440.875 339.131 436.544 336.388 436.225L306.979 435.849C295.621 435.085 259.555 420.437 254.523 415.617",
  stroke: "#D1DAE9",
  strokeWidth: 0.820072,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2211"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1727",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M304.535 442.232L312.765 450.188L322.341 450.342C322.341 450.342 339.797 450.951 341.807 448.773L344.201 446.344C341.719 440.853 339.186 436.522 336.442 436.203L309.568 435.88L304.535 442.232Z",
  stroke: "#D1DAE9",
  strokeWidth: 0.820072,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2212"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1728",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M325.369 341.011C326.781 341.842 321.944 348.535 317.086 347.987C317.086 347.987 315.588 345.892 315.16 343.922C315.096 341.169 317.086 339.194 319.612 337.78C321.816 336.535 325.583 339.978 325.369 341.011Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.819815,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2213"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1729",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M304.531 442.231L312.482 449.916C312.482 449.916 336.875 451.056 338.762 449.499L341.174 447.077C338.692 441.585 336.264 438.231 333.52 437.912C333.52 437.912 314.089 437.767 308.218 437.569L304.531 442.231Z",
  stroke: "#D1DAE9",
  strokeWidth: 0.820072,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2214"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1730",
  d: "M258.422 392.098L259.369 390.152C259.23 386.364 260.223 383.153 262.554 381.228",
  stroke: "#D1DAE9",
  strokeWidth: 0.962514,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2215"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1731",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M387.077 378.17L386.097 375.952C378.549 380.397 313.198 355.899 316.073 348.871C308.264 353.149 294.638 360.942 286.665 365.311C276.732 370.728 268.105 376.086 261.995 381.741C258.466 385.645 261.374 392.411 261.995 393.031C265.328 396.359 278.071 401.86 278.071 401.86C278.071 401.86 293.985 409.086 309.342 412.002C314.44 412.991 330.221 411.722 330.221 411.722C340.514 404.19 353.911 397.063 384.626 382.931L387.077 378.17Z",
  stroke: "#D1DAE9",
  strokeWidth: 1.16243,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2216"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1732",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M392.795 371.554L386.096 375.952C378.548 380.397 313.197 355.899 316.073 348.871C329.535 336.982 344.533 325.041 360.806 317.341C375.248 321.751 412.498 338.704 414.459 339.551C406.028 349.963 399.036 360.687 392.795 371.554Z",
  stroke: "#D1DAE9",
  strokeWidth: 1.16243,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2217"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1733",
  d: "M371.994 450.558C382.178 446.41 390.435 434.131 390.435 423.134C390.435 412.137 382.178 406.585 371.994 410.734C361.809 414.882 353.552 427.161 353.552 438.158C353.552 449.155 361.809 454.707 371.994 450.558Z",
  fill: "white",
  stroke: "#6E32F0",
  strokeWidth: 1.21683,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1734",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M374.609 415.99L377.285 415.839L374.663 425.585L381.505 417.432L383.158 419.211L376.316 427.365L384.783 423.915V426.957L376.316 430.406L383.158 432.985L381.505 436.11L374.663 433.531L377.285 441.141L374.609 443.171L372 435.555L369.378 445.302L366.715 445.447L369.323 435.706L362.481 443.859L360.828 442.08L367.671 433.927L359.217 437.371V434.33L367.671 430.886L360.828 428.307L362.481 425.182L369.323 427.761L366.715 420.145L369.378 418.121L372 425.731L374.609 415.99Z",
  stroke: "#D1DAE9",
  strokeWidth: 1.21516,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1735",
  d: "M372.006 433.746C373.59 433.101 374.875 431.191 374.875 429.48C374.875 427.77 373.59 426.906 372.006 427.551C370.422 428.197 369.137 430.107 369.137 431.817C369.137 433.528 370.422 434.392 372.006 433.746Z",
  stroke: "#D1DAE9",
  strokeWidth: 1.21596,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1736",
  d: "M371.996 445.164C379.417 442.141 385.433 433.194 385.433 425.182C385.433 417.169 379.417 413.123 371.996 416.146C364.575 419.169 358.559 428.115 358.559 436.128C358.559 444.141 364.575 448.186 371.996 445.164Z",
  stroke: "#6E32F0",
  strokeWidth: 1.21532,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2218"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1737",
  d: "M261.838 392.829L261.03 395.537L260.269 398.551L258.515 398.967",
  stroke: "#D1DAE9",
  strokeWidth: 0.962514,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2219"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1738",
  d: "M261.838 392.829L261.03 395.537L260.269 398.551L258.515 398.967",
  stroke: "#D1DAE9",
  strokeWidth: 0.962514,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2220"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1739",
  d: "M316.058 348.87C331.938 335.281 344.148 325.273 358.367 318.367C390.727 304.529 431.051 287.248 462.604 283.613C482.062 286.699 500.759 297.676 514.285 302.941",
  stroke: "#D1DAE9",
  strokeWidth: 0.962514,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2221"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1740",
  d: "M289.749 425.716L264.864 415.662V423.92L289.749 433.974V425.716Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.819815,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2222"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Vector_1741"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M407.462 377.595L406.746 379.109L404.092 380.887L400.999 378.232L403.261 375.418",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M407.462 377.595L406.746 379.109L404.092 380.887L400.999 378.232L403.261 375.418",
  stroke: "#D1DAE9",
  strokeWidth: 0.962514,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2223"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1742",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M418.242 376.923C420.682 376.44 422.993 374.76 423.228 373.311C414.839 376.099 408.74 376.212 402.918 374.611C402.918 374.611 403.154 376.291 405.915 377.202C410.901 378.848 418.242 376.923 418.242 376.923Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.819815,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2224"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1743",
  d: "M324.575 339.57C320.905 341.73 319.012 344.152 318.458 346.767",
  stroke: "#D1DAE9",
  strokeWidth: 0.962514,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2225"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1744",
  d: "M309.987 447.496C296.114 445.363 258.075 429.652 255.836 424.403",
  stroke: "#D1DAE9",
  strokeWidth: 0.962514,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2226"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1745",
  d: "M304.529 442.232C291.695 439.607 256.842 425.391 255.295 420.055",
  stroke: "#D1DAE9",
  strokeWidth: 0.962514,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2227"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1746",
  d: "M360.559 450.933L349.711 446.548",
  stroke: "#6E32F0",
  strokeWidth: 0.962514,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2228"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1747",
  d: "M525.948 378.813L524.016 378.04",
  stroke: "#D1DAE9",
  strokeWidth: 0.943573,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2229"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1748",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M419.248 368.524C420.66 369.356 421.666 370.545 423.228 373.311C414.839 376.099 408.739 376.212 402.918 374.611C402.854 371.858 407.07 367.396 409.809 366.389C411.907 365.591 419.248 368.524 419.248 368.524Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.819815,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2230"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1749",
  d: "M308.874 411.958C329.091 401.042 356.496 389.702 387.052 378.175C390.729 376.899 393.183 375.145 395.161 373.203",
  stroke: "#D1DAE9",
  strokeWidth: 0.480103,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2231"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1750",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M374.014 315.02C384.96 309.251 400.245 300.016 464.341 284.808C463.65 284.012 461.368 283.411 457.998 283.797C407.19 295.037 384.207 305.705 374.522 311.087C369.896 313.658 369.336 316.4 374.014 315.02Z",
  fill: "white",
  stroke: "#D1DAE9",
  strokeWidth: 0.962514,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Group_2232"
}, /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1751",
  d: "M386.756 394.695L528.323 337.03",
  stroke: "#D1DAE9",
  strokeWidth: 0.486258,
  strokeMiterlimit: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__label-wms"
}, /*#__PURE__*/React.createElement("rect", {
  x: 380.474,
  y: 455.5,
  width: 59.7303,
  height: 21.618,
  rx: 10.4663,
  fill: "white"
}), /*#__PURE__*/React.createElement("rect", {
  x: 380.474,
  y: 455.5,
  width: 59.7303,
  height: 21.618,
  rx: 10.4663,
  stroke: "#EDF4FF"
}), /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Vector_1752",
  d: "M391.969 457.742C396.697 457.742 400.535 461.581 400.535 466.309C400.535 471.038 396.697 474.876 391.969 474.876C387.238 474.876 383.4 471.039 383.4 466.309C383.4 461.579 387.24 457.742 391.969 457.742ZM388.477 463.633C388.132 463.037 389.038 462.513 389.383 463.11L391.377 466.564C391.565 466.51 391.763 466.481 391.969 466.481C393.156 466.481 394.123 467.448 394.123 468.635C394.123 469.823 393.156 470.789 391.969 470.789C390.781 470.789 389.814 469.823 389.814 468.635C389.814 468.029 390.067 467.479 390.472 467.088L388.477 463.632L388.477 463.633ZM391.969 467.528C391.356 467.528 390.86 468.023 390.86 468.635C390.86 469.248 391.356 469.743 391.969 469.743C392.581 469.743 393.077 469.248 393.077 468.635C393.077 468.023 392.581 467.528 391.969 467.528ZM387.629 469.422C388.03 469.984 387.175 470.591 386.777 470.033C385.999 468.946 385.581 467.645 385.581 466.309C385.581 462.785 388.446 459.922 391.969 459.922C395.491 459.922 398.355 462.786 398.355 466.309C398.355 467.644 397.936 468.946 397.16 470.033C396.762 470.591 395.907 469.984 396.308 469.422C396.965 468.508 397.309 467.433 397.309 466.309C397.309 463.357 394.92 460.968 391.969 460.968C389.018 460.968 386.628 463.357 386.628 466.309C386.628 467.433 386.973 468.508 387.629 469.422ZM391.969 458.788C387.813 458.788 384.447 462.154 384.447 466.309C384.447 470.464 387.814 473.831 391.969 473.831C396.124 473.831 399.489 470.463 399.489 466.309C399.489 462.154 396.122 458.788 391.969 458.788Z",
  fill: "#141941"
}), /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__40 km/h",
  d: "M406.554 469.309C406.499 469.309 406.453 469.29 406.414 469.251C406.376 469.213 406.357 469.166 406.357 469.112V468.059H403.749C403.689 468.059 403.64 468.04 403.601 468.001C403.569 467.963 403.552 467.916 403.552 467.861V467.302C403.552 467.269 403.558 467.231 403.569 467.187C403.585 467.138 403.61 467.094 403.643 467.055L406.069 463.691C406.14 463.598 406.242 463.552 406.373 463.552H407.27C407.324 463.552 407.371 463.571 407.409 463.609C407.448 463.648 407.467 463.694 407.467 463.749V467.088H408.199C408.265 467.088 408.314 467.107 408.347 467.146C408.385 467.179 408.405 467.225 408.405 467.286V467.861C408.405 467.916 408.385 467.963 408.347 468.001C408.309 468.04 408.262 468.059 408.207 468.059H407.467V469.112C407.467 469.166 407.448 469.213 407.409 469.251C407.371 469.29 407.324 469.309 407.27 469.309H406.554ZM404.695 467.121H406.381V464.744L404.695 467.121ZM411.368 469.391C410.979 469.391 410.647 469.334 410.373 469.218C410.099 469.103 409.874 468.944 409.699 468.741C409.523 468.539 409.392 468.306 409.304 468.042C409.216 467.774 409.164 467.489 409.148 467.187C409.142 467.039 409.137 466.877 409.131 466.702C409.131 466.521 409.131 466.34 409.131 466.159C409.137 465.978 409.142 465.811 409.148 465.657C409.159 465.356 409.211 465.073 409.304 464.81C409.397 464.541 409.532 464.308 409.707 464.111C409.888 463.914 410.115 463.757 410.39 463.642C410.664 463.527 410.99 463.469 411.368 463.469C411.752 463.469 412.081 463.527 412.355 463.642C412.63 463.757 412.854 463.914 413.03 464.111C413.211 464.308 413.345 464.541 413.433 464.81C413.526 465.073 413.578 465.356 413.589 465.657C413.6 465.811 413.606 465.978 413.606 466.159C413.606 466.34 413.606 466.521 413.606 466.702C413.606 466.877 413.6 467.039 413.589 467.187C413.578 467.489 413.529 467.774 413.441 468.042C413.353 468.306 413.222 468.539 413.046 468.741C412.871 468.944 412.643 469.103 412.364 469.218C412.089 469.334 411.758 469.391 411.368 469.391ZM411.368 468.445C411.725 468.445 411.985 468.33 412.15 468.1C412.32 467.864 412.407 467.546 412.413 467.146C412.424 466.987 412.429 466.828 412.429 466.669C412.429 466.504 412.429 466.34 412.429 466.175C412.429 466.011 412.424 465.855 412.413 465.707C412.407 465.317 412.32 465.005 412.15 464.769C411.985 464.528 411.725 464.407 411.368 464.407C411.017 464.407 410.757 464.528 410.587 464.769C410.423 465.005 410.335 465.317 410.324 465.707C410.324 465.855 410.321 466.011 410.316 466.175C410.316 466.34 410.316 466.504 410.316 466.669C410.321 466.828 410.324 466.987 410.324 467.146C410.335 467.546 410.425 467.864 410.595 468.1C410.765 468.33 411.023 468.445 411.368 468.445ZM416.704 469.309C416.649 469.309 416.603 469.29 416.564 469.251C416.526 469.213 416.507 469.166 416.507 469.112V463.667C416.507 463.612 416.526 463.565 416.564 463.527C416.603 463.489 416.649 463.469 416.704 463.469H417.37C417.431 463.469 417.477 463.489 417.51 463.527C417.549 463.565 417.568 463.612 417.568 463.667V466.48L418.949 465.172C418.999 465.128 419.043 465.095 419.081 465.073C419.119 465.046 419.177 465.032 419.254 465.032H420.019C420.074 465.032 420.117 465.049 420.15 465.081C420.183 465.114 420.2 465.158 420.2 465.213C420.2 465.235 420.194 465.26 420.183 465.287C420.172 465.314 420.15 465.339 420.117 465.361L418.423 466.948L420.323 468.988C420.378 469.043 420.405 469.09 420.405 469.128C420.405 469.183 420.386 469.227 420.348 469.26C420.315 469.293 420.274 469.309 420.224 469.309H419.443C419.361 469.309 419.3 469.298 419.262 469.276C419.229 469.249 419.188 469.213 419.139 469.169L417.568 467.516V469.112C417.568 469.166 417.549 469.213 417.51 469.251C417.477 469.29 417.431 469.309 417.37 469.309H416.704ZM421.218 469.309C421.163 469.309 421.116 469.29 421.078 469.251C421.04 469.213 421.02 469.166 421.02 469.112V465.229C421.02 465.175 421.04 465.128 421.078 465.09C421.116 465.051 421.163 465.032 421.218 465.032H421.859C421.914 465.032 421.961 465.051 421.999 465.09C422.038 465.128 422.057 465.175 422.057 465.229V465.509C422.172 465.356 422.325 465.227 422.517 465.123C422.715 465.013 422.948 464.955 423.216 464.95C423.842 464.939 424.277 465.183 424.524 465.682C424.65 465.463 424.831 465.287 425.067 465.155C425.308 465.018 425.574 464.95 425.865 464.95C426.15 464.95 426.408 465.016 426.638 465.147C426.874 465.279 427.057 465.479 427.189 465.748C427.326 466.011 427.395 466.345 427.395 466.751V469.112C427.395 469.166 427.375 469.213 427.337 469.251C427.299 469.29 427.252 469.309 427.197 469.309H426.523C426.468 469.309 426.421 469.29 426.383 469.251C426.345 469.213 426.325 469.166 426.325 469.112V466.817C426.325 466.57 426.29 466.375 426.219 466.233C426.147 466.085 426.051 465.981 425.931 465.92C425.81 465.86 425.676 465.83 425.528 465.83C425.407 465.83 425.286 465.86 425.166 465.92C425.045 465.981 424.946 466.085 424.87 466.233C424.793 466.375 424.755 466.57 424.755 466.817V469.112C424.755 469.166 424.735 469.213 424.697 469.251C424.659 469.29 424.612 469.309 424.557 469.309H423.883C423.822 469.309 423.773 469.29 423.735 469.251C423.702 469.213 423.685 469.166 423.685 469.112V466.817C423.685 466.57 423.647 466.375 423.57 466.233C423.493 466.085 423.395 465.981 423.274 465.92C423.153 465.86 423.025 465.83 422.887 465.83C422.761 465.83 422.638 465.863 422.517 465.929C422.397 465.989 422.298 466.09 422.221 466.233C422.145 466.375 422.106 466.57 422.106 466.817V469.112C422.106 469.166 422.087 469.213 422.049 469.251C422.01 469.29 421.964 469.309 421.909 469.309H421.218ZM428.269 470C428.225 470 428.187 469.983 428.154 469.95C428.121 469.918 428.105 469.876 428.105 469.827C428.105 469.805 428.11 469.775 428.121 469.737L430.918 463.017C430.94 462.979 430.97 462.94 431.008 462.902C431.047 462.864 431.101 462.844 431.173 462.844H431.707C431.751 462.844 431.789 462.861 431.822 462.894C431.861 462.927 431.88 462.968 431.88 463.017C431.88 463.039 431.872 463.069 431.855 463.108L429.051 469.827C429.034 469.86 429.007 469.896 428.968 469.934C428.93 469.978 428.872 470 428.796 470H428.269ZM432.824 469.309C432.769 469.309 432.723 469.29 432.684 469.251C432.646 469.213 432.627 469.166 432.627 469.112V463.667C432.627 463.612 432.646 463.565 432.684 463.527C432.723 463.489 432.769 463.469 432.824 463.469H433.556C433.617 463.469 433.663 463.489 433.696 463.527C433.734 463.565 433.754 463.612 433.754 463.667V465.542C433.902 465.367 434.083 465.224 434.296 465.114C434.51 465.005 434.774 464.95 435.086 464.95C435.421 464.95 435.711 465.027 435.958 465.18C436.21 465.328 436.405 465.539 436.542 465.813C436.679 466.088 436.747 466.417 436.747 466.8V469.112C436.747 469.166 436.728 469.213 436.69 469.251C436.651 469.29 436.605 469.309 436.55 469.309H435.81C435.755 469.309 435.708 469.29 435.67 469.251C435.632 469.213 435.612 469.166 435.612 469.112V466.85C435.612 466.532 435.533 466.282 435.374 466.101C435.22 465.92 434.996 465.83 434.699 465.83C434.414 465.83 434.184 465.92 434.009 466.101C433.839 466.282 433.754 466.532 433.754 466.85V469.112C433.754 469.166 433.734 469.213 433.696 469.251C433.663 469.29 433.617 469.309 433.556 469.309H432.824Z",
  fill: "#141941"
}))), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__label-rrs",
  className: "label-rrs",
  filter: "url(#CarSpeed_svg__filter0_d_13_9884)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 406.974,
  y: 255,
  width: 124,
  height: 22,
  rx: 11,
  fill: "white"
}), /*#__PURE__*/React.createElement("rect", {
  x: 407.474,
  y: 255.5,
  width: 123,
  height: 21,
  rx: 10.5,
  stroke: "#EDF4FF"
}), /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__cil-camera"
}, /*#__PURE__*/React.createElement("g", {
  id: "CarSpeed_svg__Vector_1753"
}, /*#__PURE__*/React.createElement("path", {
  d: "M427.88 262.062H425.441L424.997 260.784C424.937 260.613 424.825 260.464 424.677 260.358C424.529 260.253 424.352 260.196 424.17 260.196H419.765C419.583 260.196 419.405 260.253 419.256 260.36C419.107 260.466 418.996 260.616 418.937 260.789L418.504 262.062H416.067C415.893 262.063 415.727 262.132 415.604 262.255C415.481 262.378 415.411 262.545 415.411 262.719V271.25C415.411 271.424 415.481 271.591 415.604 271.714C415.727 271.837 415.893 271.906 416.067 271.906H427.88C428.054 271.906 428.22 271.837 428.344 271.714C428.467 271.591 428.536 271.424 428.536 271.25V262.719C428.536 262.545 428.467 262.378 428.344 262.255C428.22 262.132 428.054 262.063 427.88 262.062ZM427.661 271.031H416.286V262.938H419.13L419.765 261.071H424.17L424.818 262.938H427.661V271.031Z",
  fill: "#6E32F0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M421.974 263.594C421.357 263.594 420.754 263.777 420.242 264.119C419.729 264.462 419.33 264.948 419.094 265.518C418.858 266.088 418.796 266.714 418.916 267.319C419.037 267.924 419.333 268.479 419.769 268.915C420.205 269.351 420.761 269.648 421.365 269.768C421.97 269.888 422.597 269.827 423.167 269.591C423.736 269.355 424.223 268.955 424.565 268.443C424.908 267.93 425.091 267.327 425.091 266.711C425.09 265.884 424.761 265.092 424.177 264.508C423.592 263.923 422.8 263.595 421.974 263.594ZM421.974 268.953C421.53 268.953 421.097 268.822 420.728 268.575C420.359 268.329 420.072 267.979 419.902 267.569C419.732 267.159 419.688 266.708 419.775 266.274C419.861 265.839 420.075 265.439 420.388 265.125C420.702 264.812 421.101 264.598 421.536 264.512C421.971 264.425 422.422 264.47 422.832 264.639C423.241 264.809 423.592 265.097 423.838 265.465C424.084 265.834 424.216 266.267 424.216 266.711C424.215 267.305 423.979 267.875 423.558 268.296C423.138 268.716 422.568 268.952 421.974 268.953Z",
  fill: "#6E32F0"
}))), /*#__PURE__*/React.createElement("path", {
  id: "CarSpeed_svg__Button",
  d: "M434.28 270C434.2 270 434.132 269.972 434.076 269.916C434.02 269.86 433.992 269.792 433.992 269.712V261.9C433.992 261.812 434.02 261.74 434.076 261.684C434.132 261.628 434.2 261.6 434.28 261.6H437.388C438.356 261.6 439.12 261.824 439.68 262.272C440.24 262.72 440.52 263.372 440.52 264.228C440.52 264.82 440.372 265.312 440.076 265.704C439.788 266.096 439.4 266.38 438.912 266.556L440.664 269.616C440.688 269.664 440.7 269.708 440.7 269.748C440.7 269.82 440.672 269.88 440.616 269.928C440.568 269.976 440.512 270 440.448 270H439.356C439.22 270 439.116 269.964 439.044 269.892C438.972 269.82 438.916 269.748 438.876 269.676L437.328 266.832H435.66V269.712C435.66 269.792 435.632 269.86 435.576 269.916C435.528 269.972 435.46 270 435.372 270H434.28ZM435.66 265.476H437.352C437.84 265.476 438.204 265.368 438.444 265.152C438.684 264.928 438.804 264.616 438.804 264.216C438.804 263.816 438.684 263.504 438.444 263.28C438.212 263.048 437.848 262.932 437.352 262.932H435.66V265.476ZM444.54 270.12C443.652 270.12 442.948 269.864 442.428 269.352C441.908 268.84 441.628 268.112 441.588 267.168C441.58 267.088 441.576 266.988 441.576 266.868C441.576 266.74 441.58 266.64 441.588 266.568C441.62 265.968 441.756 265.448 441.996 265.008C442.244 264.568 442.584 264.232 443.016 264C443.448 263.76 443.956 263.64 444.54 263.64C445.188 263.64 445.732 263.776 446.172 264.048C446.612 264.312 446.944 264.684 447.168 265.164C447.392 265.636 447.504 266.184 447.504 266.808V267.06C447.504 267.14 447.476 267.208 447.42 267.264C447.364 267.32 447.292 267.348 447.204 267.348H443.22C443.22 267.348 443.22 267.36 443.22 267.384C443.22 267.408 443.22 267.428 443.22 267.444C443.228 267.724 443.28 267.984 443.376 268.224C443.48 268.456 443.628 268.644 443.82 268.788C444.02 268.932 444.256 269.004 444.528 269.004C444.752 269.004 444.94 268.972 445.092 268.908C445.244 268.836 445.368 268.756 445.464 268.668C445.56 268.58 445.628 268.508 445.668 268.452C445.74 268.356 445.796 268.3 445.836 268.284C445.884 268.26 445.952 268.248 446.04 268.248H447.072C447.152 268.248 447.216 268.272 447.264 268.32C447.32 268.368 447.344 268.428 447.336 268.5C447.328 268.628 447.26 268.784 447.132 268.968C447.012 269.152 446.836 269.332 446.604 269.508C446.372 269.684 446.08 269.832 445.728 269.952C445.384 270.064 444.988 270.12 444.54 270.12ZM443.22 266.34H445.872V266.304C445.872 265.992 445.82 265.72 445.716 265.488C445.612 265.256 445.46 265.072 445.26 264.936C445.06 264.8 444.82 264.732 444.54 264.732C444.26 264.732 444.02 264.8 443.82 264.936C443.62 265.072 443.468 265.256 443.364 265.488C443.268 265.72 443.22 265.992 443.22 266.304V266.34ZM450.589 270.12C450.173 270.12 449.797 270.04 449.461 269.88C449.125 269.712 448.857 269.492 448.657 269.22C448.465 268.94 448.369 268.628 448.369 268.284C448.369 267.724 448.593 267.28 449.041 266.952C449.497 266.616 450.097 266.392 450.841 266.28L452.485 266.04V265.788C452.485 265.452 452.401 265.192 452.233 265.008C452.065 264.824 451.777 264.732 451.369 264.732C451.081 264.732 450.845 264.792 450.661 264.912C450.485 265.024 450.353 265.176 450.265 265.368C450.201 265.472 450.109 265.524 449.989 265.524H449.041C448.953 265.524 448.885 265.5 448.837 265.452C448.797 265.404 448.777 265.34 448.777 265.26C448.785 265.132 448.837 264.976 448.933 264.792C449.029 264.608 449.181 264.432 449.389 264.264C449.597 264.088 449.865 263.94 450.193 263.82C450.521 263.7 450.917 263.64 451.381 263.64C451.885 263.64 452.309 263.704 452.653 263.832C453.005 263.952 453.285 264.116 453.493 264.324C453.701 264.532 453.853 264.776 453.949 265.056C454.045 265.336 454.093 265.632 454.093 265.944V269.712C454.093 269.792 454.065 269.86 454.009 269.916C453.953 269.972 453.885 270 453.805 270H452.833C452.745 270 452.673 269.972 452.617 269.916C452.569 269.86 452.545 269.792 452.545 269.712V269.244C452.441 269.396 452.301 269.54 452.125 269.676C451.949 269.804 451.733 269.912 451.477 270C451.229 270.08 450.933 270.12 450.589 270.12ZM450.997 268.98C451.277 268.98 451.529 268.92 451.753 268.8C451.985 268.68 452.165 268.496 452.293 268.248C452.429 267.992 452.497 267.672 452.497 267.288V267.036L451.297 267.228C450.825 267.3 450.473 267.416 450.241 267.576C450.009 267.736 449.893 267.932 449.893 268.164C449.893 268.34 449.945 268.492 450.049 268.62C450.161 268.74 450.301 268.832 450.469 268.896C450.637 268.952 450.813 268.98 450.997 268.98ZM455.921 270C455.841 270 455.773 269.972 455.717 269.916C455.661 269.86 455.633 269.792 455.633 269.712V264.06C455.633 263.972 455.661 263.9 455.717 263.844C455.773 263.788 455.841 263.76 455.921 263.76H456.893C456.973 263.76 457.041 263.788 457.097 263.844C457.161 263.9 457.193 263.972 457.193 264.06V264.552C457.377 264.296 457.613 264.1 457.901 263.964C458.197 263.828 458.537 263.76 458.921 263.76H459.413C459.501 263.76 459.569 263.788 459.617 263.844C459.673 263.9 459.701 263.968 459.701 264.048V264.912C459.701 264.992 459.673 265.06 459.617 265.116C459.569 265.172 459.501 265.2 459.413 265.2H458.477C458.093 265.2 457.793 265.308 457.577 265.524C457.369 265.74 457.265 266.036 457.265 266.412V269.712C457.265 269.792 457.237 269.86 457.181 269.916C457.125 269.972 457.053 270 456.965 270H455.921ZM463.553 270C463.473 270 463.405 269.972 463.349 269.916C463.293 269.86 463.265 269.792 463.265 269.712V261.9C463.265 261.812 463.293 261.74 463.349 261.684C463.405 261.628 463.473 261.6 463.553 261.6H466.661C467.629 261.6 468.393 261.824 468.953 262.272C469.513 262.72 469.793 263.372 469.793 264.228C469.793 264.82 469.645 265.312 469.349 265.704C469.061 266.096 468.673 266.38 468.185 266.556L469.937 269.616C469.961 269.664 469.973 269.708 469.973 269.748C469.973 269.82 469.945 269.88 469.889 269.928C469.841 269.976 469.785 270 469.721 270H468.629C468.493 270 468.389 269.964 468.317 269.892C468.245 269.82 468.189 269.748 468.149 269.676L466.601 266.832H464.933V269.712C464.933 269.792 464.905 269.86 464.849 269.916C464.801 269.972 464.733 270 464.645 270H463.553ZM464.933 265.476H466.625C467.113 265.476 467.477 265.368 467.717 265.152C467.957 264.928 468.077 264.616 468.077 264.216C468.077 263.816 467.957 263.504 467.717 263.28C467.485 263.048 467.121 262.932 466.625 262.932H464.933V265.476ZM471.483 270C471.403 270 471.335 269.972 471.279 269.916C471.223 269.86 471.195 269.792 471.195 269.712V264.048C471.195 263.968 471.223 263.9 471.279 263.844C471.335 263.788 471.403 263.76 471.483 263.76H472.479C472.567 263.76 472.635 263.788 472.683 263.844C472.739 263.9 472.767 263.968 472.767 264.048V269.712C472.767 269.792 472.739 269.86 472.683 269.916C472.635 269.972 472.567 270 472.479 270H471.483ZM471.435 262.728C471.347 262.728 471.275 262.704 471.219 262.656C471.171 262.6 471.147 262.528 471.147 262.44V261.576C471.147 261.496 471.171 261.428 471.219 261.372C471.275 261.316 471.347 261.288 471.435 261.288H472.527C472.615 261.288 472.687 261.316 472.743 261.372C472.799 261.428 472.827 261.496 472.827 261.576V262.44C472.827 262.528 472.799 262.6 472.743 262.656C472.687 262.704 472.615 262.728 472.527 262.728H471.435ZM477.179 272.64C476.595 272.64 476.115 272.564 475.739 272.412C475.363 272.26 475.067 272.076 474.851 271.86C474.635 271.644 474.479 271.428 474.383 271.212C474.295 271.004 474.247 270.84 474.239 270.72C474.231 270.64 474.255 270.568 474.311 270.504C474.375 270.448 474.447 270.42 474.527 270.42H475.571C475.651 270.42 475.715 270.436 475.763 270.468C475.811 270.508 475.851 270.576 475.883 270.672C475.931 270.776 475.995 270.888 476.075 271.008C476.155 271.128 476.275 271.228 476.435 271.308C476.603 271.396 476.831 271.44 477.119 271.44C477.423 271.44 477.679 271.396 477.887 271.308C478.095 271.22 478.251 271.072 478.355 270.864C478.467 270.656 478.523 270.368 478.523 270V269.184C478.331 269.416 478.083 269.604 477.779 269.748C477.483 269.892 477.115 269.964 476.675 269.964C476.243 269.964 475.871 269.896 475.559 269.76C475.247 269.616 474.987 269.42 474.779 269.172C474.571 268.916 474.411 268.616 474.299 268.272C474.195 267.928 474.135 267.548 474.119 267.132C474.111 266.916 474.111 266.7 474.119 266.484C474.135 266.084 474.195 265.712 474.299 265.368C474.403 265.024 474.559 264.724 474.767 264.468C474.983 264.204 475.247 264 475.559 263.856C475.871 263.712 476.243 263.64 476.675 263.64C477.131 263.64 477.515 263.728 477.827 263.904C478.139 264.072 478.395 264.284 478.595 264.54V264.06C478.595 263.972 478.623 263.9 478.679 263.844C478.735 263.788 478.803 263.76 478.883 263.76H479.855C479.935 263.76 480.003 263.788 480.059 263.844C480.115 263.9 480.143 263.972 480.143 264.06L480.155 269.844C480.155 270.42 480.047 270.916 479.831 271.332C479.615 271.748 479.287 272.068 478.847 272.292C478.415 272.524 477.859 272.64 477.179 272.64ZM477.119 268.692C477.447 268.692 477.711 268.62 477.911 268.476C478.111 268.332 478.259 268.144 478.355 267.912C478.451 267.68 478.507 267.444 478.523 267.204C478.531 267.1 478.535 266.968 478.535 266.808C478.535 266.648 478.531 266.52 478.523 266.424C478.507 266.176 478.451 265.94 478.355 265.716C478.259 265.484 478.111 265.296 477.911 265.152C477.711 265 477.447 264.924 477.119 264.924C476.791 264.924 476.527 265 476.327 265.152C476.127 265.296 475.983 265.488 475.895 265.728C475.815 265.968 475.767 266.232 475.751 266.52C475.735 266.712 475.735 266.908 475.751 267.108C475.767 267.388 475.815 267.652 475.895 267.9C475.983 268.14 476.127 268.332 476.327 268.476C476.527 268.62 476.791 268.692 477.119 268.692ZM482.054 270C481.974 270 481.906 269.972 481.85 269.916C481.794 269.86 481.766 269.792 481.766 269.712V261.768C481.766 261.688 481.794 261.62 481.85 261.564C481.906 261.508 481.974 261.48 482.054 261.48H483.122C483.21 261.48 483.278 261.508 483.326 261.564C483.382 261.62 483.41 261.688 483.41 261.768V264.504C483.626 264.248 483.89 264.04 484.202 263.88C484.514 263.72 484.898 263.64 485.354 263.64C485.842 263.64 486.266 263.752 486.626 263.976C486.994 264.192 487.278 264.5 487.478 264.9C487.678 265.3 487.778 265.78 487.778 266.34V269.712C487.778 269.792 487.75 269.86 487.694 269.916C487.638 269.972 487.57 270 487.49 270H486.41C486.33 270 486.262 269.972 486.206 269.916C486.15 269.86 486.122 269.792 486.122 269.712V266.412C486.122 265.948 486.006 265.584 485.774 265.32C485.55 265.056 485.222 264.924 484.79 264.924C484.374 264.924 484.038 265.056 483.782 265.32C483.534 265.584 483.41 265.948 483.41 266.412V269.712C483.41 269.792 483.382 269.86 483.326 269.916C483.278 269.972 483.21 270 483.122 270H482.054ZM492.05 270C491.57 270 491.166 269.916 490.838 269.748C490.51 269.58 490.266 269.332 490.106 269.004C489.946 268.668 489.866 268.252 489.866 267.756V265.032H488.918C488.838 265.032 488.77 265.004 488.714 264.948C488.658 264.892 488.63 264.824 488.63 264.744V264.048C488.63 263.968 488.658 263.9 488.714 263.844C488.77 263.788 488.838 263.76 488.918 263.76H489.866V261.768C489.866 261.688 489.89 261.62 489.938 261.564C489.994 261.508 490.066 261.48 490.154 261.48H491.126C491.206 261.48 491.274 261.508 491.33 261.564C491.386 261.62 491.414 261.688 491.414 261.768V263.76H492.914C492.994 263.76 493.062 263.788 493.118 263.844C493.174 263.9 493.202 263.968 493.202 264.048V264.744C493.202 264.824 493.174 264.892 493.118 264.948C493.062 265.004 492.994 265.032 492.914 265.032H491.414V267.636C491.414 267.964 491.47 268.22 491.582 268.404C491.702 268.588 491.906 268.68 492.194 268.68H493.022C493.102 268.68 493.17 268.708 493.226 268.764C493.282 268.82 493.31 268.888 493.31 268.968V269.712C493.31 269.792 493.282 269.86 493.226 269.916C493.17 269.972 493.102 270 493.022 270H492.05ZM500.177 270.12C499.433 270.12 498.809 270.012 498.305 269.796C497.809 269.572 497.429 269.284 497.165 268.932C496.909 268.572 496.773 268.196 496.757 267.804C496.757 267.732 496.781 267.672 496.829 267.624C496.877 267.576 496.937 267.552 497.009 267.552H498.077C498.181 267.552 498.257 267.576 498.305 267.624C498.361 267.664 498.409 267.716 498.449 267.78C498.497 267.932 498.589 268.084 498.725 268.236C498.861 268.38 499.045 268.5 499.277 268.596C499.517 268.692 499.817 268.74 500.177 268.74C500.753 268.74 501.181 268.644 501.461 268.452C501.749 268.26 501.893 268 501.893 267.672C501.893 267.44 501.817 267.256 501.665 267.12C501.513 266.976 501.277 266.848 500.957 266.736C500.645 266.616 500.229 266.492 499.709 266.364C499.109 266.22 498.605 266.048 498.197 265.848C497.797 265.64 497.493 265.38 497.285 265.068C497.085 264.756 496.985 264.36 496.985 263.88C496.985 263.416 497.109 263.004 497.357 262.644C497.613 262.284 497.973 262 498.437 261.792C498.909 261.584 499.469 261.48 500.117 261.48C500.637 261.48 501.097 261.552 501.497 261.696C501.897 261.832 502.229 262.016 502.493 262.248C502.757 262.472 502.957 262.716 503.093 262.98C503.237 263.236 503.313 263.488 503.321 263.736C503.321 263.8 503.297 263.86 503.249 263.916C503.209 263.964 503.149 263.988 503.069 263.988H501.953C501.889 263.988 501.825 263.972 501.761 263.94C501.697 263.908 501.645 263.848 501.605 263.76C501.557 263.512 501.401 263.3 501.137 263.124C500.873 262.948 500.533 262.86 500.117 262.86C499.685 262.86 499.337 262.94 499.073 263.1C498.809 263.26 498.677 263.508 498.677 263.844C498.677 264.068 498.741 264.256 498.869 264.408C499.005 264.552 499.217 264.68 499.505 264.792C499.801 264.904 500.189 265.024 500.669 265.152C501.349 265.304 501.905 265.48 502.337 265.68C502.769 265.88 503.085 266.136 503.285 266.448C503.485 266.752 503.585 267.14 503.585 267.612C503.585 268.14 503.441 268.592 503.153 268.968C502.873 269.336 502.477 269.62 501.965 269.82C501.453 270.02 500.857 270.12 500.177 270.12ZM507.504 270.12C506.616 270.12 505.912 269.864 505.392 269.352C504.872 268.84 504.592 268.112 504.552 267.168C504.544 267.088 504.54 266.988 504.54 266.868C504.54 266.74 504.544 266.64 504.552 266.568C504.584 265.968 504.72 265.448 504.96 265.008C505.208 264.568 505.548 264.232 505.98 264C506.412 263.76 506.92 263.64 507.504 263.64C508.152 263.64 508.696 263.776 509.136 264.048C509.576 264.312 509.908 264.684 510.132 265.164C510.356 265.636 510.468 266.184 510.468 266.808V267.06C510.468 267.14 510.44 267.208 510.384 267.264C510.328 267.32 510.256 267.348 510.168 267.348H506.184C506.184 267.348 506.184 267.36 506.184 267.384C506.184 267.408 506.184 267.428 506.184 267.444C506.192 267.724 506.244 267.984 506.34 268.224C506.444 268.456 506.592 268.644 506.784 268.788C506.984 268.932 507.22 269.004 507.492 269.004C507.716 269.004 507.904 268.972 508.056 268.908C508.208 268.836 508.332 268.756 508.428 268.668C508.524 268.58 508.592 268.508 508.632 268.452C508.704 268.356 508.76 268.3 508.8 268.284C508.848 268.26 508.916 268.248 509.004 268.248H510.036C510.116 268.248 510.18 268.272 510.228 268.32C510.284 268.368 510.308 268.428 510.3 268.5C510.292 268.628 510.224 268.784 510.096 268.968C509.976 269.152 509.8 269.332 509.568 269.508C509.336 269.684 509.044 269.832 508.692 269.952C508.348 270.064 507.952 270.12 507.504 270.12ZM506.184 266.34H508.836V266.304C508.836 265.992 508.784 265.72 508.68 265.488C508.576 265.256 508.424 265.072 508.224 264.936C508.024 264.8 507.784 264.732 507.504 264.732C507.224 264.732 506.984 264.8 506.784 264.936C506.584 265.072 506.432 265.256 506.328 265.488C506.232 265.72 506.184 265.992 506.184 266.304V266.34ZM513.554 270.12C513.138 270.12 512.762 270.04 512.426 269.88C512.09 269.712 511.822 269.492 511.622 269.22C511.43 268.94 511.334 268.628 511.334 268.284C511.334 267.724 511.558 267.28 512.006 266.952C512.462 266.616 513.062 266.392 513.806 266.28L515.45 266.04V265.788C515.45 265.452 515.366 265.192 515.198 265.008C515.03 264.824 514.742 264.732 514.334 264.732C514.046 264.732 513.81 264.792 513.626 264.912C513.45 265.024 513.318 265.176 513.23 265.368C513.166 265.472 513.074 265.524 512.954 265.524H512.006C511.918 265.524 511.85 265.5 511.802 265.452C511.762 265.404 511.742 265.34 511.742 265.26C511.75 265.132 511.802 264.976 511.898 264.792C511.994 264.608 512.146 264.432 512.354 264.264C512.562 264.088 512.83 263.94 513.158 263.82C513.486 263.7 513.882 263.64 514.346 263.64C514.85 263.64 515.274 263.704 515.618 263.832C515.97 263.952 516.25 264.116 516.458 264.324C516.666 264.532 516.818 264.776 516.914 265.056C517.01 265.336 517.058 265.632 517.058 265.944V269.712C517.058 269.792 517.03 269.86 516.974 269.916C516.918 269.972 516.85 270 516.77 270H515.798C515.71 270 515.638 269.972 515.582 269.916C515.534 269.86 515.51 269.792 515.51 269.712V269.244C515.406 269.396 515.266 269.54 515.09 269.676C514.914 269.804 514.698 269.912 514.442 270C514.194 270.08 513.898 270.12 513.554 270.12ZM513.962 268.98C514.242 268.98 514.494 268.92 514.718 268.8C514.95 268.68 515.13 268.496 515.258 268.248C515.394 267.992 515.462 267.672 515.462 267.288V267.036L514.262 267.228C513.79 267.3 513.438 267.416 513.206 267.576C512.974 267.736 512.858 267.932 512.858 268.164C512.858 268.34 512.91 268.492 513.014 268.62C513.126 268.74 513.266 268.832 513.434 268.896C513.602 268.952 513.778 268.98 513.962 268.98ZM521.359 270C520.879 270 520.475 269.916 520.147 269.748C519.819 269.58 519.575 269.332 519.415 269.004C519.255 268.668 519.175 268.252 519.175 267.756V265.032H518.227C518.147 265.032 518.079 265.004 518.023 264.948C517.967 264.892 517.939 264.824 517.939 264.744V264.048C517.939 263.968 517.967 263.9 518.023 263.844C518.079 263.788 518.147 263.76 518.227 263.76H519.175V261.768C519.175 261.688 519.199 261.62 519.247 261.564C519.303 261.508 519.375 261.48 519.463 261.48H520.435C520.515 261.48 520.583 261.508 520.639 261.564C520.695 261.62 520.723 261.688 520.723 261.768V263.76H522.223C522.303 263.76 522.371 263.788 522.427 263.844C522.483 263.9 522.511 263.968 522.511 264.048V264.744C522.511 264.824 522.483 264.892 522.427 264.948C522.371 265.004 522.303 265.032 522.223 265.032H520.723V267.636C520.723 267.964 520.779 268.22 520.891 268.404C521.011 268.588 521.215 268.68 521.503 268.68H522.331C522.411 268.68 522.479 268.708 522.535 268.764C522.591 268.82 522.619 268.888 522.619 268.968V269.712C522.619 269.792 522.591 269.86 522.535 269.916C522.479 269.972 522.411 270 522.331 270H521.359Z",
  fill: "#141941"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "CarSpeed_svg__filter0_d_13_9884",
  x: 396.974,
  y: 250,
  width: 144,
  height: 42,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 5
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.313726 0 0 0 0 0.25098 0 0 0 0 1 0 0 0 0.4 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_13_9884"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_13_9884",
  result: "shape"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "CarSpeed_svg__clip0_13_9884"
}, /*#__PURE__*/React.createElement("rect", {
  width: 832.947,
  height: 574,
  fill: "white"
})))));
export default SvgCarSpeed;